import { jsx as r, jsxs as u, Fragment as G } from "react/jsx-runtime";
import se, { forwardRef as st, createElement as Xe, useState as N, useRef as ie, useEffect as J, useCallback as pe, useLayoutEffect as mr, useMemo as le, createContext as ur, useContext as hr } from "react";
import fe from "react-dom";
import { useQueryClient as Eo, useQuery as yr } from "@tanstack/react-query";
function al(e) {
  return `$${e.toFixed(2)}`;
}
function ll(e) {
  return new Date(e).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function sl(e) {
  const t = new Date(e), n = (/* @__PURE__ */ new Date()).getTime() - t.getTime(), i = Math.floor(n / (1e3 * 60 * 60 * 24));
  return i === 0 ? "Today" : i === 1 ? "Yesterday" : i < 7 ? `${i} days ago` : t.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}
function dl(e, t) {
  return t > 0 ? Math.round(e * 100 / t) : 0;
}
function cl(e) {
  return e.toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/--+/g, "-").substring(0, 50);
}
function pl(e) {
  return {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }[e] || 400;
}
function gl(e, t) {
  return e.length <= t ? e : e.slice(0, t - 3) + "...";
}
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const br = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), fr = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, o, n) => n ? n.toUpperCase() : o.toLowerCase()
), ht = (e) => {
  const t = fr(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Ao = (...e) => e.filter((t, o, n) => !!t && t.trim() !== "" && n.indexOf(t) === o).join(" ").trim(), xr = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Cr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kr = st(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: o = 2,
    absoluteStrokeWidth: n,
    className: i = "",
    children: a,
    iconNode: s,
    ...m
  }, p) => Xe(
    "svg",
    {
      ref: p,
      ...Cr,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(o) * 24 / Number(t) : o,
      className: Ao("lucide", i),
      ...!a && !xr(m) && { "aria-hidden": "true" },
      ...m
    },
    [
      ...s.map(([h, d]) => Xe(h, d)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ae = (e, t) => {
  const o = st(
    ({ className: n, ...i }, a) => Xe(kr, {
      ref: a,
      iconNode: t,
      className: Ao(
        `lucide-${br(ht(e))}`,
        `lucide-${e}`,
        n
      ),
      ...i
    })
  );
  return o.displayName = ht(e), o;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vr = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Fe = ae("check", vr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wr = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], dt = ae("chevron-right", wr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sr = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], Br = ae("circle-check-big", Sr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], Ir = ae("circle-x", Fr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zr = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], Pr = ae("ellipsis-vertical", zr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tr = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], Mr = ae("loader", Tr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Er = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], yt = ae("log-out", Er);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ar = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], Wr = ae("maximize-2", Ar);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rr = [
  ["path", { d: "m14 10 7-7", key: "oa77jy" }],
  ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
], Lr = ae("minimize-2", Rr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hr = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], Wo = ae("monitor", Hr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nr = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], bt = ae("palette", Nr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dr = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], Ro = ae("pencil", Dr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Or = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], ct = ae("plus", Or);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jr = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], Gr = ae("rotate-ccw", jr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yr = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], Lo = ae("search", Yr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $r = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Je = ae("settings", $r);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qr = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], Ho = ae("smartphone", Qr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xr = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], No = ae("upload", Xr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jr = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], xe = ae("x", Jr), l = {
  // Primary colors
  primary: "#031425",
  white: "#fff",
  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",
  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",
  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",
  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",
  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",
  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",
  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)"
}, Zr = {
  sm: {
    padding: "6px 14px",
    fontSize: "12px",
    borderRadius: "8px",
    gap: "5px"
  },
  md: {
    padding: "10px 18px",
    fontSize: "13px",
    borderRadius: "10px",
    gap: "6px"
  },
  lg: {
    padding: "12px 24px",
    fontSize: "14px",
    borderRadius: "12px",
    gap: "8px"
  }
}, Ur = {
  sm: {
    padding: "6px",
    fontSize: "12px",
    borderRadius: "8px",
    width: "28px",
    height: "28px"
  },
  md: {
    padding: "8px",
    fontSize: "13px",
    borderRadius: "10px",
    width: "34px",
    height: "34px"
  },
  lg: {
    padding: "10px",
    fontSize: "14px",
    borderRadius: "12px",
    width: "42px",
    height: "42px"
  }
}, Vr = (e, t, o) => {
  switch (e) {
    case "primary":
      return {
        background: o ? l.blue_dark : t ? `linear-gradient(135deg, ${l.blue_dark} 0%, #252b6e 100%)` : `linear-gradient(135deg, ${l.blue_dark} 0%, #1f2463 100%)`,
        color: l.white,
        border: "none",
        boxShadow: t ? "0 4px 14px rgba(24, 29, 86, 0.35)" : "0 2px 8px rgba(24, 29, 86, 0.2)",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "secondary":
      return {
        background: o ? l.gray_border : l.gray_light,
        color: l.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "danger":
      return {
        background: o ? "linear-gradient(135deg, #e63e37 0%, #d13530 100%)" : t ? `linear-gradient(135deg, ${l.red} 0%, #e63e37 100%)` : `linear-gradient(135deg, ${l.red} 0%, #e63e37 100%)`,
        color: l.white,
        border: "none",
        boxShadow: t ? "0 4px 12px rgba(255, 83, 74, 0.35)" : "0 2px 6px rgba(255, 83, 74, 0.25)",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "ghost":
      return {
        background: o ? "rgba(0, 0, 0, 0.08)" : t ? "rgba(0, 0, 0, 0.04)" : "transparent",
        color: l.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "outline":
      return {
        background: o ? l.blue_light : t ? "rgba(24, 29, 86, 0.04)" : l.white,
        color: l.blue_dark,
        border: `2px solid ${l.blue_dark}`,
        boxShadow: "none",
        transform: t && !o ? "translateY(-1px)" : "none"
      };
    case "icon":
      return {
        background: o ? "rgba(0, 0, 0, 0.1)" : t ? "rgba(0, 0, 0, 0.05)" : "transparent",
        color: l.gray_medium,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    default:
      return {};
  }
}, _ = st(
  ({
    variant: e = "primary",
    size: t = "md",
    leftIcon: o,
    rightIcon: n,
    isLoading: i = !1,
    pill: a = !1,
    disabled: s,
    children: m,
    style: p,
    ...h
  }, d) => {
    const [g, f] = N(!1), [w, C] = N(!1), b = s || i, y = e === "icon" ? Ur[t] : Zr[t], k = a ? "200px" : y.borderRadius, P = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      cursor: b ? "not-allowed" : "pointer",
      opacity: b ? 0.5 : 1,
      transition: "all 0.2s ease",
      outline: "none",
      whiteSpace: "nowrap",
      fontFamily: "inherit",
      ...y,
      borderRadius: k,
      ...Vr(
        e,
        !b && g,
        !b && w
      ),
      ...p
    };
    return /* @__PURE__ */ r(
      "button",
      {
        ref: d,
        disabled: b,
        style: P,
        onMouseEnter: () => f(!0),
        onMouseLeave: () => {
          f(!1), C(!1);
        },
        onMouseDown: () => C(!0),
        onMouseUp: () => C(!1),
        ...h,
        children: i ? /* @__PURE__ */ r(qr, { size: t }) : /* @__PURE__ */ u(G, { children: [
          o && /* @__PURE__ */ r(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: o
            }
          ),
          m,
          n && /* @__PURE__ */ r(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: n
            }
          )
        ] })
      }
    );
  }
);
_.displayName = "Button";
const qr = ({ size: e }) => {
  const t = e === "sm" ? 12 : e === "md" ? 14 : 16;
  return /* @__PURE__ */ u(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        animation: "bc-button-spin 1s linear infinite"
      },
      children: [
        /* @__PURE__ */ r("style", { children: `
          @keyframes bc-button-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
        /* @__PURE__ */ r(
          "circle",
          {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeDasharray: "32",
            strokeDashoffset: "12"
          }
        )
      ]
    }
  );
}, Do = () => typeof window > "u" ? !1 : window.self !== window.top, Ye = () => {
  var e, t;
  return typeof window > "u" ? document.body : window.self !== window.top && ((t = (e = window.parent) == null ? void 0 : e.document) != null && t.body) ? window.parent.document.body : document.body;
}, Ze = () => {
  var e;
  return typeof window > "u" ? document : window.self !== window.top && ((e = window.parent) != null && e.document) ? window.parent.document : document;
}, Kr = async () => {
  if (typeof window > "u") return !0;
  try {
    const t = (await fetch(window.location.href, { method: "HEAD" })).headers.get("Content-Security-Policy");
    return !(t != null && t.includes("frame-ancestors 'none'"));
  } catch {
    return !0;
  }
}, _r = () => {
  const [e, t] = N({ x: 0, y: 0 }), [o, n] = N(!1), i = ie({ x: 0, y: 0 }), a = (s) => {
    n(!0), i.current = {
      x: s.clientX - e.x,
      y: s.clientY - e.y
    };
  };
  return J(() => {
    const s = (p) => {
      o && t({
        x: p.clientX - i.current.x,
        y: p.clientY - i.current.y
      });
    }, m = () => {
      n(!1);
    };
    if (o) {
      const p = Ze();
      return p.addEventListener("mousemove", s), p.addEventListener("mouseup", m), () => {
        p.removeEventListener("mousemove", s), p.removeEventListener("mouseup", m);
      };
    }
  }, [o]), { dragOffset: e, isDragging: o, handleMouseDown: a };
}, Ie = ({
  title: e,
  message: t,
  confirmLabel: o = "Save",
  cancelLabel: n = "Discard",
  onConfirm: i,
  onCancel: a,
  isLoading: s = !1
}) => {
  const m = /* @__PURE__ */ u(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        .confirm-dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000010;
        }

        .confirm-dialog-container {
          background: ${l.white};
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          max-width: 400px;
          width: 90%;
          padding: 24px;
        }

        .confirm-dialog-title {
          margin: 0 0 12px;
          font-size: 18px;
          font-weight: 600;
          color: ${l.primary};
        }

        .confirm-dialog-message {
          margin: 0 0 24px;
          font-size: 14px;
          color: ${l.gray_medium};
          line-height: 1.5;
        }

        .confirm-dialog-actions {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
        }
      ` }),
    /* @__PURE__ */ r("div", { className: "confirm-dialog-overlay", onClick: a, children: /* @__PURE__ */ u(
      "div",
      {
        className: "confirm-dialog-container",
        onClick: (p) => p.stopPropagation(),
        children: [
          /* @__PURE__ */ r("h3", { className: "confirm-dialog-title", children: e }),
          /* @__PURE__ */ r("p", { className: "confirm-dialog-message", children: t }),
          /* @__PURE__ */ u("div", { className: "confirm-dialog-actions", children: [
            /* @__PURE__ */ r(
              _,
              {
                variant: "ghost",
                size: "sm",
                onClick: a,
                disabled: s,
                children: n
              }
            ),
            /* @__PURE__ */ r(
              _,
              {
                variant: "primary",
                size: "sm",
                onClick: i,
                isLoading: s,
                disabled: s,
                children: o
              }
            )
          ] })
        ]
      }
    ) })
  ] });
  return fe.createPortal(m, Ye());
}, en = ({ value: e, onChange: t }) => {
  const [o, n] = N(e || "");
  return J(() => {
    n(e || "");
  }, [e]), /* @__PURE__ */ r(
    "input",
    {
      type: "text",
      value: o,
      onChange: (a) => {
        const s = a.target.value;
        n(s), t(s);
      },
      className: "edit-panel-input",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${l.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: l.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: l.white,
        outline: "none"
      }
    }
  );
}, tn = ({
  value: e,
  onChange: t,
  field: o
}) => {
  var n, i;
  return /* @__PURE__ */ r(
    "select",
    {
      value: e ?? ((i = (n = o.options) == null ? void 0 : n[0]) == null ? void 0 : i.value) ?? "",
      onChange: (a) => t(a.target.value),
      className: "edit-panel-select",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${l.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: l.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: l.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px"
      },
      children: (o.options ?? []).map((a) => /* @__PURE__ */ r("option", { value: a.value, children: a.label }, a.value))
    }
  );
};
function $e() {
  return ($e = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var n in o) Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
    }
    return e;
  }).apply(this, arguments);
}
function Oo(e, t) {
  if (e == null) return {};
  var o, n, i = {}, a = Object.keys(e);
  for (n = 0; n < a.length; n++) t.indexOf(o = a[n]) >= 0 || (i[o] = e[o]);
  return i;
}
function Ue(e) {
  var t = ie(e), o = ie(function(n) {
    t.current && t.current(n);
  });
  return t.current = e, o.current;
}
var ze = function(e, t, o) {
  return t === void 0 && (t = 0), o === void 0 && (o = 1), e > o ? o : e < t ? t : e;
}, Be = function(e) {
  return "touches" in e;
}, Ve = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, ft = function(e, t, o) {
  var n = e.getBoundingClientRect(), i = Be(t) ? function(a, s) {
    for (var m = 0; m < a.length; m++) if (a[m].identifier === s) return a[m];
    return a[0];
  }(t.touches, o) : t;
  return { left: ze((i.pageX - (n.left + Ve(e).pageXOffset)) / n.width), top: ze((i.pageY - (n.top + Ve(e).pageYOffset)) / n.height) };
}, xt = function(e) {
  !Be(e) && e.preventDefault();
}, jo = se.memo(function(e) {
  var t = e.onMove, o = e.onKey, n = Oo(e, ["onMove", "onKey"]), i = ie(null), a = Ue(t), s = Ue(o), m = ie(null), p = ie(!1), h = le(function() {
    var w = function(y) {
      xt(y), (Be(y) ? y.touches.length > 0 : y.buttons > 0) && i.current ? a(ft(i.current, y, m.current)) : b(!1);
    }, C = function() {
      return b(!1);
    };
    function b(y) {
      var k = p.current, P = Ve(i.current), x = y ? P.addEventListener : P.removeEventListener;
      x(k ? "touchmove" : "mousemove", w), x(k ? "touchend" : "mouseup", C);
    }
    return [function(y) {
      var k = y.nativeEvent, P = i.current;
      if (P && (xt(k), !function(M, v) {
        return v && !Be(M);
      }(k, p.current) && P)) {
        if (Be(k)) {
          p.current = !0;
          var x = k.changedTouches || [];
          x.length && (m.current = x[0].identifier);
        }
        P.focus(), a(ft(P, k, m.current)), b(!0);
      }
    }, function(y) {
      var k = y.which || y.keyCode;
      k < 37 || k > 40 || (y.preventDefault(), s({ left: k === 39 ? 0.05 : k === 37 ? -0.05 : 0, top: k === 40 ? 0.05 : k === 38 ? -0.05 : 0 }));
    }, b];
  }, [s, a]), d = h[0], g = h[1], f = h[2];
  return J(function() {
    return f;
  }, [f]), se.createElement("div", $e({}, n, { onTouchStart: d, onMouseDown: d, className: "react-colorful__interactive", ref: i, onKeyDown: g, tabIndex: 0, role: "slider" }));
}), pt = function(e) {
  return e.filter(Boolean).join(" ");
}, Go = function(e) {
  var t = e.color, o = e.left, n = e.top, i = n === void 0 ? 0.5 : n, a = pt(["react-colorful__pointer", e.className]);
  return se.createElement("div", { className: a, style: { top: 100 * i + "%", left: 100 * o + "%" } }, se.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, de = function(e, t, o) {
  return t === void 0 && (t = 0), o === void 0 && (o = Math.pow(10, t)), Math.round(o * e) / o;
}, on = function(e) {
  return sn(qe(e));
}, qe = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? de(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? de(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, rn = function(e) {
  return ln(an(e));
}, nn = function(e) {
  var t = e.s, o = e.v, n = e.a, i = (200 - t) * o / 100;
  return { h: de(e.h), s: de(i > 0 && i < 200 ? t * o / 100 / (i <= 100 ? i : 200 - i) * 100 : 0), l: de(i / 2), a: de(n, 2) };
}, Ke = function(e) {
  var t = nn(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, an = function(e) {
  var t = e.h, o = e.s, n = e.v, i = e.a;
  t = t / 360 * 6, o /= 100, n /= 100;
  var a = Math.floor(t), s = n * (1 - o), m = n * (1 - (t - a) * o), p = n * (1 - (1 - t + a) * o), h = a % 6;
  return { r: de(255 * [n, m, s, s, p, n][h]), g: de(255 * [p, n, n, m, s, s][h]), b: de(255 * [s, s, p, n, n, m][h]), a: de(i, 2) };
}, Me = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, ln = function(e) {
  var t = e.r, o = e.g, n = e.b, i = e.a, a = i < 1 ? Me(de(255 * i)) : "";
  return "#" + Me(t) + Me(o) + Me(n) + a;
}, sn = function(e) {
  var t = e.r, o = e.g, n = e.b, i = e.a, a = Math.max(t, o, n), s = a - Math.min(t, o, n), m = s ? a === t ? (o - n) / s : a === o ? 2 + (n - t) / s : 4 + (t - o) / s : 0;
  return { h: de(60 * (m < 0 ? m + 6 : m)), s: de(a ? s / a * 100 : 0), v: de(a / 255 * 100), a: i };
}, dn = se.memo(function(e) {
  var t = e.hue, o = e.onChange, n = pt(["react-colorful__hue", e.className]);
  return se.createElement("div", { className: n }, se.createElement(jo, { onMove: function(i) {
    o({ h: 360 * i.left });
  }, onKey: function(i) {
    o({ h: ze(t + 360 * i.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": de(t), "aria-valuemax": "360", "aria-valuemin": "0" }, se.createElement(Go, { className: "react-colorful__hue-pointer", left: t / 360, color: Ke({ h: t, s: 100, v: 100, a: 1 }) })));
}), cn = se.memo(function(e) {
  var t = e.hsva, o = e.onChange, n = { backgroundColor: Ke({ h: t.h, s: 100, v: 100, a: 1 }) };
  return se.createElement("div", { className: "react-colorful__saturation", style: n }, se.createElement(jo, { onMove: function(i) {
    o({ s: 100 * i.left, v: 100 - 100 * i.top });
  }, onKey: function(i) {
    o({ s: ze(t.s + 100 * i.left, 0, 100), v: ze(t.v - 100 * i.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + de(t.s) + "%, Brightness " + de(t.v) + "%" }, se.createElement(Go, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: Ke(t) })));
}), Yo = function(e, t) {
  if (e === t) return !0;
  for (var o in e) if (e[o] !== t[o]) return !1;
  return !0;
}, pn = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || Yo(qe(e), qe(t));
};
function gn(e, t, o) {
  var n = Ue(o), i = N(function() {
    return e.toHsva(t);
  }), a = i[0], s = i[1], m = ie({ color: t, hsva: a });
  J(function() {
    if (!e.equal(t, m.current.color)) {
      var h = e.toHsva(t);
      m.current = { hsva: h, color: t }, s(h);
    }
  }, [t, e]), J(function() {
    var h;
    Yo(a, m.current.hsva) || e.equal(h = e.fromHsva(a), m.current.color) || (m.current = { hsva: a, color: h }, n(h));
  }, [a, e, n]);
  var p = pe(function(h) {
    s(function(d) {
      return Object.assign({}, d, h);
    });
  }, []);
  return [a, p];
}
var mn = typeof window < "u" ? mr : J, un = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, Ct = /* @__PURE__ */ new Map(), hn = function(e) {
  mn(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !Ct.has(t)) {
      var o = t.createElement("style");
      o.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, Ct.set(t, o);
      var n = un();
      n && o.setAttribute("nonce", n), t.head.appendChild(o);
    }
  }, []);
}, yn = function(e) {
  var t = e.className, o = e.colorModel, n = e.color, i = n === void 0 ? o.defaultColor : n, a = e.onChange, s = Oo(e, ["className", "colorModel", "color", "onChange"]), m = ie(null);
  hn(m);
  var p = gn(o, i, a), h = p[0], d = p[1], g = pt(["react-colorful", t]);
  return se.createElement("div", $e({}, s, { ref: m, className: g }), se.createElement(cn, { hsva: h, onChange: d }), se.createElement(dn, { hue: h.h, onChange: d, className: "react-colorful__last-control" }));
}, bn = { defaultColor: "000", toHsva: on, fromHsva: function(e) {
  return rn({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: pn }, fn = function(e) {
  return se.createElement(yn, $e({}, e, { colorModel: bn }));
};
const kt = (e) => {
  const t = e.startsWith("#") ? e : `#${e}`, o = t.slice(0, 7).padEnd(7, "0"), n = t.slice(7, 9) || "ff", i = parseInt(n, 16), a = Math.round(i / 255 * 100);
  return { hex: o, opacity: a };
}, ke = (e, t) => {
  const o = Math.round(t / 100 * 255).toString(16).padStart(2, "0");
  return `${(e.startsWith("#") ? e : `#${e}`).slice(0, 7)}${o}`;
}, vt = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, $o = ({
  value: e,
  onChange: t,
  className: o
}) => {
  const { hex: n, opacity: i } = kt(
    e || "#000000ff"
  ), [a, s] = N(n), [m, p] = N(i), [h, d] = N(
    i < 100 ? e || "#000000ff" : n
  );
  J(() => {
    const { hex: b, opacity: y } = kt(
      e || "#000000ff"
    );
    s(b), p(y), d(y < 100 ? e || "#000000ff" : b);
  }, [e]);
  const g = (b) => {
    s(b), d(m < 100 ? ke(b, m) : b), t(ke(b, m));
  }, f = (b) => {
    const y = b.target.value;
    d(y);
    const k = vt(y);
    if (k)
      if (k.length === 9) {
        const P = k.slice(0, 7), x = k.slice(7, 9), M = parseInt(x, 16), v = Math.round(M / 255 * 100);
        s(P), p(v), t(k);
      } else
        s(k), t(ke(k, m));
  }, w = () => {
    const b = vt(h);
    if (b)
      if (b.length === 9)
        d(b);
      else {
        const y = ke(b, m);
        d(m < 100 ? y : b);
      }
    else {
      const y = ke(a, m);
      d(m < 100 ? y : a);
    }
  }, C = (b) => {
    const y = parseInt(b.target.value, 10);
    p(y);
    const k = ke(a, y);
    t(k), d(y < 100 ? k : a);
  };
  return /* @__PURE__ */ u("div", { className: `bc-color-picker ${o || ""}`, children: [
    /* @__PURE__ */ r("style", { children: `
        .bc-color-picker {
          width: 200px;
        }

        .bc-color-picker .react-colorful {
          width: 100%;
          height: auto;
        }

        .bc-color-picker .react-colorful__saturation {
          border-radius: 8px;
          height: 150px;
        }

        .bc-color-picker .react-colorful__hue {
          height: 14px;
          border-radius: 7px;
          margin-top: 16px;
        }

        .bc-color-picker .react-colorful__pointer {
          width: 20px;
          height: 20px;
        }

        .bc-color-picker-hex-input {
          width: 100%;
          margin-top: 16px;
          padding: 8px 10px;
          border: 1px solid ${l.border_glass};
          border-radius: 8px;
          font-size: 13px;
          color: ${l.primary};
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          background: ${l.bg_light};
          outline: none;
          box-sizing: border-box;
          text-align: center;
          transition: all 0.15s ease;
        }

        .bc-color-picker-hex-input:focus {
          border-color: ${l.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${l.white};
        }

        .bc-color-picker-opacity-container {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 12px;
        }

        .bc-color-picker-opacity-slider {
          flex: 1;
          height: 14px;
          -webkit-appearance: none;
          appearance: none;
          background: linear-gradient(to right, white 0%, ${a} 100%);
          border-radius: 7px;
          outline: none;
          cursor: pointer;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${l.white};
          border: 2px solid ${l.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: transform 0.1s ease;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }

        .bc-color-picker-opacity-slider::-moz-range-thumb {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${l.white};
          border: 2px solid ${l.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }

        .bc-color-picker-opacity-value {
          min-width: 36px;
          font-size: 12px;
          font-weight: 500;
          color: ${l.gray_medium};
          text-align: right;
          user-select: none;
        }
      ` }),
    /* @__PURE__ */ r(fn, { color: a, onChange: g }),
    /* @__PURE__ */ r(
      "input",
      {
        type: "text",
        value: h,
        onChange: f,
        onBlur: w,
        placeholder: "#000000 or #000000ff",
        className: "bc-color-picker-hex-input",
        maxLength: 9
      }
    ),
    /* @__PURE__ */ u("div", { className: "bc-color-picker-opacity-container", children: [
      /* @__PURE__ */ r(
        "input",
        {
          type: "range",
          min: "0",
          max: "100",
          value: m,
          onChange: C,
          className: "bc-color-picker-opacity-slider",
          style: {
            background: `linear-gradient(to right, white 0%, ${a} 100%)`
          }
        }
      ),
      /* @__PURE__ */ r("span", { className: "bc-color-picker-opacity-value", children: m })
    ] })
  ] });
}, xn = "data:image/png;base64,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", _e = ({
  color: e,
  size: t = 32,
  borderRadius: o = 4,
  className: n,
  style: i
}) => /* @__PURE__ */ u(
  "div",
  {
    className: n,
    style: {
      position: "relative",
      width: t,
      height: t,
      borderRadius: o,
      overflow: "hidden",
      ...i
    },
    children: [
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${xn})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "repeat",
            borderRadius: "inherit"
          }
        }
      ),
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundColor: e,
            display: "block",
            borderRadius: "inherit"
          }
        }
      )
    ]
  }
), Cn = (e) => typeof e == "object" && e !== null && "type" in e && "value" in e && (e.type === "theme" || e.type === "custom"), T = (e) => ({
  type: "theme",
  value: e
}), c = (e) => ({
  type: "custom",
  value: e
}), ve = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, wt = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, kn = ({
  value: e,
  onChange: t,
  field: o,
  themeColors: n,
  openColorPicker: i,
  setOpenColorPicker: a
}) => {
  const m = Cn(e) && e.type === "theme" ? e.value : "", p = le(() => {
    if (!e) return "#000000ff";
    if (typeof e == "string")
      return ve(e);
    if (e.type === "custom")
      return ve(e.value);
    if (e.type === "theme") {
      const S = n[e.value];
      return S ? ve(S) : "#000000ff";
    }
    return "#000000ff";
  }, [e, n]), h = () => "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0"), d = (S) => {
    if (S === "") {
      const H = h();
      t({ type: "custom", value: H });
    } else
      t({ type: "theme", value: S });
  }, g = (S) => {
    t({ type: "custom", value: S });
  }, f = i === o.key, w = p, C = ie(null), b = ie(null), [y, k] = se.useState(!1), P = (S) => {
    const H = ve(S);
    return H.length === 9 && H.slice(7, 9).toLowerCase() === "ff" ? H.slice(0, 7) : H;
  }, [x, M] = N(() => P(w));
  J(() => {
    M(P(p));
  }, [p]);
  const v = (S) => {
    const H = S.target.value;
    M(H);
    const D = wt(H);
    if (D) {
      const E = ve(D);
      g(E);
    }
  }, R = () => {
    const S = wt(x);
    if (!S)
      M(P(w));
    else {
      const H = ve(S);
      M(P(H));
    }
  }, W = 300;
  return J(() => {
    if (f && b.current) {
      const S = b.current.getBoundingClientRect(), D = window.innerHeight - S.bottom, E = S.top;
      k(D < W && E > D);
    }
  }, [f]), J(() => {
    if (!f) return;
    const S = (H) => {
      C.current && !C.current.contains(H.target) && a(null);
    };
    return document.addEventListener("mousedown", S, !0), () => {
      document.removeEventListener("mousedown", S, !0);
    };
  }, [f, a]), /* @__PURE__ */ u(
    "div",
    {
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ u(
          "select",
          {
            value: m,
            onChange: (S) => d(S.target.value),
            className: "edit-panel-select",
            style: {
              flex: 1,
              padding: "12px 14px",
              border: `1px solid ${l.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: l.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: l.white,
              cursor: "pointer",
              maxWidth: "110px",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              paddingRight: "30px"
            },
            children: [
              /* @__PURE__ */ r("option", { value: "", children: "Custom" }),
              Object.keys(n).map((S) => /* @__PURE__ */ r("option", { value: S, children: S }, S))
            ]
          }
        ),
        /* @__PURE__ */ u("div", { ref: C, style: { position: "relative" }, children: [
          /* @__PURE__ */ r(
            "button",
            {
              ref: b,
              type: "button",
              onClick: () => a(f ? null : o.key),
              className: "edit-panel-color-swatch",
              style: {
                width: "42px",
                height: "42px",
                border: `2px solid ${l.border_glass}`,
                borderRadius: "10px",
                cursor: "pointer",
                padding: "3px",
                transition: "all 0.15s ease",
                backgroundColor: l.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              },
              "aria-label": "Open color picker",
              children: /* @__PURE__ */ r(
                _e,
                {
                  color: w,
                  style: { width: "100%", height: "100%" },
                  borderRadius: 6
                }
              )
            }
          ),
          f && /* @__PURE__ */ r(
            "div",
            {
              className: "edit-panel-color-popover",
              style: {
                position: "absolute",
                ...y ? { bottom: "calc(100% + 8px)" } : { top: "calc(100% + 8px)" },
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
                backgroundColor: l.white,
                borderRadius: "12px",
                padding: "12px",
                boxShadow: `0 8px 24px ${l.shadow_medium}, 0 0 0 1px ${l.border_glass}`
              },
              onClick: (S) => S.stopPropagation(),
              children: /* @__PURE__ */ r(
                $o,
                {
                  value: w,
                  onChange: g
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            value: x,
            onChange: v,
            onBlur: R,
            className: "edit-panel-color-text",
            placeholder: "#000000 or #000000ff",
            maxLength: 9,
            style: {
              width: "100px",
              padding: "12px 10px",
              border: `1px solid ${l.border_glass}`,
              borderRadius: "10px",
              fontSize: "12px",
              color: l.primary,
              fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace",
              background: l.white,
              outline: "none",
              transition: "all 0.15s ease",
              cursor: "text"
            },
            onFocus: (S) => S.target.select()
          }
        )
      ]
    }
  );
}, vn = ({
  value: e,
  onChange: t,
  field: o
}) => /* @__PURE__ */ r(
  "input",
  {
    type: "number",
    value: e || 0,
    min: o.min,
    max: o.max,
    step: o.step || 1,
    onChange: (n) => t(parseFloat(n.target.value)),
    className: "edit-panel-input",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${l.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: l.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: l.white,
      outline: "none"
    }
  }
), wn = ({ value: e, onChange: t }) => {
  const o = !!e;
  return /* @__PURE__ */ r(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": o,
      onClick: () => t(!o),
      className: "edit-panel-toggle",
      style: {
        width: "48px",
        height: "28px",
        borderRadius: "14px",
        border: "none",
        padding: "2px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: o ? l.blue : l.gray_light,
        display: "flex",
        alignItems: "center",
        justifyContent: o ? "flex-end" : "flex-start"
      },
      children: /* @__PURE__ */ r(
        "span",
        {
          style: {
            width: "24px",
            height: "24px",
            borderRadius: "12px",
            background: l.white,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
            transition: "all 0.2s ease"
          }
        }
      )
    }
  );
}, Sn = ({
  value: e,
  onChange: t,
  themeFonts: o
}) => /* @__PURE__ */ u(
  "select",
  {
    value: e || "inherit",
    onChange: (n) => t(n.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${l.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: l.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: l.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ r("option", { value: "inherit", children: "Inherit (System Font)" }),
      Object.entries(o).map(([n, i]) => /* @__PURE__ */ r("option", { value: n, children: i.name }, n))
    ]
  }
), Bn = ({
  value: e,
  onChange: t,
  themeIcons: o
}) => /* @__PURE__ */ u(
  "select",
  {
    value: e || "default",
    onChange: (n) => t(n.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${l.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: l.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: l.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ r("option", { value: "default", children: "Default" }),
      Object.entries(o).map(([n, i]) => /* @__PURE__ */ r("option", { value: n, children: i.name }, n))
    ]
  }
);
function St(e, t) {
  if (!e) return !0;
  if (typeof e == "string")
    return !!t[e];
  const { field: o, value: n, operator: i } = e, a = t[o];
  return i === "includes" && n !== void 0 ? typeof a == "string" && a.includes(n) : i === "not_equals" && n !== void 0 ? a !== n : i === "equals" || n !== void 0 ? a === n : !!a;
}
const Qo = ({
  displayName: e,
  fields: t,
  values: o,
  initialValues: n,
  onChange: i,
  onClose: a,
  onReset: s,
  screenPosition: m,
  onSave: p,
  isSaving: h = !1,
  themeColors: d = {},
  themeFonts: g = {},
  themeIcons: f = {}
}) => {
  const { dragOffset: w, isDragging: C, handleMouseDown: b } = _r(), y = ie(null), [k, P] = N(null), [x, M] = N(!1), v = le(() => n ? JSON.stringify(o) !== JSON.stringify(n) : !1, [o, n]), R = () => {
    v ? M(!0) : a();
  }, W = () => {
    M(!1), s && s(), a();
  }, S = async () => {
    p && p(), M(!1);
  };
  J(() => {
    if (!k) return;
    const B = Ze(), A = (I) => {
      const $ = I.target;
      !$.closest(".edit-panel-color-popover") && !$.closest(".edit-panel-color-swatch") && P(null);
    };
    return B.addEventListener("mousedown", A, !0), () => {
      B.removeEventListener("mousedown", A, !0);
    };
  }, [k]), J(() => {
    if (!Do()) return;
    const B = Ze(), A = "edit-panel-styles";
    if (!B.getElementById(A)) {
      const I = B.createElement("style");
      I.id = A, I.textContent = `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `, B.head.appendChild(I);
    }
    return () => {
      const I = B.getElementById(A);
      I && I.remove();
    };
  }, []);
  const H = le(
    () => t.some((B) => B.responsive),
    [t]
  ), [D, E] = N("desktop"), O = le(() => D === "mobile" && H ? t.filter((B) => B.responsive).map(
    (B) => ({
      ...B,
      key: `mobile_${B.key}`,
      label: B.label
      // keep same label
    })
  ).filter((B) => St(B.condition, o)) : t.filter((B) => !B.key.startsWith("mobile_")).filter((B) => St(B.condition, o)), [t, D, H, o]), F = le(() => {
    const B = [], A = {};
    return O.forEach((I) => {
      if (I.group)
        A[I.group] || (A[I.group] = []), A[I.group].push(I);
      else {
        const $ = I.key.match(/^elementStyles\.([^.]+)\./);
        if ($) {
          const Q = $[1];
          A[Q] || (A[Q] = []), A[Q].push(I);
        } else
          B.push(I);
      }
    }), { baseFields: B, groups: A };
  }, [O]), L = (B) => ({
    h1: "H1",
    h2: "H2",
    h3: "H3",
    h4: "H4",
    h5: "H5",
    h6: "H6",
    p: "Paragraph",
    strong: "Bold",
    em: "Italic",
    code: "Code",
    blockquote: "Blockquote",
    ul: "Unordered List",
    ol: "Ordered List",
    li: "List Item",
    table: "Table",
    thead: "Table Header",
    tbody: "Table Body",
    tr: "Table Row",
    th: "Header Cell",
    td: "Table Cell",
    // Product Card Carousel groups
    carousel: "Carousel",
    "Card Container": "Card Container",
    title: "Title",
    price: "Price",
    "Retailer Icons": "Retailer Icons",
    image: "Image"
  })[B] || B, Y = (B) => {
    const A = o[B.key];
    switch (B.type) {
      case "text":
        return /* @__PURE__ */ r(
          en,
          {
            value: A,
            onChange: (I) => i(B.key, I),
            field: B
          }
        );
      case "options":
        return /* @__PURE__ */ r(
          tn,
          {
            value: A,
            onChange: (I) => i(B.key, I),
            field: B
          }
        );
      case "color":
        return /* @__PURE__ */ r(
          kn,
          {
            value: A,
            onChange: (I) => i(B.key, I),
            field: B,
            themeColors: d,
            openColorPicker: k,
            setOpenColorPicker: P
          }
        );
      case "number":
        return /* @__PURE__ */ r(
          vn,
          {
            value: A,
            onChange: (I) => i(B.key, I),
            field: B
          }
        );
      case "toggle":
        return /* @__PURE__ */ r(
          wn,
          {
            value: A,
            onChange: (I) => i(B.key, I),
            field: B
          }
        );
      case "font":
        return /* @__PURE__ */ r(
          Sn,
          {
            value: A,
            onChange: (I) => i(B.key, I),
            field: B,
            themeFonts: g
          }
        );
      case "icon":
        return /* @__PURE__ */ r(
          Bn,
          {
            value: A,
            onChange: (I) => i(B.key, I),
            field: B,
            themeIcons: f
          }
        );
      default:
        return null;
    }
  }, j = /* @__PURE__ */ u(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .edit-panel-close {
          transition: all 0.15s ease;
        }

        .edit-panel-close:hover {
          background-color: ${l.overlay_light};
          color: ${l.primary};
          transform: scale(1.1);
        }

        .edit-panel-input:focus,
        .edit-panel-select:focus {
          border-color: ${l.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
        }

        .edit-panel-input:hover:not(:focus),
        .edit-panel-select:hover:not(:focus) {
          border-color: ${l.gray_border};
        }

        .edit-panel-color-text:focus {
          border-color: ${l.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${l.white};
        }

        .edit-panel-color-swatch:hover {
          border-color: ${l.gray_border};
          transform: scale(1.05);
        }

        /* ColorPicker popover styles are now in the ColorPicker component */

        .drag-handle {
          cursor: ${C ? "grabbing" : "grab"};
          transition: background-color 0.15s ease;
        }

        .drag-handle:hover {
          background-color: ${l.overlay_light};
        }

        .edit-panel-save-button {
          background: linear-gradient(135deg, ${l.blue} 0%, ${l.blue_dark} 100%);
          color: ${l.white};
          border: none;
          padding: 10px 18px;
          border-radius: 10px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.15s ease;
          box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
          letter-spacing: 0.3px;
        }

        .edit-panel-save-button:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
        }

        .edit-panel-save-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .edit-panel-save-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* Custom scrollbar */
        .edit-panel-content::-webkit-scrollbar {
          width: 6px;
        }

        .edit-panel-content::-webkit-scrollbar-track {
          background: transparent;
        }

        .edit-panel-content::-webkit-scrollbar-thumb {
          background: ${l.gray_border};
          border-radius: 3px;
        }

        .edit-panel-content::-webkit-scrollbar-thumb:hover {
          background: ${l.gray_medium};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        ref: y,
        style: {
          position: "fixed",
          top: m.y + w.y,
          left: m.x + w.x,
          background: l.glass_bg_strong,
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: `1px solid ${l.border_subtle}`,
          borderRadius: "20px",
          boxShadow: `
            0 8px 40px ${l.shadow_medium},
            0 20px 60px ${l.shadow_soft},
            0 0 0 1px ${l.border_glass}
          `,
          zIndex: 999999,
          width: "620px",
          maxWidth: "620px",
          maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          animation: "edit-panel-slideIn 0.2s ease-out"
        },
        onClick: (B) => B.stopPropagation(),
        onMouseDown: (B) => B.stopPropagation(),
        children: [
          /* @__PURE__ */ u(
            "div",
            {
              className: "drag-handle",
              onMouseDown: b,
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                borderBottom: `1px solid ${l.border_glass}`,
                borderRadius: "20px 20px 0 0",
                userSelect: "none"
              },
              children: [
                /* @__PURE__ */ u(
                  "div",
                  {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      flex: 1
                    },
                    children: [
                      /* @__PURE__ */ r(
                        "div",
                        {
                          style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "3px",
                            opacity: 0.3
                          },
                          children: [...Array(6)].map((B, A) => /* @__PURE__ */ r(
                            "div",
                            {
                              style: {
                                width: "4px",
                                height: "4px",
                                background: l.gray_medium,
                                borderRadius: "1px"
                              }
                            },
                            A
                          ))
                        }
                      ),
                      /* @__PURE__ */ r(
                        "h3",
                        {
                          style: {
                            fontSize: "13px",
                            fontWeight: 600,
                            color: l.primary,
                            margin: 0,
                            letterSpacing: "0.2px"
                          },
                          children: e || "Edit Properties"
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ u("div", { style: { display: "flex", gap: "8px", alignItems: "center" }, children: [
                  v && s && /* @__PURE__ */ r(
                    _,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: s,
                      disabled: h,
                      "aria-label": "Reset changes",
                      leftIcon: /* @__PURE__ */ r(Gr, { size: 14 }),
                      children: "Reset"
                    }
                  ),
                  v && p && /* @__PURE__ */ r(
                    _,
                    {
                      variant: "primary",
                      size: "sm",
                      onClick: p,
                      disabled: h,
                      isLoading: h,
                      "aria-label": "Save changes",
                      type: "submit",
                      children: "Save"
                    }
                  ),
                  /* @__PURE__ */ r(
                    _,
                    {
                      variant: "icon",
                      size: "md",
                      onClick: R,
                      "aria-label": "Close",
                      children: /* @__PURE__ */ r(xe, { size: 18 })
                    }
                  )
                ] })
              ]
            }
          ),
          H && /* @__PURE__ */ u(
            "div",
            {
              style: {
                display: "flex",
                gap: "0",
                padding: "0 20px",
                borderBottom: `1px solid ${l.border_glass}`
              },
              children: [
                /* @__PURE__ */ u(
                  "button",
                  {
                    onClick: () => E("desktop"),
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "10px 16px",
                      background: "none",
                      border: "none",
                      borderBottom: D === "desktop" ? `2px solid ${l.blue}` : "2px solid transparent",
                      color: D === "desktop" ? l.blue : l.gray_medium,
                      fontSize: "12px",
                      fontWeight: D === "desktop" ? 600 : 500,
                      cursor: "pointer",
                      transition: "all 0.15s ease"
                    },
                    children: [
                      /* @__PURE__ */ r(Wo, { size: 14 }),
                      "Desktop"
                    ]
                  }
                ),
                /* @__PURE__ */ u(
                  "button",
                  {
                    onClick: () => E("mobile"),
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "10px 16px",
                      background: "none",
                      border: "none",
                      borderBottom: D === "mobile" ? `2px solid ${l.blue}` : "2px solid transparent",
                      color: D === "mobile" ? l.blue : l.gray_medium,
                      fontSize: "12px",
                      fontWeight: D === "mobile" ? 600 : 500,
                      cursor: "pointer",
                      transition: "all 0.15s ease"
                    },
                    children: [
                      /* @__PURE__ */ r(Ho, { size: 14 }),
                      "Mobile"
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ r(
            "div",
            {
              className: "edit-panel-content",
              style: {
                padding: "20px 24px 24px",
                overflowY: "auto",
                overflowX: "hidden",
                flex: 1
              },
              children: /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px"
                  },
                  children: [
                    F.baseFields.length > 0 && /* @__PURE__ */ r(
                      "div",
                      {
                        style: {
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "20px"
                        },
                        children: F.baseFields.map((B) => /* @__PURE__ */ u(
                          "div",
                          {
                            style: {
                              minWidth: 0
                            },
                            children: [
                              /* @__PURE__ */ r(
                                "label",
                                {
                                  style: {
                                    display: "block",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: l.gray_medium,
                                    marginBottom: "8px",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px"
                                  },
                                  children: B.label
                                }
                              ),
                              Y(B)
                            ]
                          },
                          B.key
                        ))
                      }
                    ),
                    Object.entries(F.groups).map(
                      ([B, A]) => /* @__PURE__ */ u("div", { children: [
                        /* @__PURE__ */ r(
                          "h4",
                          {
                            style: {
                              fontSize: "12px",
                              fontWeight: 700,
                              color: l.primary,
                              margin: "0 0 16px 0",
                              paddingBottom: "8px",
                              borderBottom: `2px solid ${l.border_glass}`,
                              textTransform: "uppercase",
                              letterSpacing: "0.5px"
                            },
                            children: L(B)
                          }
                        ),
                        /* @__PURE__ */ r(
                          "div",
                          {
                            style: {
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "20px"
                            },
                            children: A.map((I) => /* @__PURE__ */ u(
                              "div",
                              {
                                style: {
                                  minWidth: 0
                                },
                                children: [
                                  /* @__PURE__ */ r(
                                    "label",
                                    {
                                      style: {
                                        display: "block",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: l.gray_medium,
                                        marginBottom: "8px",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px"
                                      },
                                      children: I.label
                                    }
                                  ),
                                  Y(I)
                                ]
                              },
                              I.key
                            ))
                          }
                        )
                      ] }, B)
                    )
                  ]
                }
              )
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ u(G, { children: [
    fe.createPortal(j, Ye()),
    x && /* @__PURE__ */ r(
      Ie,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: S,
        onCancel: W,
        isLoading: h
      }
    )
  ] });
}, me = {
  THEME_ID: "bc_themeId",
  EDIT_MODE: "bc_editMode",
  EDIT_THEME_TOKEN: "bc_editThemeToken"
}, Fn = (e, t, o) => {
  try {
    e ? localStorage.setItem(me.THEME_ID, e) : localStorage.removeItem(me.THEME_ID), localStorage.setItem(me.EDIT_MODE, String(t)), o ? localStorage.setItem(me.EDIT_THEME_TOKEN, o) : localStorage.removeItem(me.EDIT_THEME_TOKEN);
  } catch (n) {
    console.error("Failed to save theme params to localStorage:", n);
  }
}, In = () => {
  try {
    return {
      themeId: localStorage.getItem(me.THEME_ID),
      editMode: localStorage.getItem(me.EDIT_MODE) === "true",
      editThemeToken: localStorage.getItem(me.EDIT_THEME_TOKEN)
    };
  } catch (e) {
    return console.error("Failed to read theme params from localStorage:", e), {
      themeId: null,
      editMode: !1,
      editThemeToken: null
    };
  }
}, zn = () => {
  try {
    localStorage.removeItem(me.THEME_ID), localStorage.removeItem(me.EDIT_MODE), localStorage.removeItem(me.EDIT_THEME_TOKEN);
  } catch (e) {
    console.error("Failed to clear theme params from localStorage:", e);
  }
}, Pn = () => {
  try {
    const e = new URLSearchParams(window.location.search), t = e.get("themeId"), o = e.get("editMode") === "true", n = e.get("editThemeToken");
    t && Fn(t, o, n);
  } catch (e) {
    console.error("Failed to sync URL to storage:", e);
  }
}, Tn = () => {
  try {
    const e = new URL(window.location.href);
    e.searchParams.delete("themeId"), e.searchParams.delete("editMode"), e.searchParams.delete("editThemeToken"), window.history.replaceState({}, "", e.toString());
  } catch (e) {
    console.error("Failed to clear URL params:", e);
  }
}, ml = (e, t, o) => {
  try {
    const n = new URL(window.location.href);
    e ? (n.searchParams.set("themeId", e), n.searchParams.set("editMode", String(t)), o ? n.searchParams.set("editThemeToken", o) : n.searchParams.delete("editThemeToken")) : (n.searchParams.delete("themeId"), n.searchParams.delete("editMode"), n.searchParams.delete("editThemeToken")), window.history.replaceState({}, "", n.toString());
  } catch (n) {
    console.error("Failed to update URL params:", n);
  }
}, Bt = () => {
  const e = new URLSearchParams(window.location.search), t = e.get("themeId"), o = e.get("editMode"), n = e.get("editThemeToken"), i = e.get("origin"), a = In();
  return {
    themeId: t || a.themeId,
    editMode: o === "true" || o === null && a.editMode,
    editThemeToken: n || a.editThemeToken,
    origin: i
  };
}, Pe = () => {
  const [e, t] = N(Bt);
  return J(() => {
    const o = setTimeout(() => {
      const n = Bt();
      t((i) => i.themeId !== n.themeId || i.editMode !== n.editMode || i.editThemeToken !== n.editThemeToken || i.origin !== n.origin ? n : i);
    }, 0);
    return () => clearTimeout(o);
  }, []), e;
}, Xo = () => Pe().editMode, Jo = ur(!1), Mn = ({ children: e }) => /* @__PURE__ */ r(Jo.Provider, { value: !0, children: e }), En = () => hr(Jo), et = "bc-widget-panel-opened", Zo = (e) => {
  const t = new CustomEvent(et, {
    detail: { widgetId: e },
    bubbles: !0
  });
  document.dispatchEvent(t);
}, Uo = (e) => {
  const t = (o) => {
    e(o.detail.widgetId);
  };
  return document.addEventListener(et, t), () => {
    document.removeEventListener(et, t);
  };
}, An = (e, t = 32, o = 4) => {
  const n = window.innerWidth, i = window.innerHeight, a = n < 768, s = e.left, m = n - e.right, p = e.top, h = i - e.bottom, d = t + o, g = s >= d, f = m >= d, w = p >= d, C = h >= d;
  let b = "top-left", y = {};
  return a ? f && w ? (b = "top-right", y = {
    top: e.top - o,
    left: e.right - t + o
  }) : f && C ? (b = "bottom-right", y = {
    top: e.bottom - t + o,
    left: e.right - t + o
  }) : g && w ? (b = "top-left", y = {
    top: e.top - o,
    left: e.left - o
  }) : g && C ? (b = "bottom-left", y = {
    top: e.bottom - t + o,
    left: e.left - o
  }) : (b = "top-right", y = {
    top: e.top + o,
    left: e.right - t - o
  }) : g && w ? (b = "top-left", y = {
    top: e.top - o,
    left: e.left - o
  }) : f && w ? (b = "top-right", y = {
    top: e.top - o,
    left: e.right - t + o
  }) : g && C ? (b = "bottom-left", y = {
    top: e.bottom - t + o,
    left: e.left - o
  }) : f && C ? (b = "bottom-right", y = {
    top: e.bottom - t + o,
    left: e.right - t + o
  }) : (b = "top-left", y = {
    top: e.top + o,
    left: e.left + o
  }), { position: b, style: y };
}, K = ({
  children: e,
  widgetId: t,
  displayName: o,
  editFields: n,
  editValues: i,
  onEditChange: a,
  onSave: s,
  isSaving: m = !1,
  themeColors: p = {},
  themeFonts: h = {},
  themeIcons: d = {},
  triggerMode: g = "hover",
  triggerIcon: f = "pencil",
  triggerPosition: w = "bottom-right",
  triggerLabel: C,
  wrapperStyle: b,
  containerClassName: y
}) => {
  const [k, P] = N(!1), [x, M] = N({ x: 0, y: 0 }), [v, R] = N(null), [W, S] = N(!1), [H, D] = N(
    null
  ), [E, O] = N(!1), [F, L] = N(!1), Y = ie(null), j = ie(null), B = Xo(), A = En(), I = (g === "persistent" || E || F) && !k, $ = pe(() => {
    if (j.current) {
      const Z = j.current.getBoundingClientRect();
      if (g === "persistent") {
        const he = C ? 160 : 28, ne = {};
        w.includes("top") ? ne.top = Z.top + 12 : ne.top = Z.bottom - 32 - 12, w.includes("right") ? ne.left = Z.right - he - 12 : ne.left = Z.left + 12, D(ne);
      } else {
        const { style: ge } = An(Z);
        D(ge);
      }
    }
  }, [g, w]);
  J(() => {
    if (!B || !I) {
      D(null);
      return;
    }
    $();
    const Z = () => $();
    return window.addEventListener("scroll", Z, !0), window.addEventListener("resize", Z), () => {
      window.removeEventListener("scroll", Z, !0), window.removeEventListener("resize", Z);
    };
  }, [B, I, $]);
  const Q = pe(() => v ? JSON.stringify(i) !== JSON.stringify(v) : !1, [i, v]);
  if (J(() => t ? Uo((ge) => {
    ge !== t && k && (Q() ? S(!0) : P(!1));
  }) : void 0, [t, k, Q]), !B || A)
    return /* @__PURE__ */ r(G, { children: e });
  const X = () => {
    if (Y.current) {
      const Z = Y.current.getBoundingClientRect(), ge = window.innerWidth, Se = window.innerHeight, he = 620, ne = 450, ce = 10, mt = Se - Z.bottom, ut = Z.top, pr = ge - Z.left, gr = Z.right;
      let be;
      mt >= ne + ce ? be = Z.bottom + ce : ut >= ne + ce ? be = Z.top - ne - ce : mt >= ut ? be = Math.max(ce, Se - ne - ce) : be = Math.max(ce, Z.top - ne - ce);
      let Ce;
      pr >= he ? Ce = Z.left : gr >= he ? Ce = Z.right - he : Ce = Math.max(
        ce,
        Math.min(ge - he - ce, Z.left)
      ), Ce = Math.max(ce, Math.min(Ce, ge - he - ce)), be = Math.max(ce, Math.min(be, Se - ne - ce)), M({ x: Ce, y: be });
    }
    R({ ...i }), P(!0), t && Zo(t);
  }, U = () => {
    v && Object.keys(v).forEach((Z) => {
      a(Z, v[Z]);
    });
  }, ee = () => {
    s && s(), R({ ...i });
  }, re = () => {
    U(), S(!1), P(!1);
  }, oe = () => {
    ee(), S(!1), P(!1);
  }, q = () => {
    if (!H) return null;
    const Z = g === "persistent", ge = f === "gear" ? Je : Ro, he = Z && C ? (
      // Labeled button for persistent mode (more discoverable)
      /* @__PURE__ */ u(
        "button",
        {
          ref: Y,
          style: {
            position: "fixed",
            top: H.top,
            left: H.left,
            height: 32,
            background: F ? l.blue_light : "rgba(255, 255, 255, 0.92)",
            border: `1px solid ${F ? l.blue : "rgba(0,0,0,0.12)"}`,
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "0 12px 0 8px",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
            transition: "all 0.2s ease",
            transform: F ? "scale(1.03)" : "scale(1)",
            opacity: F ? 1 : 0.85,
            zIndex: 999998,
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            whiteSpace: "nowrap"
          },
          onMouseDown: (ne) => ne.stopPropagation(),
          onClick: (ne) => {
            ne.stopPropagation(), ne.preventDefault(), X();
          },
          onMouseEnter: () => L(!0),
          onMouseLeave: () => L(!1),
          "aria-label": C,
          children: [
            /* @__PURE__ */ r(
              ge,
              {
                size: 14,
                color: F ? l.blue : l.gray_dark
              }
            ),
            /* @__PURE__ */ r(
              "span",
              {
                style: {
                  fontSize: "11px",
                  fontWeight: 600,
                  color: F ? l.blue : l.gray_dark,
                  letterSpacing: "0.2px"
                },
                children: C
              }
            )
          ]
        }
      )
    ) : (
      // Icon-only button (standard for hover mode, compact for persistent without label)
      /* @__PURE__ */ r(
        "button",
        {
          ref: Y,
          style: {
            position: "fixed",
            top: H.top,
            left: H.left,
            width: Z ? 28 : 32,
            height: Z ? 28 : 32,
            background: F ? l.blue_light : Z ? "rgba(255, 255, 255, 0.85)" : l.white,
            border: `1px solid ${F ? l.blue : Z ? "rgba(0,0,0,0.1)" : l.gray_border}`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: Z ? "0 1px 4px rgba(0, 0, 0, 0.1)" : "0 2px 8px rgba(0, 0, 0, 0.15)",
            transition: "background 0.2s, border-color 0.2s, transform 0.2s, opacity 0.2s",
            transform: F ? "scale(1.05)" : "scale(1)",
            opacity: Z && !F ? 0.7 : 1,
            zIndex: 999998,
            padding: 0
          },
          onMouseDown: (ne) => ne.stopPropagation(),
          onClick: (ne) => {
            ne.stopPropagation(), ne.preventDefault(), X();
          },
          onMouseEnter: () => L(!0),
          onMouseLeave: () => L(!1),
          "aria-label": f === "gear" ? "Edit layout" : "Edit widget",
          children: /* @__PURE__ */ r(ge, { size: Z ? 14 : 16, color: l.gray_dark })
        }
      )
    );
    return fe.createPortal(he, document.body);
  };
  return /* @__PURE__ */ u(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        .widget-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        }

        .widget-wrapper.widget-fill-container,
        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-hovered {
          outline: 1px dashed ${l.blue};
        }

        .widget-wrapper.widget-editing {
          outline: 2px dashed ${l.blue};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        ref: j,
        className: `widget-wrapper${g === "persistent" ? " widget-fill-container" : ""}${y ? ` ${y}` : ""}${k ? " widget-editing" : I ? " widget-hovered" : ""}`,
        style: b,
        onMouseEnter: () => O(!0),
        onMouseLeave: () => O(!1),
        children: [
          e,
          k && /* @__PURE__ */ r(
            Qo,
            {
              widgetId: t,
              displayName: o,
              fields: n,
              values: i,
              initialValues: v || void 0,
              onChange: a,
              onClose: () => P(!1),
              onReset: U,
              screenPosition: x,
              onSave: ee,
              isSaving: m,
              themeColors: p,
              themeFonts: h,
              themeIcons: d
            }
          ),
          W && /* @__PURE__ */ r(
            Ie,
            {
              title: "Unsaved Changes",
              message: "You have unsaved changes. Would you like to save them before closing?",
              confirmLabel: "Save",
              cancelLabel: "Discard",
              onConfirm: oe,
              onCancel: re,
              isLoading: m
            }
          )
        ]
      }
    ),
    I && q()
  ] });
};
function Wn() {
  const e = Array.from(
    document.getElementsByTagName("script")
  ).filter((i) => i.hasAttribute("data-api-domain"));
  if (e.length > 0)
    return e[e.length - 1];
  if (document.currentScript)
    return document.currentScript;
  const t = Array.from(document.getElementsByTagName("script")), o = t.find((i) => {
    const a = i.src;
    return a && a.includes("bc-widgets");
  });
  if (o)
    return o;
  const n = t.find((i) => {
    const a = i.src;
    return a && (a.includes("bc-checkout-shop-app") || a.includes("brandclub-checkout-shop-app"));
  });
  return n || (t.length > 0 ? t[t.length - 1] : null);
}
const Vo = (() => {
  const e = Wn();
  if (e != null && e.hasAttribute("data-api-domain")) {
    const o = e.getAttribute("data-api-domain");
    if (o)
      return o.startsWith("http://") || o.startsWith("https://") ? o : `https://${o}`;
  }
  const t = e == null ? void 0 : e.src;
  if (t)
    try {
      return `https://${new URL(t).hostname}`;
    } catch {
    }
  return typeof window < "u" ? (console.warn(
    "[bc-widgets] Could not determine script domain, using window.location.origin as fallback. Consider adding data-api-domain attribute to script tag."
  ), window.location.origin) : "";
})(), ue = `${Vo}/api-rewards`;
Vo.replace(/^https?:\/\//, "");
const qo = {
  // Core colors
  primary: "#181d56",
  secondary: "#ffffff",
  tertiary: "#7e8fa8",
  accent: "#ffffff",
  background: "#ffffff",
  transparent: "#00000000",
  // Text colors
  textPrimary: "#181d56",
  textSecondary: "#181d56",
  textTertiary: "#7e8fa8",
  // Semantic colors
  link: "#5572b7",
  success: "#71c285",
  error: "#ff534a",
  warning: "#ffbd32",
  info: "#5572b7"
}, Rn = Object.keys(qo), Ne = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, Ft = (e) => {
  const t = Ne(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, It = (e) => {
  const t = Ne(e || "#000000");
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, zt = ({
  themeColors: e,
  isExpanded: t,
  onToggle: o,
  isLoading: n,
  isAddingColor: i,
  setIsAddingColor: a,
  newColorKey: s,
  setNewColorKey: m,
  newColorValue: p,
  setNewColorValue: h,
  onAddColor: d,
  onUpdateColor: g,
  onRenameColor: f,
  onDeleteColor: w
}) => {
  const [C, b] = N(null), y = ie({}), [k, P] = N({
    top: 0,
    left: 0,
    openAbove: !1
  }), [x, M] = N(null), [v, R] = N(null), [W, S] = N(null), H = ie({}), [D, E] = N({
    top: 0,
    left: 0
  }), O = 300;
  J(() => {
    if (C && y.current[C]) {
      const I = y.current[C].getBoundingClientRect(), Q = window.innerHeight - I.bottom, X = I.top, U = Q < O && X > Q;
      P({
        top: U ? I.top - 8 : I.bottom + 8,
        left: I.left + I.width / 2,
        openAbove: U
      });
    }
  }, [C]), J(() => {
    if (!C) return;
    const I = ($) => {
      const Q = $.target;
      !Q.closest(".bc-theme-color-popover") && !Q.closest(".bc-theme-color-swatch") && b(null);
    };
    return document.addEventListener("mousedown", I), () => {
      document.removeEventListener("mousedown", I);
    };
  }, [C]), J(() => {
    if (W && H.current[W]) {
      const I = H.current[W].getBoundingClientRect();
      E({
        top: I.bottom + 4,
        left: I.right
      });
    }
  }, [W]), J(() => {
    if (!W) return;
    const I = ($) => {
      const Q = $.target;
      !Q.closest(".bc-theme-color-dropdown") && !Q.closest(".bc-theme-color-menu-btn") && S(null);
    };
    return document.addEventListener("mousedown", I), () => {
      document.removeEventListener("mousedown", I);
    };
  }, [W]);
  const F = (I, $) => {
    M(I), R({ name: I, value: Ne($) }), S(null), b(null);
  }, L = () => {
    M(null), R(null), b(null);
  }, Y = async (I) => {
    if (!v) return;
    const { name: $, value: Q } = v, X = Ft(Q);
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(X))
      return;
    $.trim() && $.trim() !== I && f && await f(I, $.trim());
    const ee = Ft(e[I]);
    if (X !== ee) {
      const re = $.trim() || I;
      await g(re, X);
    }
    M(null), R(null), b(null);
  }, j = (I) => {
    v && R({ ...v, value: I });
  }, B = (I) => {
    v && R({ ...v, name: I });
  }, A = (I, $, Q, X) => {
    const U = C === I, ee = Ne($), re = X && !n;
    return /* @__PURE__ */ u(G, { children: [
      re ? /* @__PURE__ */ r(
        "button",
        {
          ref: (oe) => {
            y.current[I] = oe;
          },
          type: "button",
          onClick: () => b(U ? null : I),
          className: "bc-theme-color-swatch",
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${l.border_glass}`,
            borderRadius: "6px",
            cursor: "pointer",
            padding: "2px",
            transition: "all 0.15s ease",
            backgroundColor: l.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          "aria-label": "Open color picker",
          children: /* @__PURE__ */ r(
            _e,
            {
              color: ee,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ) : /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${l.border_glass}`,
            borderRadius: "6px",
            padding: "2px",
            backgroundColor: l.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: /* @__PURE__ */ r(
            _e,
            {
              color: ee,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ),
      U && re && fe.createPortal(
        /* @__PURE__ */ r(
          "div",
          {
            className: "bc-theme-color-popover",
            style: {
              position: "fixed",
              top: k.top,
              left: k.left,
              transform: k.openAbove ? "translate(-50%, -100%)" : "translateX(-50%)",
              zIndex: 1000002,
              backgroundColor: l.white,
              borderRadius: "12px",
              padding: "12px",
              boxShadow: `0 8px 24px ${l.shadow_medium}, 0 0 0 1px ${l.border_glass}`
            },
            onClick: (oe) => oe.stopPropagation(),
            children: /* @__PURE__ */ r($o, { value: ee, onChange: Q })
          }
        ),
        document.body
      )
    ] });
  };
  return /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ r("style", { children: `
        .bc-theme-color-swatch:hover:not(:disabled) {
          border-color: ${l.gray_border};
          transform: scale(1.05);
        }
        .bc-theme-color-menu-btn:hover:not(:disabled) {
          background: ${l.gray_light} !important;
        }
        .bc-theme-editor-row-container {
          display: flex;
          flex-direction: column;
        }
      ` }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
      /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
        "Colors",
        /* @__PURE__ */ r("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ r(
        dt,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ r("div", { className: "bc-theme-editor-section-content", children: n && Object.keys(e).length === 0 ? /* @__PURE__ */ r("div", { className: "bc-theme-editor-loading", children: "Loading colors..." }) : /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([I, $]) => {
        const Q = x === I, X = Rn.includes(I), U = W === I, ee = Q && v ? v.name : I, re = It(Q && v ? v.value : $), oe = Q && v ? v.value : $;
        return /* @__PURE__ */ u("div", { className: "bc-theme-editor-row-container", children: [
          /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
            /* @__PURE__ */ r(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: ee,
                onChange: (q) => Q && B(q.target.value),
                readOnly: !Q,
                disabled: n,
                style: { cursor: Q ? "text" : "default" }
              }
            ),
            A(
              I,
              oe,
              j,
              Q
              // only editable when in edit mode
            ),
            Q ? /* @__PURE__ */ r(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: re,
                onChange: (q) => {
                  const Z = q.target.value;
                  v && R({ ...v, value: Z });
                },
                disabled: n,
                placeholder: "#000000 or #000000ff",
                maxLength: 9,
                style: {
                  width: "85px",
                  textAlign: "right",
                  fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace"
                }
              }
            ) : /* @__PURE__ */ r(
              "span",
              {
                className: "bc-theme-editor-color-value",
                style: { cursor: "default" },
                children: re
              }
            ),
            !Q && /* @__PURE__ */ r(
              "button",
              {
                ref: (q) => {
                  H.current[I] = q;
                },
                className: "bc-theme-color-menu-btn",
                onClick: () => S(U ? null : I),
                disabled: n,
                "aria-label": "Color options",
                style: {
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: l.gray_medium,
                  transition: "all 0.15s ease"
                },
                children: /* @__PURE__ */ r(Pr, { size: 16 })
              }
            ),
            U && fe.createPortal(
              /* @__PURE__ */ u(
                "div",
                {
                  className: "bc-theme-color-dropdown",
                  style: {
                    position: "fixed",
                    top: D.top,
                    left: D.left,
                    transform: "translateX(-100%)",
                    zIndex: 1000003,
                    backgroundColor: l.white,
                    borderRadius: "8px",
                    padding: "4px",
                    boxShadow: `0 4px 12px ${l.shadow_medium}, 0 0 0 1px ${l.border_glass}`,
                    minWidth: "100px"
                  },
                  onClick: (q) => q.stopPropagation(),
                  children: [
                    /* @__PURE__ */ r(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => F(I, $),
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: l.primary,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (q) => q.currentTarget.style.background = l.gray_light,
                        onMouseLeave: (q) => q.currentTarget.style.background = "transparent",
                        children: "Edit"
                      }
                    ),
                    /* @__PURE__ */ r(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => {
                          S(null), w(I);
                        },
                        disabled: X,
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: X ? "not-allowed" : "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: X ? l.gray_medium : l.red,
                          opacity: X ? 0.5 : 1,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (q) => {
                          X || (q.currentTarget.style.background = l.gray_light);
                        },
                        onMouseLeave: (q) => q.currentTarget.style.background = "transparent",
                        children: "Delete"
                      }
                    )
                  ]
                }
              ),
              document.body
            )
          ] }),
          Q && /* @__PURE__ */ u(
            "div",
            {
              className: "bc-theme-editor-row-actions",
              style: {
                display: "flex",
                gap: "8px",
                marginTop: "8px",
                marginLeft: "auto",
                justifyContent: "flex-end"
              },
              children: [
                /* @__PURE__ */ r(
                  _,
                  {
                    variant: "primary",
                    size: "sm",
                    leftIcon: /* @__PURE__ */ r(Fe, { size: 12 }),
                    onClick: () => Y(I),
                    disabled: n,
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ r(
                  _,
                  {
                    variant: "secondary",
                    size: "sm",
                    onClick: L,
                    disabled: n,
                    children: "Cancel"
                  }
                )
              ]
            }
          )
        ] }, I);
      }),
      i ? /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            className: "bc-theme-editor-input",
            placeholder: "Color name",
            value: s,
            onChange: (I) => m(I.target.value),
            disabled: n,
            autoFocus: !0
          }
        ),
        A(
          "__new_color__",
          p,
          h,
          !0
          // new color is editable
        ),
        /* @__PURE__ */ r(
          _,
          {
            variant: "primary",
            size: "sm",
            leftIcon: /* @__PURE__ */ r(Fe, { size: 12 }),
            onClick: d,
            disabled: n || !s.trim(),
            children: "Save"
          }
        ),
        /* @__PURE__ */ r(
          _,
          {
            variant: "secondary",
            size: "sm",
            onClick: () => {
              a(!1), m(""), h("#000000ff");
            },
            disabled: n,
            children: "Cancel"
          }
        )
      ] }) : /* @__PURE__ */ r(
        _,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ r(ct, { size: 12 }),
          onClick: () => a(!0),
          disabled: n,
          children: "Add Color"
        }
      )
    ] }) })
  ] });
}, Ln = (e) => {
  const t = {};
  let o = !1;
  for (const [n, i] of Object.entries(e))
    typeof i == "string" && i.startsWith("#") ? (t[n] = { type: "custom", value: i }, o = !0) : t[n] = i;
  return { migrated: t, needsMigration: o };
}, Hn = (e) => {
  const t = {};
  for (const [o, n] of Object.entries(qo))
    o in e || (t[o] = n);
  return t;
}, Ko = (e) => {
  if (!e) return { processedTheme: e, needsUpdate: !1 };
  let t = !1;
  const o = { ...e };
  o.config || (o.config = {});
  const n = o.config.colors || {}, i = Hn(n);
  if (Object.keys(i).length > 0 && (o.config.colors = { ...n, ...i }, t = !0), o.config.widgetConfig) {
    const a = {};
    for (const [s, m] of Object.entries(
      o.config.widgetConfig
    )) {
      const { migrated: p, needsMigration: h } = Ln(
        m
      );
      a[s] = p, h && (t = !0);
    }
    o.config.widgetConfig = a;
  }
  return { processedTheme: o, needsUpdate: t };
}, _o = async (e, t) => {
  try {
    console.log(
      `Theme ${e} needs migration. Will be migrated on next save.`
    );
  } catch (o) {
    console.error(`Failed to migrate theme ${e}:`, o);
  }
}, Nn = async (e) => {
  const t = await fetch(
    `${ue}/brand-app-widget-theme/by-theme-id?appThemeId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch widget theme");
  const o = await t.json(), { processedTheme: n, needsUpdate: i } = Ko(o);
  return i && _o(e, n.config), n;
}, Dn = async (e) => {
  const t = await fetch(
    `${ue}/brand-app-widget-theme/published-by-app-id?appId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch published widget theme");
  const o = await t.json(), { processedTheme: n, needsUpdate: i } = Ko(o);
  return i && (n != null && n.appThemeId) && _o(
    n.appThemeId,
    n.config
  ), n;
}, On = async ({
  themeId: e,
  widgetId: t,
  widgetState: o,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ue}/brand-app-widget-theme/update-widget-config`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        widgetId: t,
        widgetState: o,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let a = "Failed to update widget config";
    try {
      a = (await i.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return i.json();
}, Pt = async ({
  themeId: e,
  colorKey: t,
  colorValue: o,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ue}/brand-app-widget-theme/set-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        colorValue: o,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let a = "Failed to set theme color";
    try {
      a = (await i.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return i.json();
}, jn = async ({
  themeId: e,
  colorKey: t,
  editThemeToken: o
}) => {
  const n = await fetch(
    `${ue}/brand-app-widget-theme/delete-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        editThemeToken: o
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme color";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, Gn = async ({
  themeId: e,
  oldColorKey: t,
  newColorKey: o,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ue}/brand-app-widget-theme/rename-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        oldColorKey: t,
        newColorKey: o,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let a = "Failed to rename theme color";
    try {
      a = (await i.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return i.json();
}, Tt = async ({
  themeId: e,
  fileName: t,
  contentType: o,
  assetType: n,
  editThemeToken: i
}) => {
  const a = await fetch(
    `${ue}/brand-app-widget-theme/generate-asset-upload-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fileName: t,
        contentType: o,
        assetType: n,
        editThemeToken: i
      })
    }
  );
  if (!a.ok) {
    let m = "Failed to generate upload URL";
    try {
      const p = await a.json();
      m = p.errorMessage || p.message || m;
    } catch {
    }
    throw new Error(m);
  }
  const s = await a.json();
  if (s.status === "failed")
    throw new Error(s.errorMessage || "Failed to generate upload URL");
  return {
    signedUploadUrl: s.signedUploadUrl,
    objectPublicUrl: s.objectPublicUrl
  };
}, Mt = async ({
  file: e,
  signedUploadUrl: t
}) => {
  if (!(await fetch(t, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  })).ok)
    throw new Error("Failed to upload file to S3");
}, Yn = async ({
  themeId: e,
  fontKey: t,
  fontValue: o,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ue}/brand-app-widget-theme/set-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        fontValue: o,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let a = "Failed to set theme font";
    try {
      a = (await i.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return i.json();
}, $n = async ({
  themeId: e,
  fontKey: t,
  editThemeToken: o
}) => {
  const n = await fetch(
    `${ue}/brand-app-widget-theme/delete-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        editThemeToken: o
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme font";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, Qn = async ({
  themeId: e,
  iconKey: t,
  iconValue: o,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ue}/brand-app-widget-theme/set-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        iconValue: o,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let a = "Failed to set theme icon";
    try {
      a = (await i.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return i.json();
}, Xn = async ({
  themeId: e,
  iconKey: t,
  editThemeToken: o
}) => {
  const n = await fetch(
    `${ue}/brand-app-widget-theme/delete-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        editThemeToken: o
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme icon";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, De = ["bc-widget-theme"], er = "bc-theme-updated";
let Qe = null, Et = !1;
const Jn = (e) => {
  Qe = e, J(() => {
    if (Et) return;
    Et = !0;
    const t = (o) => {
      var i;
      if (o.origin !== window.location.origin || ((i = o.data) == null ? void 0 : i.type) !== er || !Qe) return;
      const { themeId: n } = o.data.payload;
      Qe.refetchQueries({
        queryKey: [...De, n]
      });
    };
    window.addEventListener("message", t);
  }, []);
}, Te = () => {
  const e = Pe(), t = Eo();
  return Jn(t), yr({
    queryKey: [...De, e.themeId],
    queryFn: async () => {
      if (e.themeId)
        return Nn(e.themeId);
      const o = window.location.hostname;
      return Dn(o);
    },
    staleTime: 5 * 60 * 1e3
    // 5 minutes
  });
}, gt = () => {
  var n;
  const { data: e, isLoading: t, refetch: o } = Te();
  return {
    themeColors: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.colors) || {},
    isLoading: t,
    refreshThemeColors: async () => {
      await o();
    }
  };
}, tr = () => {
  var n;
  const { data: e, isLoading: t, refetch: o } = Te();
  return {
    themeFonts: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.fonts) || {},
    isLoading: t,
    refreshThemeFonts: async () => {
      await o();
    }
  };
}, or = () => {
  var n;
  const { data: e, isLoading: t, refetch: o } = Te();
  return {
    themeIcons: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.icons) || {},
    isLoading: t,
    refreshThemeIcons: async () => {
      await o();
    }
  };
}, Zn = (e, t) => {
  var a, s;
  const { data: o, isLoading: n } = Te(), i = e ? (s = (a = o == null ? void 0 : o.config) == null ? void 0 : a.widgetConfig) == null ? void 0 : s[e] : void 0;
  return {
    ...t,
    ...i,
    isLoading: n
  };
}, tt = (e) => {
  const t = Eo(), o = Pe();
  return { updateWidgetConfig: (a, s) => {
    e && t.setQueryData(
      [...De, o.themeId],
      (m) => {
        var p, h, d;
        return m ? {
          ...m,
          config: {
            ...m == null ? void 0 : m.config,
            widgetConfig: {
              ...(p = m == null ? void 0 : m.config) == null ? void 0 : p.widgetConfig,
              [e]: {
                ...(d = (h = m == null ? void 0 : m.config) == null ? void 0 : h.widgetConfig) == null ? void 0 : d[e],
                [a]: s
              }
            }
          }
        } : {
          config: {
            widgetConfig: {
              [e]: {
                [a]: s
              }
            }
          }
        };
      }
    );
  }, getWidgetState: () => {
    var s, m;
    if (!e) return;
    const a = t.getQueryData([
      ...De,
      o.themeId
    ]);
    return (m = (s = a == null ? void 0 : a.config) == null ? void 0 : s.widgetConfig) == null ? void 0 : m[e];
  } };
}, rr = (e, t, o = "#000000") => e ? typeof e == "string" ? e : e.type === "custom" ? e.value : t[e.value] ?? o : o, Un = (e) => (t, o = "#000000") => rr(t, e, o), ul = () => {
  const { themeColors: e } = gt();
  return pe(
    (o, n = "#000000") => rr(o, e, n),
    [e]
  );
};
function V(e, t, o) {
  const { isLoading: n, ...i } = Zn(
    e,
    t
  ), a = i, [s, m] = N(!1), { themeColors: p } = gt(), { themeFonts: h } = tr(), { themeIcons: d } = or(), g = le(
    () => Un(p),
    [p]
  ), f = Pe(), { updateWidgetConfig: w, getWidgetState: C } = tt(e), b = le(() => {
    const M = {};
    return o.forEach((v) => {
      M[v.key] = v.type, v.responsive && (M[`mobile_${v.key}`] = v.type);
    }), M;
  }, [o]), y = pe(
    (M, v) => {
      const R = b[M];
      let W = v;
      switch (R) {
        case "toggle":
          typeof v == "string" && (W = v === "true");
          break;
        case "number":
          if (typeof v == "string" && v !== "") {
            const S = parseFloat(v);
            isNaN(S) || (W = S);
          }
          break;
        case "options":
          typeof v == "string" && (v === "true" ? W = !0 : v === "false" ? W = !1 : /^\d+$/.test(v) && (W = parseInt(v, 10)));
          break;
      }
      w(M, W);
    },
    [b, w]
  ), k = !!(f.themeId && f.editThemeToken && e), P = pe(async () => {
    if (!f.themeId || !f.editThemeToken || !e) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    m(!0);
    try {
      const M = C() || a;
      await On({
        themeId: f.themeId,
        widgetId: e,
        widgetState: M,
        editThemeToken: f.editThemeToken
      });
    } catch (M) {
      console.error("Failed to save widget config:", M), alert(`Failed to save: ${M.message}`);
    } finally {
      m(!1);
    }
  }, [f, e, C, a]), x = pe(() => {
    const M = { ...a };
    return o.forEach((v) => {
      const R = M[v.key];
      v.type === "options" && (typeof R == "boolean" ? M[v.key] = R ? "true" : "false" : typeof R == "number" && (M[v.key] = String(R)));
    }), M;
  }, [a, o]);
  return {
    state: a,
    isLoading: n,
    isSaving: s,
    handleEditChange: y,
    handleSave: P,
    themeColors: p,
    themeFonts: h,
    themeIcons: d,
    resolveColor: g,
    canSave: k,
    getEditValues: x
  };
}
const we = [
  { label: "Normal", value: "400" },
  { label: "Medium", value: "500" },
  { label: "Semibold", value: "600" },
  { label: "Bold", value: "700" },
  { label: "Extra Bold", value: "800" },
  { label: "Black", value: "900" }
], te = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" },
  { label: "Extra Bold", value: "800" },
  // CSS doesn't have keyword for 800, use numeric
  { label: "Black", value: "900" }
  // CSS doesn't have keyword for 900, use numeric
];
we.slice(
  0,
  4
);
const At = we.slice(1, 4), Vn = we.slice(0, 3), qn = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Kn = {
  // Background
  backgroundColor: c("#ffffff"),
  shadowEnabled: !1,
  shadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
  // Border styling
  borderColor: c("#DCDDDC"),
  borderColorFocus: c("#DCDDDC"),
  borderRadiusSingleLine: 100,
  // pill shape
  borderRadiusMultiLine: 20,
  // rounded
  borderWidth: 1,
  // Submit button
  submitButtonBgColor: T("textPrimary"),
  submitButtonBgColorHover: T("textPrimary"),
  submitButtonIconColor: T("textPrimary"),
  submitButtonSize: 24,
  submitButtonBorderRadius: 14,
  // Action icons (attachment, mic)
  iconColor: T("textPrimary"),
  iconColorHover: T("tertiary"),
  iconSize: 24,
  micActiveColor: T("error"),
  microphoneIcon: "default",
  // Textarea typography
  fontSize: 16,
  fontWeight: "medium",
  fontFamily: "inherit",
  textColor: T("textPrimary"),
  placeholderColor: c("#9CA3AF"),
  // Layout
  paddingX: 12,
  paddingY: 12,
  maxWidth: 768,
  minHeight: 0,
  // Visibility toggles
  showAttachmentButton: !0,
  showMicrophoneButton: !0
}, Wt = [
  // Background
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "shadowEnabled", label: "Shadow", type: "toggle" },
  { key: "shadow", label: "Shadow Value (CSS)", type: "text" },
  // Border styling group
  { key: "borderColor", label: "Border Color", type: "color" },
  { key: "borderColorFocus", label: "Border Color (Focus)", type: "color" },
  {
    key: "borderRadiusSingleLine",
    label: "Border Radius (Single Line)",
    type: "number",
    min: 0,
    max: 100,
    step: 1
  },
  {
    key: "borderRadiusMultiLine",
    label: "Border Radius (Multi Line)",
    type: "number",
    min: 0,
    max: 50,
    step: 1
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 1
  },
  // Submit button group
  { key: "submitButtonBgColor", label: "Submit Button Color", type: "color" },
  {
    key: "submitButtonBgColorHover",
    label: "Submit Button Hover Color",
    type: "color"
  },
  {
    key: "submitButtonIconColor",
    label: "Submit Button Icon Color",
    type: "color"
  },
  {
    key: "submitButtonSize",
    label: "Submit Button Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "submitButtonBorderRadius",
    label: "Submit Button Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  // Action icons group
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "iconColorHover", label: "Icon Hover Color", type: "color" },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  { key: "micActiveColor", label: "Mic Active Color", type: "color" },
  { key: "microphoneIcon", label: "Microphone Icon", type: "icon" },
  // Typography group
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: te
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "placeholderColor", label: "Placeholder Color", type: "color" },
  // Layout group
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "minHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 200,
    step: 10
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 1200,
    step: 50
  },
  {
    key: "minHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 300,
    step: 10
  },
  // Visibility toggles
  {
    key: "showAttachmentButton",
    label: "Show Attachment Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  },
  {
    key: "showMicrophoneButton",
    label: "Show Microphone Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  }
], hl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    themeIcons: g,
    resolveColor: f,
    canSave: w,
    getEditValues: C
  } = V(
    t,
    { ...Kn, ...e },
    Wt
  ), b = i.fontFamily, y = b && b !== "inherit" ? d[b] : null, k = y && y.format === "google" ? y.url : null;
  if (J(() => {
    k && qn(k);
  }, [k]), a)
    return /* @__PURE__ */ r(G, {});
  const P = y ? y.format === "system" ? y.url : `"${y.name}", sans-serif` : "inherit", x = y && y.format !== "system" && y.format !== "google", M = `chat-input-${t || "default"}`, v = `
    ${x ? `
      @font-face {
        font-family: "${y.name}";
        src: url("${y.url}") format("${y.format}");
        font-display: swap;
      }
    ` : ""}
    ${P !== "inherit" ? `.${M} { font-family: ${P} !important; }` : ""}
  `.trim(), R = {
    ...i,
    fontFamilyCss: P
  }, W = /* @__PURE__ */ u(G, { children: [
    v && /* @__PURE__ */ r("style", { children: v }),
    n(R, g, f)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Wt,
      editValues: C(),
      onEditChange: m,
      onSave: w ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      themeIcons: g,
      children: W
    }
  );
}, Rt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, _n = {
  // Headings - decreasing sizes with bold weight
  h1: {
    fontSize: 28,
    fontWeight: "700",
    lineHeight: 1.3,
    marginTop: 16,
    marginBottom: 12,
    color: T("textPrimary")
  },
  h2: {
    fontSize: 24,
    fontWeight: "700",
    lineHeight: 1.35,
    marginTop: 14,
    marginBottom: 10,
    color: T("textPrimary")
  },
  h3: {
    fontSize: 20,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 12,
    marginBottom: 8,
    color: T("textPrimary")
  },
  h4: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 10,
    marginBottom: 6
  },
  h5: {
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 8,
    marginBottom: 4
  },
  // Text elements
  p: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 12,
    color: T("textPrimary")
  },
  strong: { fontWeight: "600" },
  em: { fontWeight: "500" },
  code: { fontSize: 14, fontWeight: "500", lineHeight: 1.4 },
  blockquote: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 8,
    marginBottom: 8,
    color: T("textPrimary")
  },
  // Lists
  ul: { marginTop: 8, marginBottom: 12 },
  ol: { marginTop: 8, marginBottom: 12 },
  li: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginBottom: 4,
    color: T("textPrimary")
  },
  // Tables
  table: { fontSize: 14, marginTop: 8, marginBottom: 12 },
  thead: { fontWeight: "600" },
  tbody: { fontWeight: "500" },
  tr: {},
  th: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 1.4,
    color: T("textPrimary")
  },
  td: {
    fontSize: 14,
    fontWeight: "500",
    lineHeight: 1.4,
    color: T("textPrimary")
  }
}, ei = {
  // Background & Colors (defaults for user message, assistant can override via widgetId)
  bgColor: c("#E8F4FD"),
  // blueWhite-like for user
  textColor: T("textPrimary"),
  // Border radius
  borderRadius: 10,
  borderRadiusShort: 100,
  // pill shape for short messages
  // Typography
  fontSize: 16,
  fontWeight: "500",
  fontFamily: "inherit",
  lineHeight: 1.5,
  // Padding
  paddingX: 16,
  paddingY: 12,
  // Layout
  maxWidth: "70%",
  alignment: "left",
  // Short message threshold
  shortMessageThreshold: 50,
  // Element styles with defaults
  elementStyles: _n
}, Ee = (e, t) => {
  const o = `elementStyles.${e}`;
  return [
    {
      key: `${o}.fontFamily`,
      label: `${t} Font`,
      type: "font"
    },
    {
      key: `${o}.fontSize`,
      label: `${t} Font Size`,
      type: "number",
      min: 10,
      max: 48,
      step: 1
    },
    {
      key: `${o}.fontWeight`,
      label: `${t} Font Weight`,
      type: "options",
      options: we
    },
    {
      key: `${o}.color`,
      label: `${t} Color`,
      type: "color"
    },
    {
      key: `${o}.lineHeight`,
      label: `${t} Line Height`,
      type: "number",
      min: 1,
      max: 2.5,
      step: 0.1
    },
    {
      key: `${o}.marginTop`,
      label: `${t} Margin Top`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    },
    {
      key: `${o}.marginBottom`,
      label: `${t} Margin Bottom`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    }
  ];
}, Ae = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell"
}, nr = [
  { key: "bgColor", label: "Background Color", type: "color" },
  { key: "textColor", label: "Text Color", type: "color" },
  {
    key: "borderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "borderRadiusShort",
    label: "Short Msg Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "fontSize",
    label: "Base Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Base Font Weight",
    type: "options",
    options: Vn
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  {
    key: "lineHeight",
    label: "Base Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "paddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "alignment",
    label: "Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Right", value: "right" },
      { label: "Center", value: "center" }
    ]
  }
], ti = ["h1", "h2", "h3"], oi = ["p", "blockquote"], ri = ["li"], ni = ["th", "td"], ii = [
  ...ti.flatMap(
    (e) => Ee(e, Ae[e])
  ),
  ...oi.flatMap(
    (e) => Ee(e, Ae[e])
  ),
  ...ri.flatMap(
    (e) => Ee(e, Ae[e])
  ),
  ...ni.flatMap(
    (e) => Ee(e, Ae[e])
  )
], ai = [...nr, ...ii], li = (e, t, o, n) => {
  if (!t) return "";
  const i = [], a = [], s = /* @__PURE__ */ new Set();
  for (const [m, p] of Object.entries(t)) {
    if (!p) continue;
    const h = [];
    if (p.fontSize !== void 0 && h.push(`font-size: ${p.fontSize}px !important`), p.fontWeight !== void 0 && h.push(`font-weight: ${p.fontWeight} !important`), p.color && p.color !== "inherit") {
      const d = n(p.color);
      h.push(`color: ${d} !important`);
    }
    if (p.lineHeight !== void 0 && h.push(`line-height: ${p.lineHeight} !important`), p.marginTop !== void 0 && h.push(`margin-top: ${p.marginTop}px !important`), p.marginBottom !== void 0 && h.push(`margin-bottom: ${p.marginBottom}px !important`), p.fontFamily && p.fontFamily !== "inherit") {
      const d = o[p.fontFamily];
      d && (d.format === "system" ? h.push(`font-family: ${d.url} !important`) : (h.push(
        `font-family: "${d.name}", sans-serif !important`
      ), d.format !== "google" && !s.has(d.name) && (a.push(`
              @font-face {
                font-family: "${d.name}";
                src: url("${d.url}") format("${d.format}");
                font-display: swap;
              }
            `), s.add(d.name))));
    }
    h.length > 0 && i.push(`#concierge-mount .${e} .message-content ${m},
#concierge-mount .${e} .message-content .message-markdown ${m},
.${e} .message-content ${m},
.${e} .message-content .message-markdown ${m} {
  ${h.join(`;
  `)};
}`);
  }
  return [...a, ...i].join(`

`);
}, si = (e, t, o) => {
  const n = t.split("."), i = { ...e };
  let a = i;
  for (let s = 0; s < n.length - 1; s++) {
    const m = n[s];
    a[m] = { ...a[m] }, a = a[m];
  }
  return a[n[n.length - 1]] = o, i;
}, di = (e) => {
  const t = {};
  for (const [o, n] of Object.entries(e))
    if (o === "elementStyles" && typeof n == "object" && n !== null) {
      for (const [i, a] of Object.entries(
        n
      ))
        if (a && typeof a == "object")
          for (const [s, m] of Object.entries(a))
            t[`elementStyles.${i}.${s}`] = m;
    } else
      t[o] = n;
  return t;
}, yl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    resolveColor: g,
    canSave: f
  } = V(
    t,
    { ...ei, ...e },
    nr
    // Only use base fields for type transformations
  ), w = (E, O) => {
    if (E.includes(".")) {
      const F = si(i, E, O), L = E.split(".")[0];
      m(L, F[L]);
    } else
      m(E, O);
  }, C = le(() => di(i), [i]), b = i.fontFamily, y = b && b !== "inherit" ? d[b] : null, k = y && y.format === "google" ? y.url : null, P = le(() => {
    const E = [];
    if (i.elementStyles) {
      for (const O of Object.values(i.elementStyles))
        if (O != null && O.fontFamily && O.fontFamily !== "inherit") {
          const F = d[O.fontFamily];
          (F == null ? void 0 : F.format) === "google" && F.url && !E.includes(F.url) && E.push(F.url);
        }
    }
    return E;
  }, [i.elementStyles, d]);
  J(() => {
    k && Rt(k);
    for (const E of P)
      Rt(E);
  }, [k, P]);
  const x = `message-bubble-${t || "default"}`, M = le(
    () => li(
      x,
      i.elementStyles,
      d,
      g
    ),
    [x, i.elementStyles, d, g]
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const v = y ? y.format === "system" ? y.url : `"${y.name}", sans-serif` : "inherit", S = [`
    ${y && y.format !== "system" && y.format !== "google" ? `
      @font-face {
        font-family: "${y.name}";
        src: url("${y.url}") format("${y.format}");
        font-display: swap;
      }
    ` : ""}
    ${v !== "inherit" ? `.${x} { font-family: ${v} !important; }` : ""}
  `.trim(), M].filter(Boolean).join(`

`), H = {
    ...i,
    fontFamilyCss: v
  }, D = /* @__PURE__ */ u("div", { className: x, children: [
    S && /* @__PURE__ */ r("style", { children: S }),
    n(H, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: ai,
      editValues: C,
      onEditChange: w,
      onSave: f ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      children: D
    }
  );
}, bl = {
  headings: ["h1", "h2", "h3", "h4", "h5"],
  text: ["p", "strong", "em", "code", "blockquote"],
  lists: ["ul", "ol", "li"],
  tables: ["table", "thead", "tbody", "tr", "th", "td"]
}, ci = {
  // Container
  containerBgColor: c("#e9ecef"),
  containerPaddingX: 16,
  containerPaddingY: 12,
  containerBorderRadius: 18,
  containerBorderRadiusBottomLeft: 5,
  // Dots
  dotColor: c("#999999"),
  dotSize: 8,
  dotSpacing: 2,
  // Animation
  animationDuration: 1.4,
  // Status text
  statusTextColor: c("#666666"),
  statusFontSize: 12,
  statusMarginTop: 8
}, Lt = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "containerBorderRadiusBottomLeft",
    label: "Bottom Left Radius",
    type: "number",
    min: 0,
    max: 20,
    step: 1
  },
  // Dots
  { key: "dotColor", label: "Dot Color", type: "color" },
  {
    key: "dotSize",
    label: "Dot Size",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  },
  {
    key: "dotSpacing",
    label: "Dot Spacing",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  },
  // Animation
  {
    key: "animationDuration",
    label: "Animation Duration (s)",
    type: "number",
    min: 0.5,
    max: 3,
    step: 0.1
  },
  // Status text
  { key: "statusTextColor", label: "Status Text Color", type: "color" },
  {
    key: "statusFontSize",
    label: "Status Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "statusMarginTop",
    label: "Status Margin Top",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  }
], fl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    resolveColor: d,
    canSave: g
  } = V(
    t,
    { ...ci, ...e },
    Lt
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const f = n(i, d);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Lt,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      children: f
    }
  );
}, Ht = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, We = ({ width: e }) => /* @__PURE__ */ r(
  "div",
  {
    style: {
      width: `${e}px`,
      height: "32px",
      borderRadius: "9999px",
      backgroundColor: "#e5e7eb",
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), pi = {
  // Preset
  preset: "inline",
  // Title
  showTitle: !0,
  titleText: "Get expert advice on this product",
  titleFontSize: 20,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  titleColor: c("#181d56"),
  // Title icon & behavior
  showSparkleIcon: !0,
  collapsible: !1,
  // Container
  containerGap: 16,
  containerMarginTop: 16,
  containerMarginBottom: 16,
  containerBgColor: c("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Suggestion pills
  pillPaddingX: 12,
  pillPaddingY: 4,
  pillBorderRadius: 50,
  pillBorderColor: c("#181d56"),
  pillBorderWidth: 1.5,
  pillBgColor: c("#ffffff"),
  pillBgColorHover: c("#f3f4f6"),
  pillTextColor: c("#181d56"),
  pillFontSize: 16,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, gi = {
  inline: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: c("#181d56"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: c("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: c("#181d56"),
    pillBorderWidth: 1.5,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#f3f4f6"),
    pillTextColor: c("#181d56"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  highlighted: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: c("#181d56"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: c("#f6f8fa"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: c("#181d56"),
    pillBorderWidth: 1.5,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#f3f4f6"),
    pillTextColor: c("#181d56"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  accordion: {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: c("#181d56"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: c("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: c("#181d56"),
    pillBorderWidth: 1.5,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#f3f4f6"),
    pillTextColor: c("#181d56"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  "accordion-highlighted": {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: c("#181d56"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: c("#f6f8fa"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: c("#181d56"),
    pillBorderWidth: 1.5,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#f3f4f6"),
    pillTextColor: c("#181d56"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  }
}, mi = [
  { label: "Inline Pills (V1)", value: "inline" },
  { label: "Highlighted (V2)", value: "highlighted" },
  { label: "Accordion (V3)", value: "accordion" },
  { label: "Accordion Highlighted (V4)", value: "accordion-highlighted" },
  { label: "Custom", value: "custom" }
], Nt = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: mi
  },
  // Title section
  { key: "showTitle", label: "Show Title", type: "toggle" },
  { key: "showSparkleIcon", label: "Show Sparkle Icon", type: "toggle" },
  { key: "collapsible", label: "Collapsible (Accordion)", type: "toggle" },
  { key: "titleText", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...te]
  },
  { key: "titleFontFamily", label: "Title Font Family", type: "font" },
  { key: "titleColor", label: "Title Color", type: "color" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Title and Pills",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 2,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...te]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], ir = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, ui = ({
  color: e = "currentColor"
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    style: { flexShrink: 0 },
    children: /* @__PURE__ */ r(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6375 8.97842L15.9115 8.19942C13.4152 7.49564 11.4643 5.54472 10.7605 3.04842L9.98148 0.32242C9.90136 0.12736 9.71136 0 9.50048 0C9.2896 0 9.09961 0.12736 9.01948 0.32242L8.24048 3.04842C7.5367 5.54472 5.58578 7.49564 3.08948 8.19942L0.36348 8.97842C0.14841 9.03946 0 9.23586 0 9.45942C0 9.68298 0.14841 9.87938 0.36348 9.94042L3.08948 10.7194C5.58578 11.4232 7.53671 13.3741 8.24048 15.8704L9.01948 18.5964C9.08052 18.8115 9.27692 18.9599 9.50048 18.9599C9.72404 18.9599 9.92044 18.8115 9.98148 18.5964L10.7605 15.8704C11.4642 13.3741 13.4152 11.4232 15.9115 10.7194L18.6375 9.94042C18.8526 9.87938 19.001 9.68298 19.001 9.45942C19.001 9.23586 18.8526 9.03946 18.6375 8.97842Z",
        fill: e
      }
    )
  }
), hi = ({
  expanded: e,
  color: t = "currentColor"
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      flexShrink: 0,
      transition: "transform 0.2s ease",
      transform: e ? "rotate(180deg)" : "rotate(0deg)"
    },
    children: /* @__PURE__ */ r("polyline", { points: "6 9 12 15 18 9" })
  }
), yi = ({ question: e, onClick: t, state: o, resolveColor: n }) => {
  const [i, a] = N(!1);
  return /* @__PURE__ */ r(
    "button",
    {
      onClick: t,
      onMouseEnter: () => a(!0),
      onMouseLeave: () => a(!1),
      style: {
        padding: `${o.pillPaddingY}px ${o.pillPaddingX}px`,
        borderRadius: `${o.pillBorderRadius}px`,
        border: `${o.pillBorderWidth}px solid ${n(o.pillBorderColor)}`,
        backgroundColor: n(i ? o.pillBgColorHover : o.pillBgColor),
        color: n(o.pillTextColor),
        fontSize: `${o.pillFontSize}px`,
        fontWeight: ir[o.pillFontWeight] || 500,
        fontFamily: o.pillFontFamilyCss || "inherit",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        textAlign: "left",
        lineHeight: "32px"
      },
      children: e
    }
  );
}, xl = ({
  widgetId: e = "conversation-starters",
  displayName: t = "Conversation Starters",
  initialState: o = {},
  questions: n,
  isLoading: i = !1,
  onQuestionClick: a
}) => {
  const {
    state: s,
    isLoading: m,
    isSaving: p,
    handleEditChange: h,
    handleSave: d,
    themeColors: g,
    themeFonts: f,
    resolveColor: w,
    canSave: C
  } = V(
    e,
    { ...pi, ...o },
    Nt
  ), [b, y] = N(!1), k = (I, $) => {
    if (I === "preset" && $ !== "custom") {
      const X = gi[$];
      if (X) {
        h("preset", $), Object.entries(X).forEach(([U, ee]) => {
          h(U, ee);
        });
        return;
      }
    }
    h(I, $);
  }, P = s.pillFontFamily, x = P && P !== "inherit" ? f[P] : null, M = s.titleFontFamily, v = M && M !== "inherit" ? f[M] : null, R = x && x.format === "google" ? x.url : null, W = v && v.format === "google" ? v.url : null;
  if (J(() => {
    R && Ht(R);
  }, [R]), J(() => {
    W && Ht(W);
  }, [W]), m || !i && n.length === 0)
    return null;
  const S = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", H = v ? v.format === "system" ? v.url : `"${v.name}", sans-serif` : "inherit", D = x && x.format !== "system" && x.format !== "google", E = v && v.format !== "system" && v.format !== "google", O = `conversation-starters-${e || "default"}`, F = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    ${D ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${E ? `
      @font-face {
        font-family: "${v.name}";
        src: url("${v.url}") format("${v.format}");
        font-display: swap;
      }
    ` : ""}
  `.trim(), L = {
    ...s,
    pillFontFamilyCss: S,
    titleFontFamilyCss: H
  }, Y = s.collapsible ? b : !0, j = w(s.containerBgColor), B = j && j !== "transparent" && j !== "", A = /* @__PURE__ */ u(G, { children: [
    F && /* @__PURE__ */ r("style", { children: F }),
    /* @__PURE__ */ u(
      "div",
      {
        className: O,
        style: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: Y ? `${s.containerGap}px` : "0px",
          marginTop: `${s.containerMarginTop}px`,
          marginBottom: `${s.containerMarginBottom}px`,
          backgroundColor: B ? j : void 0,
          padding: B || s.containerPaddingX || s.containerPaddingY ? `${s.containerPaddingY}px ${s.containerPaddingX}px` : void 0,
          borderRadius: s.containerBorderRadius > 0 ? `${s.containerBorderRadius}px` : void 0
        },
        children: [
          s.showTitle && /* @__PURE__ */ u(
            "h3",
            {
              onClick: s.collapsible ? () => y((I) => !I) : void 0,
              style: {
                fontSize: `${s.titleFontSize}px`,
                fontWeight: ir[s.titleFontWeight] || 600,
                fontFamily: H,
                color: w(s.titleColor),
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: s.collapsible ? "pointer" : void 0,
                userSelect: s.collapsible ? "none" : void 0
              },
              children: [
                s.showSparkleIcon && /* @__PURE__ */ r(ui, { color: w(s.titleColor) }),
                /* @__PURE__ */ r("span", { style: { flex: 1 }, children: s.titleText }),
                s.collapsible && /* @__PURE__ */ r(
                  hi,
                  {
                    expanded: b,
                    color: w(s.titleColor)
                  }
                )
              ]
            }
          ),
          Y && /* @__PURE__ */ r(G, { children: i ? /* @__PURE__ */ u(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start"
              },
              children: [
                /* @__PURE__ */ r(We, { width: 180 }),
                /* @__PURE__ */ r(We, { width: 140 }),
                /* @__PURE__ */ r(We, { width: 200 }),
                /* @__PURE__ */ r(We, { width: 160 })
              ]
            }
          ) : /* @__PURE__ */ r(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start",
                width: "100%"
              },
              children: n.map((I, $) => /* @__PURE__ */ r(
                yi,
                {
                  question: I,
                  onClick: () => a(I),
                  state: L,
                  resolveColor: w
                },
                $
              ))
            }
          ) })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: Nt,
      editValues: s,
      onEditChange: k,
      onSave: C ? d : void 0,
      isSaving: p,
      themeColors: g,
      themeFonts: f,
      children: A
    }
  );
}, bi = {
  // Pill styling (matching Figma design)
  pillBgColor: T("secondary"),
  pillBgColorHover: c("#F6F8FA"),
  pillTextColor: T("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "500",
  pillBorderRadius: 100,
  // Pill shape
  pillPaddingX: 12,
  pillPaddingY: 12,
  // Border styling
  pillBorderWidth: 1,
  pillBorderColor: T("primary"),
  // Selected state styling
  pillBgColorSelected: T("primary"),
  pillTextColorSelected: T("secondary"),
  pillBorderColorSelected: T("primary"),
  // Container
  containerGap: 8,
  maxWidthDesktop: "100%",
  maxWidthMobile: "100%"
}, Dt = [
  // Default state styling
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  // Border styling
  {
    key: "pillBorderWidth",
    label: "Border Width (px)",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Border Color", type: "color" },
  // Selected state styling
  { key: "pillBgColorSelected", label: "Selected Background", type: "color" },
  { key: "pillTextColorSelected", label: "Selected Text Color", type: "color" },
  {
    key: "pillBorderColorSelected",
    label: "Selected Border Color",
    type: "color"
  },
  // Typography
  {
    key: "pillFontSize",
    label: "Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Font Weight",
    type: "options",
    options: we
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "pillPaddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 2,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills (px)",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "maxWidthDesktop",
    label: "Max Width (Desktop)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "maxWidthMobile",
    label: "Max Width (Mobile)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" }
    ]
  }
], Cl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    resolveColor: d,
    canSave: g
  } = V(
    t,
    { ...bi, ...e },
    Dt
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const f = n(i, d);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Dt,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      children: f
    }
  );
}, fi = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, xi = {
  // Background
  backgroundColor: c("transparent"),
  // Title styling
  titleColor: T("textPrimary"),
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  // Icon styling (shared defaults)
  iconColor: T("textPrimary"),
  iconColorHover: T("tertiary"),
  iconSize: 20,
  // Individual icon overrides
  homeIconSize: 22,
  homeIconColor: void 0,
  sidebarIconSize: 20,
  sidebarIconColor: void 0,
  composeIconSize: 18,
  composeIconColor: void 0,
  cartIconSize: 22,
  cartIconColor: void 0,
  // Button styling
  buttonSize: 44,
  buttonBorderRadius: 8,
  buttonHoverBgColor: c("#f3f4f6"),
  // Badge styling (cart count)
  badgeBgColor: T("primary"),
  badgeTextColor: T("secondary"),
  badgeFontSize: 12,
  badgeMinWidth: 18,
  // Layout
  height: 56,
  paddingX: 16,
  paddingY: 8,
  maxWidth: 768
}, Ot = [
  // Layout group
  {
    key: "backgroundColor",
    label: "Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "height",
    label: "Height",
    type: "number",
    min: 40,
    max: 80,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Layout"
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Layout"
  },
  // Title group
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...te],
    group: "Title"
  },
  {
    key: "titleFontFamily",
    label: "Font Family",
    type: "font",
    group: "Title"
  },
  // Home Icon group
  {
    key: "homeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Home Icon"
  },
  {
    key: "homeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Home Icon"
  },
  // Sidebar Icon group
  {
    key: "sidebarIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Sidebar Icon"
  },
  {
    key: "sidebarIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Sidebar Icon"
  },
  // Compose Icon group
  {
    key: "composeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Compose Icon"
  },
  {
    key: "composeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Compose Icon"
  },
  // Cart Icon group
  {
    key: "cartIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Cart Icon"
  },
  {
    key: "cartIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Cart Icon"
  },
  // Shared Icons group (default color applies to all without individual override)
  {
    key: "iconColor",
    label: "Default Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  {
    key: "iconColorHover",
    label: "Hover Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  // Buttons group
  {
    key: "buttonSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Buttons"
  },
  {
    key: "buttonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Buttons"
  },
  {
    key: "buttonHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Buttons"
  },
  // Badge group
  { key: "badgeBgColor", label: "Background", type: "color", group: "Badge" },
  { key: "badgeTextColor", label: "Text Color", type: "color", group: "Badge" },
  {
    key: "badgeFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Badge"
  },
  {
    key: "badgeMinWidth",
    label: "Min Width",
    type: "number",
    min: 14,
    max: 24,
    step: 2,
    group: "Badge"
  }
], kl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    resolveColor: g,
    canSave: f
  } = V(
    t,
    { ...xi, ...e },
    Ot
  ), w = i.titleFontFamily, C = w && w !== "inherit" ? d[w] : null, b = C && C.format === "google" ? C.url : null;
  if (J(() => {
    b && fi(b);
  }, [b]), a)
    return /* @__PURE__ */ r(G, {});
  const y = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", k = C && C.format !== "system" && C.format !== "google", P = `header-${t || "default"}`, x = `
    ${k ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${y !== "inherit" ? `.${P} [data-title-text] { font-family: ${y} !important; }` : ""}
  `.trim(), M = {
    ...i,
    titleFontFamilyCss: y
  }, v = /* @__PURE__ */ u(G, { children: [
    x && /* @__PURE__ */ r("style", { children: x }),
    n(M, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Ot,
      editValues: i,
      onEditChange: m,
      onSave: f ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      children: v
    }
  );
}, Ci = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, jt = {
  // Text content
  titleContent: "CONCIERGE",
  titleFontSize: 14,
  titleFontWeight: "bold",
  titleFontFamily: "inherit",
  titleColor: T("textPrimary"),
  titleLetterSpacing: 2,
  titleTextTransform: "uppercase",
  titleTextAlign: "center",
  titleLineHeight: 1,
  // Button colors - default to textPrimary theme color
  closeButtonColor: T("textPrimary"),
  maximizeButtonColor: T("textPrimary"),
  historyButtonColor: T("textPrimary")
}, Gt = [
  // Text content
  { key: "titleContent", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleLetterSpacing",
    label: "Title Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "titleTextTransform",
    label: "Title Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "titleTextAlign",
    label: "Title Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 0.8,
    max: 2,
    step: 0.1
  },
  // Button colors
  { key: "closeButtonColor", label: "Close Button Color", type: "color" },
  {
    key: "maximizeButtonColor",
    label: "Maximize Button Color",
    type: "color"
  },
  {
    key: "historyButtonColor",
    label: "History Button Color",
    type: "color"
  }
], ki = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 400, vl = ({
  showMaximize: e = !0,
  isMaximized: t = !1,
  onMaximize: o,
  onMinimize: n,
  onClose: i,
  onHistoryClick: a,
  title: s = "CONCIERGE",
  widgetId: m = "concierge-widget-header",
  displayName: p = "Concierge Header",
  initialState: h = {},
  // mobileBrandLogoUrl,
  // showMobileLogo = false,
  bottomContent: d
}) => {
  const {
    state: g,
    isLoading: f,
    isSaving: w,
    handleEditChange: C,
    handleSave: b,
    themeColors: y,
    themeFonts: k,
    resolveColor: P,
    canSave: x
  } = V(
    m,
    {
      ...jt,
      titleContent: (s == null ? void 0 : s.toUpperCase()) || jt.titleContent,
      ...h
    },
    Gt
  ), M = g.titleFontFamily, v = M && M !== "inherit" ? k[M] : null, R = v && v.format === "google" ? v.url : null;
  if (J(() => {
    R && Ci(R);
  }, [R]), f)
    return /* @__PURE__ */ r(
      "div",
      {
        className: "tw:flex tw:items-center tw:justify-between tw:p-4",
        "data-concierge-header": !0
      }
    );
  const W = v ? v.format === "system" ? v.url : `"${v.name}", sans-serif` : "inherit", S = v && v.format !== "system" && v.format !== "google", H = `concierge-header-${m || "default"}`, D = (O) => {
    if (O.startsWith("#")) {
      const F = O.slice(1), L = F.length === 3 ? parseInt(F[0] + F[0], 16) : parseInt(F.slice(0, 2), 16), Y = F.length === 3 ? parseInt(F[1] + F[1], 16) : parseInt(F.slice(2, 4), 16), j = F.length === 3 ? parseInt(F[2] + F[2], 16) : parseInt(F.slice(4, 6), 16);
      return `rgba(${L}, ${Y}, ${j}, 0.7)`;
    }
    return O.startsWith("rgba") ? O.replace(/,\s*[\d.]+\)$/, ", 0.7)") : O.startsWith("rgb") ? O.replace("rgb", "rgba").replace(")", ", 0.7)") : O;
  }, E = /* @__PURE__ */ u(
    "div",
    {
      style: {
        borderBottom: "1px solid #F3F3F3",
        boxShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
        backgroundColor: "#ffffff"
      },
      children: [
        /* @__PURE__ */ r("style", { children: `
        ${S ? `
          @font-face {
            font-family: "${v.name}";
            src: url("${v.url}") format("${v.format}");
            font-display: swap;
          }
        ` : ""}
        ${W !== "inherit" ? `.${H} [data-title-text] { font-family: ${W} !important; }` : ""}
        .${H} .concierge-maximize-icon {
          color: ${P(g.maximizeButtonColor)};
          transition: color 0.2s ease;
        }
        .${H} .concierge-maximize-icon:hover {
          color: ${D(P(g.maximizeButtonColor))};
        }
        .${H} .concierge-close-icon {
          color: ${P(g.closeButtonColor)};
          transition: color 0.2s ease;
        }
        .${H} .concierge-close-icon:hover {
          color: ${D(P(g.closeButtonColor))};
        }
        .${H} .concierge-history-icon {
          color: ${P(g.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${H} .concierge-history-icon:hover {
          color: ${D(P(g.historyButtonColor))};
        }
      ` }),
        /* @__PURE__ */ u(
          "div",
          {
            className: `tw:flex tw:items-center tw:justify-between tw:p-4 ${H}`,
            "data-concierge-header": !0,
            children: [
              /* @__PURE__ */ u(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-1",
                  style: { minWidth: "80px" },
                  children: [
                    t && n && /* @__PURE__ */ r(
                      "button",
                      {
                        onClick: n,
                        className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                        "aria-label": "Minimize to widget",
                        children: /* @__PURE__ */ r(Lr, { className: "tw:w-5 tw:h-5 concierge-maximize-icon" })
                      }
                    ),
                    !t && e && o && /* @__PURE__ */ r(
                      "button",
                      {
                        onClick: o,
                        className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                        "aria-label": "Expand to full view",
                        children: /* @__PURE__ */ r(Wr, { className: "tw:w-5 tw:h-5 concierge-maximize-icon" })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ r(
                "span",
                {
                  "data-title-text": !0,
                  style: {
                    fontSize: `${g.titleFontSize}px`,
                    fontWeight: ki(g.titleFontWeight),
                    fontFamily: W !== "inherit" ? W : void 0,
                    color: P(g.titleColor),
                    letterSpacing: `${g.titleLetterSpacing}px`,
                    textTransform: g.titleTextTransform,
                    textAlign: "center",
                    lineHeight: g.titleLineHeight,
                    flex: 1
                  },
                  children: g.titleContent
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-1 tw:justify-end",
                  style: { minWidth: "80px" },
                  children: /* @__PURE__ */ r(
                    "button",
                    {
                      onClick: i,
                      className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                      "aria-label": "Close",
                      children: /* @__PURE__ */ r(xe, { className: "tw:w-5 tw:h-5 concierge-close-icon" })
                    }
                  )
                }
              )
            ]
          }
        ),
        d
      ]
    }
  );
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: m,
      displayName: p,
      editFields: Gt,
      editValues: g,
      onEditChange: C,
      onSave: x ? b : void 0,
      isSaving: w,
      themeColors: y,
      themeFonts: k,
      children: E
    }
  );
}, vi = {
  // Logo / Brand Icon
  logoIcon: "default",
  logoIconSize: 22,
  expandedLogoMaxHeight: 48,
  expandedLogoMaxWidth: 160,
  // Brand Link
  brandLinkText: "example.com",
  brandLinkPrefix: "Visit ",
  brandLinkFontSize: 14,
  brandLinkColor: T("textPrimary"),
  // Layout
  expandedWidth: 248,
  collapsedWidth: 40,
  expandedBgColor: c("#fcfaf9"),
  collapsedBgColor: c("#ffffff"),
  borderColor: c("#dcdddc"),
  // Navigation Icons
  sidebarIconSize: 20,
  sidebarIconColor: T("textPrimary"),
  composeIconSize: 18,
  composeIconColor: T("textPrimary"),
  closeIconColor: T("textPrimary"),
  // Labels
  openSidebarLabel: "Open sidebar",
  closeSidebarLabel: "Close sidebar",
  newChatLabel: "New chat",
  signOutLabel: "Sign out",
  labelFontSize: 14,
  labelFontWeight: "medium",
  labelColor: T("textPrimary"),
  // Tooltips
  tooltipBgColor: T("textPrimary"),
  tooltipTextColor: c("#ffffff"),
  tooltipFontSize: 12,
  tooltipBorderRadius: 8,
  // Chat History
  chatHistoryTitle: "Chat history",
  chatHistoryTitleFontSize: 14,
  chatHistoryTitleFontWeight: "medium",
  chatHistoryTitleColor: T("textPrimary"),
  chatItemFontSize: 14,
  chatItemFontWeight: "medium",
  chatItemColor: T("textPrimary"),
  chatItemActiveBgColor: c("rgba(220,221,220,0.5)"),
  chatItemHoverBgColor: c("rgba(220,221,220,0.3)"),
  chatItemPaddingX: 8,
  chatItemPaddingY: 4,
  chatItemBorderRadius: 5,
  chatItemLineClamp: 1,
  // Avatar
  avatarSize: 20,
  avatarBgColor: T("textPrimary"),
  avatarTextColor: c("#ffffff"),
  avatarFontSize: 8,
  avatarFontWeight: "semibold"
}, Re = te.slice(0, 4), Yt = [
  // ── Logo / Brand Icon ──────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Icon", type: "icon", group: "Logo" },
  {
    key: "logoIconSize",
    label: "Icon Size (collapsed)",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Logo"
  },
  {
    key: "expandedLogoMaxHeight",
    label: "Expanded Logo Max Height",
    type: "number",
    min: 24,
    max: 80,
    step: 4,
    group: "Logo"
  },
  {
    key: "expandedLogoMaxWidth",
    label: "Expanded Logo Max Width",
    type: "number",
    min: 80,
    max: 200,
    step: 10,
    group: "Logo"
  },
  // ── Brand Link ─────────────────────────────────────────────────────────
  {
    key: "brandLinkText",
    label: "Link Text",
    type: "text",
    group: "Brand Link"
  },
  {
    key: "brandLinkPrefix",
    label: "Prefix Text",
    type: "text",
    group: "Brand Link"
  },
  {
    key: "brandLinkFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Brand Link"
  },
  {
    key: "brandLinkColor",
    label: "Color",
    type: "color",
    group: "Brand Link"
  },
  // ── Layout ─────────────────────────────────────────────────────────────
  {
    key: "expandedWidth",
    label: "Expanded Width",
    type: "number",
    min: 200,
    max: 320,
    step: 4,
    group: "Layout"
  },
  {
    key: "collapsedWidth",
    label: "Collapsed Width",
    type: "number",
    min: 36,
    max: 56,
    step: 2,
    group: "Layout"
  },
  {
    key: "expandedBgColor",
    label: "Expanded Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "collapsedBgColor",
    label: "Collapsed Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "borderColor",
    label: "Border Color",
    type: "color",
    group: "Layout"
  },
  // ── Navigation Icons ───────────────────────────────────────────────────
  {
    key: "sidebarIconSize",
    label: "Sidebar Icon Size",
    type: "number",
    min: 16,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "sidebarIconColor",
    label: "Sidebar Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "composeIconSize",
    label: "Compose Icon Size",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "composeIconColor",
    label: "Compose Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Icons"
  },
  // ── Labels ─────────────────────────────────────────────────────────────
  {
    key: "openSidebarLabel",
    label: "Open Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "closeSidebarLabel",
    label: "Close Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "newChatLabel",
    label: "New Chat Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "signOutLabel",
    label: "Sign Out Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "labelFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Labels"
  },
  {
    key: "labelFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...Re],
    group: "Labels"
  },
  { key: "labelColor", label: "Color", type: "color", group: "Labels" },
  // ── Tooltips ───────────────────────────────────────────────────────────
  {
    key: "tooltipBgColor",
    label: "Background",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipTextColor",
    label: "Text Color",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Tooltips"
  },
  {
    key: "tooltipBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Tooltips"
  },
  // ── Chat History ───────────────────────────────────────────────────────
  {
    key: "chatHistoryTitle",
    label: "Section Title",
    type: "text",
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...Re],
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleColor",
    label: "Title Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemFontSize",
    label: "Item Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemFontWeight",
    label: "Item Font Weight",
    type: "options",
    options: [...Re],
    group: "Chat History"
  },
  {
    key: "chatItemColor",
    label: "Item Text Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemActiveBgColor",
    label: "Active Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemHoverBgColor",
    label: "Hover Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemPaddingX",
    label: "Item Padding X",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemPaddingY",
    label: "Item Padding Y",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemBorderRadius",
    label: "Item Border Radius",
    type: "number",
    min: 0,
    max: 12,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemLineClamp",
    label: "Item Max Lines",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Chat History"
  },
  // ── Avatar ─────────────────────────────────────────────────────────────
  {
    key: "avatarSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Avatar"
  },
  {
    key: "avatarBgColor",
    label: "Background",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarTextColor",
    label: "Text Color",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarFontSize",
    label: "Font Size",
    type: "number",
    min: 6,
    max: 14,
    step: 1,
    group: "Avatar"
  },
  {
    key: "avatarFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...Re],
    group: "Avatar"
  }
], wl = ({
  widgetId: e = "concierge-sidebar",
  displayName: t = "Concierge Sidebar",
  initialState: o = {},
  wrapperStyle: n,
  children: i
}) => {
  const {
    state: a,
    isLoading: s,
    isSaving: m,
    handleEditChange: p,
    handleSave: h,
    themeColors: d,
    themeIcons: g,
    resolveColor: f,
    canSave: w
  } = V(
    e,
    { ...vi, ...o },
    Yt
  ), C = a.logoIcon && a.logoIcon !== "default" ? g[a.logoIcon] : null, b = {
    logoIconUrl: C ? C.url : null
  };
  if (s)
    return /* @__PURE__ */ r(G, {});
  const y = i(a, b, f);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: Yt,
      editValues: a,
      onEditChange: p,
      onSave: w ? h : void 0,
      isSaving: m,
      themeColors: d,
      themeIcons: g,
      wrapperStyle: n,
      children: y
    }
  );
}, wi = {
  filled: {
    backgroundColor: T("primary"),
    backgroundColorHover: T("primary"),
    iconColor: T("secondary"),
    borderWidth: 0,
    borderColor: c("transparent"),
    shadowOpacity: 0.25,
    shadowBlur: 50,
    shadowSpread: -12,
    shadowOffsetY: 25
  },
  light: {
    backgroundColor: c("#f5f5f5"),
    backgroundColorHover: c("#ebebeb"),
    iconColor: T("primary"),
    borderWidth: 0,
    borderColor: c("transparent"),
    shadowOpacity: 0.12,
    shadowBlur: 24,
    shadowSpread: -4,
    shadowOffsetY: 8
  },
  outlined: {
    backgroundColor: c("#ffffff"),
    backgroundColorHover: c("#f5f5f5"),
    iconColor: T("primary"),
    borderWidth: 1.5,
    borderColor: c("#1a1a1a"),
    shadowOpacity: 0,
    shadowBlur: 0,
    shadowSpread: 0,
    shadowOffsetY: 0
  }
}, Si = {
  "rounded-square": { borderRadius: 25 },
  circle: { borderRadius: 50 }
}, Bi = {
  // Preset selectors
  buttonShape: "circle",
  buttonStyle: "filled",
  // Position
  position: "bottom-right",
  horizontalOffset: 20,
  verticalOffset: 20,
  // Size
  size: 44,
  // Colors (using theme colors) — derived from "filled" style
  backgroundColor: T("primary"),
  backgroundColorHover: T("primary"),
  iconColor: T("secondary"),
  // Border — derived from "filled" style
  borderWidth: 0,
  borderColor: c("transparent"),
  // Shape — derived from "circle" shape
  borderRadius: 50,
  // percentage - 50 = circle
  // Shadow — derived from "filled" style
  shadowColor: T("primary"),
  shadowOpacity: 0.25,
  shadowBlur: 50,
  shadowSpread: -12,
  shadowOffsetY: 25,
  // Icon
  iconStyle: "chat-ai",
  iconSize: 22,
  // Animation
  hoverScale: 1.1,
  animationDuration: 200,
  // Suggested Messages
  showSuggestedMessages: !0,
  suggestedMessages: void 0,
  suggestedMessageRotationMs: 4e3,
  // Suggested Pills Styling
  pillBackgroundColor: "#ffffff",
  pillTextColor: "#1f2937",
  pillBorderRadius: 12,
  pillFontSize: 14,
  pillPaddingX: 16,
  pillPaddingY: 10,
  pillShadowOpacity: 0.12,
  pillsToShow: 2,
  // Header Styling
  pillHeaderText: void 0,
  pillHeaderColor: "#6b7280",
  pillHeaderFontSize: 11
}, $t = [
  // --- Preset selectors ---
  {
    key: "iconStyle",
    label: "Icon",
    type: "options",
    options: [
      { label: "Chat AI", value: "chat-ai" },
      { label: "Search Sparkle", value: "search-sparkle" },
      { label: "Three Sparkles", value: "three-sparkles" },
      { label: "Diamond Sparkles", value: "diamond-sparkles" },
      { label: "Search Star", value: "search-star" },
      { label: "Search Sparkle Alt", value: "search-sparkle-alt" }
    ]
  },
  {
    key: "buttonShape",
    label: "Shape",
    type: "options",
    options: [
      { label: "Circle", value: "circle" },
      { label: "Rounded Square", value: "rounded-square" }
    ]
  },
  {
    key: "buttonStyle",
    label: "Style",
    type: "options",
    options: [
      { label: "Filled", value: "filled" },
      { label: "Light", value: "light" },
      { label: "Outlined", value: "outlined" }
    ]
  },
  // --- Size & Position ---
  {
    key: "size",
    label: "Button Size",
    type: "number",
    min: 32,
    max: 72,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Size & Position"
  },
  {
    key: "position",
    label: "Position",
    type: "options",
    options: [
      { label: "Bottom Right", value: "bottom-right" },
      { label: "Bottom Left", value: "bottom-left" },
      { label: "Top Right", value: "top-right" },
      { label: "Top Left", value: "top-left" }
    ],
    group: "Size & Position"
  },
  {
    key: "horizontalOffset",
    label: "Horizontal Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "verticalOffset",
    label: "Vertical Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  // --- Colors ---
  { key: "backgroundColor", label: "Background Color", type: "color", group: "Colors" },
  { key: "backgroundColorHover", label: "Hover Background", type: "color", group: "Colors" },
  { key: "iconColor", label: "Icon Color", type: "color", group: "Colors" },
  // --- Shape ---
  {
    key: "borderRadius",
    label: "Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shape"
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 4,
    step: 0.5,
    group: "Shape"
  },
  { key: "borderColor", label: "Border Color", type: "color", group: "Shape" },
  // --- Shadow ---
  { key: "shadowColor", label: "Shadow Color", type: "color", group: "Shadow" },
  {
    key: "shadowOpacity",
    label: "Shadow Opacity",
    type: "number",
    min: 0,
    max: 1,
    step: 0.05,
    group: "Shadow"
  },
  {
    key: "shadowBlur",
    label: "Shadow Blur",
    type: "number",
    min: 0,
    max: 100,
    step: 5,
    group: "Shadow"
  },
  {
    key: "shadowSpread",
    label: "Shadow Spread",
    type: "number",
    min: -20,
    max: 20,
    step: 2,
    group: "Shadow"
  },
  {
    key: "shadowOffsetY",
    label: "Shadow Offset Y",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shadow"
  },
  // Animation
  {
    key: "hoverScale",
    label: "Hover Scale",
    type: "number",
    min: 1,
    max: 1.3,
    step: 0.05
  },
  {
    key: "animationDuration",
    label: "Animation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  },
  // Suggested Messages
  {
    key: "showSuggestedMessages",
    label: "Show Suggested Messages",
    type: "toggle"
  },
  {
    key: "suggestedMessageRotationMs",
    label: "Message Rotation (ms)",
    type: "number",
    min: 2e3,
    max: 1e4,
    step: 500
  },
  {
    key: "pillsToShow",
    label: "Number of Pills",
    type: "number",
    min: 1,
    max: 4,
    step: 1
  },
  // Pill Styling
  { key: "pillBackgroundColor", label: "Pill Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillShadowOpacity",
    label: "Pill Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  // Header Styling
  {
    key: "pillHeaderText",
    label: "Header Text (Override)",
    type: "text"
  },
  { key: "pillHeaderColor", label: "Header Text Color", type: "color" },
  {
    key: "pillHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 9,
    max: 14,
    step: 1
  }
], Fi = (e) => {
  const { position: t, horizontalOffset: o, verticalOffset: n, size: i } = e, a = {
    position: "fixed",
    zIndex: 2147483647
    // Max z-index to ensure it's on top
  };
  return t.startsWith("bottom") ? a.bottom = n + i - 8 : a.top = n - 8, t.endsWith("left") ? a.left = o + i - 8 : a.right = o - 8, a;
}, Sl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const [i, a] = N(!1), [s, m] = N({ x: 0, y: 0 }), [p, h] = N(null), [d, g] = N(!1), [f, w] = N(!1), C = ie(null), b = Xo(), {
    state: y,
    isLoading: k,
    isSaving: P,
    handleEditChange: x,
    handleSave: M,
    themeColors: v,
    resolveColor: R,
    canSave: W
  } = V(
    t,
    { ...Bi, ...e },
    $t
  ), S = pe(
    (j, B) => {
      if (x(j, B), j === "buttonStyle") {
        const A = wi[B];
        A && Object.entries(A).forEach(([I, $]) => {
          x(I, $);
        });
      }
      if (j === "buttonShape") {
        const A = Si[B];
        A && x("borderRadius", A.borderRadius);
      }
    },
    [x]
  ), H = pe(() => p ? JSON.stringify(y) !== JSON.stringify(p) : !1, [y, p]);
  if (J(() => t ? Uo((B) => {
    B !== t && i && (H() ? g(!0) : a(!1));
  }) : void 0, [t, i, H]), k)
    return /* @__PURE__ */ r(G, {});
  const D = n(y, R);
  if (!b)
    return /* @__PURE__ */ r(G, { children: D });
  const E = () => {
    if (C.current) {
      const j = C.current.getBoundingClientRect(), B = window.innerWidth, A = window.innerHeight, I = 620, $ = 450, Q = 10, X = A - j.bottom, U = j.top, ee = B - j.left, re = j.right;
      let oe;
      X >= $ + Q ? oe = j.bottom + Q : U >= $ + Q ? oe = j.top - $ - Q : X >= U ? oe = Math.max(Q, A - $ - Q) : oe = Math.max(Q, j.top - $ - Q);
      let q;
      ee >= I ? q = j.left : re >= I ? q = j.right - I : q = Math.max(
        Q,
        Math.min(B - I - Q, j.left)
      ), q = Math.max(Q, Math.min(q, B - I - Q)), oe = Math.max(Q, Math.min(oe, A - $ - Q)), m({ x: q, y: oe });
    }
    h({ ...y }), a(!0), t && Zo(t);
  }, O = () => {
    p && Object.keys(p).forEach((j) => {
      S(j, p[j]);
    });
  }, F = () => {
    M && W && M(), h({ ...y });
  }, L = () => {
    g(!1), a(!1);
  }, Y = () => {
    F(), g(!1), a(!1);
  };
  return /* @__PURE__ */ u(G, { children: [
    /* @__PURE__ */ r("style", { children: `
        .floating-button-edit-icon {
          width: 32px;
          height: 32px;
          background: ${l.white};
          border: 1px solid ${l.gray_border};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.2s;
          padding: 0;
          opacity: 0;
          pointer-events: none;
        }

        .floating-button-edit-icon.visible {
          opacity: 1;
          pointer-events: auto;
        }

        .floating-button-edit-icon:hover {
          background: ${l.blue_light};
          border-color: ${l.blue};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        onMouseEnter: () => w(!0),
        onMouseLeave: () => w(!1),
        style: { display: "contents" },
        children: [
          D,
          /* @__PURE__ */ r(
            "button",
            {
              ref: C,
              className: `floating-button-edit-icon ${f || i ? "visible" : ""}`,
              style: Fi(y),
              onMouseDown: (j) => {
                j.stopPropagation();
              },
              onClick: (j) => {
                j.stopPropagation(), j.preventDefault(), E();
              },
              "aria-label": "Edit widget",
              children: /* @__PURE__ */ r(Ro, { size: 16, color: l.gray_dark })
            }
          )
        ]
      }
    ),
    i && /* @__PURE__ */ r(
      Qo,
      {
        widgetId: t,
        displayName: o,
        fields: $t,
        values: y,
        initialValues: p || void 0,
        onChange: S,
        onClose: () => a(!1),
        onReset: O,
        screenPosition: s,
        onSave: F,
        isSaving: P,
        themeColors: v
      }
    ),
    d && /* @__PURE__ */ r(
      Ie,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: Y,
        onCancel: L,
        isLoading: P
      }
    )
  ] });
}, Ii = {
  // Icon container
  iconContainerSize: 80,
  iconContainerBgColor: c("#f6f8fa"),
  iconContainerBorderRadius: 50,
  // Icon
  iconSize: 40,
  iconColor: T("textPrimary"),
  // Title
  titleFontSize: 28,
  titleFontWeight: "semibold",
  titleColor: T("textPrimary"),
  titleMarginBottom: 12,
  // Description
  descriptionFontSize: 16,
  descriptionColor: T("textPrimary"),
  descriptionMaxWidth: 500,
  descriptionLineHeight: 1.5,
  descriptionMarginBottom: 32,
  // Suggestions section title
  suggestionsTitleFontSize: 16,
  suggestionsTitleFontWeight: "medium",
  suggestionsTitleColor: T("textPrimary"),
  suggestionsTitleMarginBottom: 16,
  // Suggestion pills
  suggestionPillPaddingX: 16,
  suggestionPillPaddingY: 10,
  suggestionPillBorderRadius: 20,
  suggestionPillBorderColor: c("#e5e7eb"),
  suggestionPillBgColor: c("transparent"),
  suggestionPillBgColorHover: c("#f3f4f6"),
  suggestionPillTextColor: T("textPrimary"),
  suggestionPillFontSize: 14,
  suggestionPillGap: 8,
  // Container
  containerPadding: 20
}, Qt = [
  // Icon container
  {
    key: "iconContainerSize",
    label: "Icon Container Size",
    type: "number",
    min: 40,
    max: 120,
    step: 8
  },
  {
    key: "iconContainerBgColor",
    label: "Icon Container Background",
    type: "color"
  },
  {
    key: "iconContainerBorderRadius",
    label: "Icon Container Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 20,
    max: 80,
    step: 4
  },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...te]
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleMarginBottom",
    label: "Title Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  // Description
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionMaxWidth",
    label: "Description Max Width",
    type: "number",
    min: 300,
    max: 700,
    step: 50
  },
  {
    key: "descriptionLineHeight",
    label: "Description Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "descriptionMarginBottom",
    label: "Description Margin Bottom",
    type: "number",
    min: 16,
    max: 64,
    step: 4
  },
  // Suggestions section title
  {
    key: "suggestionsTitleFontSize",
    label: "Suggestions Title Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "suggestionsTitleFontWeight",
    label: "Suggestions Title Weight",
    type: "options",
    options: [...te]
  },
  {
    key: "suggestionsTitleColor",
    label: "Suggestions Title Color",
    type: "color"
  },
  {
    key: "suggestionsTitleMarginBottom",
    label: "Suggestions Title Margin",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Suggestion pills
  {
    key: "suggestionPillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "suggestionPillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 16,
    step: 2
  },
  {
    key: "suggestionPillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "suggestionPillBorderColor",
    label: "Pill Border Color",
    type: "color"
  },
  { key: "suggestionPillBgColor", label: "Pill Background", type: "color" },
  {
    key: "suggestionPillBgColorHover",
    label: "Pill Background (Hover)",
    type: "color"
  },
  { key: "suggestionPillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "suggestionPillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "suggestionPillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerPadding",
    label: "Container Padding",
    type: "number",
    min: 0,
    max: 40,
    step: 4
  }
], Bl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    resolveColor: d,
    canSave: g
  } = V(
    t,
    { ...Ii, ...e },
    Qt
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const f = n(i, d);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Qt,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      children: f
    }
  );
}, zi = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Pi = {
  // Carousel gap
  carouselGap: 16,
  // Card container
  cardBorderRadius: 10,
  // "Explore now" pill
  pillBgColor: c("rgba(255, 255, 255, 0.6)"),
  pillBorderColor: c("#ffffff"),
  pillTextColor: c("#031425"),
  pillPaddingX: 12,
  pillPaddingY: 6,
  pillBorderRadius: 50,
  // Arrow button
  arrowBgColor: c("rgba(255, 255, 255, 0.6)"),
  arrowBorderColor: c("#ffffff"),
  arrowIconColor: c("#031425"),
  // Title
  titleColor: c("#031425"),
  titleFontWeight: "semibold",
  titleFontFamily: "inherit"
}, Xt = [
  // Carousel gap
  {
    key: "carouselGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Card container
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // "Explore now" pill
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 20,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 12,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 4,
    max: 50,
    step: 2
  },
  // Arrow button
  { key: "arrowBgColor", label: "Arrow Background", type: "color" },
  { key: "arrowBorderColor", label: "Arrow Border Color", type: "color" },
  { key: "arrowIconColor", label: "Arrow Icon Color", type: "color" },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...te]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  }
], Fl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    resolveColor: g,
    canSave: f,
    getEditValues: w
  } = V(
    t,
    { ...Pi, ...e },
    Xt
  ), C = i.titleFontFamily, b = C && C !== "inherit" ? d[C] : null, y = b && b.format === "google" ? b.url : null;
  if (J(() => {
    y && zi(y);
  }, [y]), a)
    return /* @__PURE__ */ r(G, {});
  const k = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", P = b && b.format !== "system" && b.format !== "google", x = `trending-card-${t || "default"}`, M = `
    ${P ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
    ${k !== "inherit" ? `.${x} [data-title-text] { font-family: ${k} !important; }` : ""}
  `.trim(), v = {
    ...i,
    titleFontFamilyCss: k
  }, R = /* @__PURE__ */ u(G, { children: [
    M && /* @__PURE__ */ r("style", { children: M }),
    n(v, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Xt,
      editValues: w(),
      onEditChange: m,
      onSave: f ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      children: R
    }
  );
}, Ti = {
  // Container
  backgroundColor: T("secondary"),
  borderColor: T("primary"),
  borderWidth: 1,
  borderRadius: 9999,
  // pill shape
  paddingX: 12,
  paddingY: 8,
  // Text
  textColor: T("textPrimary"),
  textColorLoading: c("rgba(0, 0, 0, 0.4)"),
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  // Product images
  imageSize: 24,
  imageBorderColor: c("#e5e7eb"),
  imageOverlap: 12,
  imageBorderRadius: 9999,
  // circle
  // Counter (+N)
  counterTextColor: c("rgba(0, 0, 0, 0.5)"),
  counterFontSize: 14,
  // Placeholder (loading state)
  placeholderBgColor: c("#f3f4f6")
}, Jt = [
  // Container
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Text
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "textColorLoading", label: "Text Color (Loading)", type: "color" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: te
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  // Product images
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2
  },
  { key: "imageBorderColor", label: "Image Border Color", type: "color" },
  {
    key: "imageOverlap",
    label: "Image Overlap",
    type: "number",
    min: 0,
    max: 20,
    step: 2
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 2
  },
  // Counter
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Placeholder
  { key: "placeholderBgColor", label: "Placeholder Background", type: "color" }
], Il = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    themeIcons: g,
    resolveColor: f,
    canSave: w
  } = V(
    t,
    { ...Ti, ...e },
    Jt
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const C = n(i, f);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Jt,
      editValues: i,
      onEditChange: m,
      onSave: w ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      themeIcons: g,
      children: C
    }
  );
}, Mi = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Ei = {
  // Preset
  preset: "plain",
  // Layout direction
  layout: "vertical",
  // Container
  containerGap: 8,
  containerBgColor: c("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Icon
  showIcon: !1,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: c("#e5e7eb"),
  pillBorderWidth: 1,
  pillBgColor: c("#ffffff"),
  pillBgColorHover: c("#f3f4f6"),
  pillTextColor: c("#181d56"),
  pillShadowEnabled: !1,
  pillShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Ai = {
  // --- Base: transparent bg, thin light border ---
  plain: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: c("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: c("#e5e7eb"),
    pillBorderWidth: 1,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#f3f4f6"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "plain-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: c("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: c("#e5e7eb"),
    pillBorderWidth: 1,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#f3f4f6"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Highlighted: container bg, no pill border ---
  highlighted: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: c("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: c("transparent"),
    pillBorderWidth: 0,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#ebeef1"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "highlighted-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: c("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: c("transparent"),
    pillBorderWidth: 0,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#ebeef1"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Container bg with thin border on pills ---
  "container-bg": {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: c("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: c("#e5e7eb"),
    pillBorderWidth: 1,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#ebeef1"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "container-bg-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: c("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: c("#e5e7eb"),
    pillBorderWidth: 1,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#ebeef1"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Extras: stronger border treatment ---
  bordered: {
    showIcon: !1,
    containerGap: 6,
    containerBgColor: c("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: c("#d1d5db"),
    pillBorderWidth: 1.5,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#f3f4f6"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-icon": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: c("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: c("#d1d5db"),
    pillBorderWidth: 1.5,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#f3f4f6"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-highlighted": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: c("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: c("#d1d5db"),
    pillBorderWidth: 1.5,
    pillBgColor: c("#ffffff"),
    pillBgColorHover: c("#ebeef1"),
    pillTextColor: c("#181d56"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  }
}, Wi = [
  { label: "Plain", value: "plain" },
  { label: "Plain + Icon", value: "plain-icon" },
  { label: "Highlighted", value: "highlighted" },
  { label: "Highlighted + Icon", value: "highlighted-icon" },
  { label: "Container BG", value: "container-bg" },
  { label: "Container BG + Icon", value: "container-bg-icon" },
  { label: "Bordered", value: "bordered" },
  { label: "Bordered + Icon", value: "bordered-icon" },
  { label: "Bordered Highlighted", value: "bordered-highlighted" },
  { label: "Custom", value: "custom" }
], Zt = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: Wi
  },
  // Layout direction
  {
    key: "layout",
    label: "Layout",
    type: "options",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  // Icon toggle
  { key: "showIcon", label: "Show Arrow Icon", type: "toggle" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Shadow Value (CSS)", type: "text" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...te]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" },
  // Shadow
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Pill Shadow CSS", type: "text" }
], zl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    resolveColor: g,
    canSave: f
  } = V(
    t,
    { ...Ei, ...e },
    Zt
  ), w = (H, D) => {
    if (H === "preset" && D !== "custom") {
      const O = Ai[D];
      if (O) {
        m("preset", D), Object.entries(O).forEach(([F, L]) => {
          m(F, L);
        });
        return;
      }
    }
    m(H, D);
  }, C = i.pillFontFamily, b = C && C !== "inherit" ? d[C] : null, y = b && b.format === "google" ? b.url : null;
  if (J(() => {
    y && Mi(y);
  }, [y]), a)
    return /* @__PURE__ */ r(G, {});
  const k = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", P = b && b.format !== "system" && b.format !== "google", x = `suggestion-list-${t || "default"}`, M = `
    ${P ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
    ${k !== "inherit" ? `.${x} { font-family: ${k} !important; }` : ""}
  `.trim(), v = {
    ...i,
    pillFontFamilyCss: k
  }, R = g(i.containerBgColor), W = R && R !== "transparent" && R !== "", S = /* @__PURE__ */ u(G, { children: [
    M && /* @__PURE__ */ r("style", { children: M }),
    /* @__PURE__ */ r(
      "div",
      {
        className: x,
        style: {
          backgroundColor: W ? R : void 0,
          padding: W || i.containerPaddingX || i.containerPaddingY ? `${i.containerPaddingY}px ${i.containerPaddingX}px` : void 0,
          borderRadius: i.containerBorderRadius > 0 ? `${i.containerBorderRadius}px` : void 0
        },
        children: n(v, g)
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Zt,
      editValues: i,
      onEditChange: w,
      onSave: f ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      children: S
    }
  );
}, Ri = {
  "vertical-compact": {
    panel: {
      mainBgColor: c("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 8,
      pillBorderColor: c("#e5e7eb"),
      pillBorderWidth: 1,
      pillBgColor: c("#ffffff"),
      pillTextColor: c("#181d56"),
      pillContainerBgColor: c("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: c("#e5e7eb"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 0
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: c("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillBorderRadius: 8,
      pillBorderColor: c("#e5e7eb"),
      pillBorderWidth: 1,
      pillBgColor: c("#ffffff"),
      pillBgColorHover: c("#f3f4f6"),
      pillTextColor: c("#181d56")
    },
    chatInput: {
      borderColor: c("#e5e7eb"),
      borderColorFocus: c("#181d56"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 20,
      minHeight: 0
    }
  },
  "vertical-expanded": {
    panel: {
      mainBgColor: c("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 8,
      pillBorderColor: c("transparent"),
      pillBorderWidth: 0,
      pillBgColor: c("#ffffff"),
      pillTextColor: c("#181d56"),
      pillContainerBgColor: c("transparent"),
      pillContainerBorderRadius: 12,
      inputBorderColor: c("#e5e7eb"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 100
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: c("transparent"),
      containerPaddingX: 12,
      containerPaddingY: 12,
      containerBorderRadius: 12,
      pillBorderRadius: 8,
      pillBorderColor: c("transparent"),
      pillBorderWidth: 0,
      pillBgColor: c("#ffffff"),
      pillBgColorHover: c("#e5e7eb"),
      pillTextColor: c("#181d56")
    },
    chatInput: {
      borderColor: c("#e5e7eb"),
      borderColorFocus: c("#181d56"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 20,
      minHeight: 100
    }
  },
  "horizontal-compact": {
    panel: {
      mainBgColor: c("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: c("#e5e7eb"),
      pillBorderWidth: 1,
      pillBgColor: c("#ffffff"),
      pillTextColor: c("#181d56"),
      pillContainerBgColor: c("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: c("#e5e7eb"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 0
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: c("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: c("#e5e7eb"),
      pillBorderWidth: 1,
      pillBgColor: c("#ffffff"),
      pillBgColorHover: c("#f3f4f6"),
      pillTextColor: c("#181d56")
    },
    chatInput: {
      borderColor: c("#e5e7eb"),
      borderColorFocus: c("#181d56"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 20,
      minHeight: 0
    }
  },
  "horizontal-expanded": {
    panel: {
      mainBgColor: c("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: c("#e5e7eb"),
      pillBorderWidth: 1,
      pillBgColor: c("#ffffff"),
      pillTextColor: c("#181d56"),
      pillContainerBgColor: c("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: c("#e5e7eb"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 100
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: c("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: c("#e5e7eb"),
      pillBorderWidth: 1,
      pillBgColor: c("#ffffff"),
      pillBgColorHover: c("#f3f4f6"),
      pillTextColor: c("#181d56")
    },
    chatInput: {
      borderColor: c("#e5e7eb"),
      borderColorFocus: c("#181d56"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 20,
      minHeight: 100
    }
  }
}, Li = [
  { label: "Vertical + Compact Input", value: "vertical-compact" },
  { label: "Vertical + Expanded Input", value: "vertical-expanded" },
  { label: "Horizontal + Compact Input", value: "horizontal-compact" },
  { label: "Horizontal + Expanded Input", value: "horizontal-expanded" },
  { label: "Custom", value: "custom" }
], Ut = [
  // --- General ---
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: Li
  },
  { key: "mainBgColor", label: "Background", type: "color" },
  // --- Suggestion Pills group ---
  {
    key: "pillLayout",
    label: "Layout",
    type: "options",
    group: "Suggestion Pills",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  {
    key: "pillShowIcon",
    label: "Show Icon",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderColor",
    label: "Border Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5,
    group: "Suggestion Pills"
  },
  {
    key: "pillBgColor",
    label: "Background",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillTextColor",
    label: "Text Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Suggestion Pills"
  },
  // --- Input Box group ---
  {
    key: "inputBorderColor",
    label: "Border Color",
    type: "color",
    group: "Input Box"
  },
  {
    key: "inputBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 0.5,
    group: "Input Box"
  },
  {
    key: "inputBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Input Box"
  },
  {
    key: "inputMinHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 200,
    step: 10,
    group: "Input Box"
  },
  {
    key: "inputShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Input Box"
  },
  {
    key: "inputShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Input Box"
  }
], Hi = {
  preset: "vertical-compact",
  mainBgColor: c("transparent"),
  // Pill defaults
  pillLayout: "vertical",
  pillShowIcon: !1,
  pillBorderRadius: 8,
  pillBorderColor: c("#e5e7eb"),
  pillBorderWidth: 1,
  pillBgColor: c("#ffffff"),
  pillTextColor: c("#181d56"),
  pillShadowEnabled: !1,
  pillShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
  pillContainerBgColor: c("transparent"),
  pillContainerBorderRadius: 0,
  // Input defaults
  inputBorderColor: c("#e5e7eb"),
  inputBorderWidth: 1,
  inputBorderRadius: 100,
  inputMinHeight: 0,
  inputShadowEnabled: !1,
  inputShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)"
}, Pl = ({
  widgetId: e = "concierge-panel",
  displayName: t = "Concierge Panel",
  initialState: o = {},
  suggestionListWidgetId: n = "concierge-suggestion-list",
  chatInputWidgetId: i = "concierge-chat-input",
  suppressChildEdits: a = !0,
  children: s
}) => {
  const {
    state: m,
    isLoading: p,
    isSaving: h,
    handleEditChange: d,
    handleSave: g,
    themeColors: f,
    themeFonts: w,
    resolveColor: C,
    canSave: b
  } = V(
    e,
    { ...Hi, ...o },
    Ut
  ), { updateWidgetConfig: y } = tt(
    n
  ), { updateWidgetConfig: k } = tt(i), P = {
    pillLayout: "layout",
    pillShowIcon: "showIcon",
    pillBorderRadius: "pillBorderRadius",
    pillBorderColor: "pillBorderColor",
    pillBorderWidth: "pillBorderWidth",
    pillBgColor: "pillBgColor",
    pillTextColor: "pillTextColor",
    pillShadowEnabled: "pillShadowEnabled",
    pillShadow: "pillShadow",
    pillContainerBgColor: "containerBgColor",
    pillContainerBorderRadius: "containerBorderRadius"
  }, x = {
    inputBorderColor: "borderColor",
    inputBorderWidth: "borderWidth",
    inputBorderRadius: "borderRadiusSingleLine",
    inputMinHeight: "minHeight",
    inputShadowEnabled: "shadowEnabled",
    inputShadow: "shadow"
  }, M = pe(
    (W, S) => {
      if (W === "preset" && S !== "custom") {
        const D = Ri[S];
        if (D) {
          d("preset", S), D.panel && Object.entries(D.panel).forEach(([E, O]) => {
            d(E, O);
          }), Object.entries(D.suggestionList).forEach(([E, O]) => {
            y(E, O);
          }), Object.entries(D.chatInput).forEach(([E, O]) => {
            k(E, O);
          });
          return;
        }
      }
      if (W in P) {
        d("preset", "custom"), d(W, S), y(P[W], S);
        return;
      }
      if (W in x) {
        d("preset", "custom"), d(W, S), k(x[W], S);
        return;
      }
      d(W, S);
    },
    [d, y, k]
  );
  if (p)
    return /* @__PURE__ */ r(G, {});
  const v = s(m, C);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: Ut,
      editValues: m,
      onEditChange: M,
      onSave: b ? g : void 0,
      isSaving: h,
      themeColors: f,
      themeFonts: w,
      containerClassName: "widget-fill-height",
      children: a ? /* @__PURE__ */ r(Mn, { children: v }) : v
    }
  );
}, Vt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Ni = {
  // Card/Pill container
  borderColor: c("#DCDCDC"),
  borderColorSelected: T("primary"),
  backgroundColor: T("secondary"),
  backgroundColorHover: c("#F6F8FA"),
  borderRadius: 8,
  // Rectangle card dimensions
  cardWidth: 88,
  cardGap: 12,
  cardImageSize: 72,
  // Compact pill dimensions
  pillImageSize: 32,
  pillGap: 8,
  pillPaddingY: 6,
  pillPaddingX: 12,
  // Checkmark badge
  checkmarkBgColor: T("primary"),
  checkmarkIconColor: T("secondary"),
  checkmarkSize: 16,
  // Price text
  priceColor: T("textPrimary"),
  priceFontSize: 16,
  priceFontWeightNormal: "medium",
  priceFontWeightSelected: "semibold",
  priceFontFamily: "inherit",
  // Variant name text
  nameColor: T("textPrimary"),
  nameFontSize: 14,
  nameFontSizeCompact: 14,
  nameFontWeightNormal: "medium",
  nameFontWeightSelected: "semibold",
  nameFontFamily: "inherit",
  // Divider
  dividerColor: c("#DCDCDC"),
  dividerColorSelected: T("primary")
}, qt = [
  // Card/Pill container
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderColorSelected",
    label: "Border Color (Selected)",
    type: "color"
  },
  { key: "backgroundColor", label: "Background Color", type: "color" },
  {
    key: "backgroundColorHover",
    label: "Background Color (Hover)",
    type: "color"
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  // Rectangle card dimensions
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 60,
    max: 120,
    step: 4
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "cardImageSize",
    label: "Card Image Size",
    type: "number",
    min: 48,
    max: 96,
    step: 4
  },
  // Compact pill dimensions
  {
    key: "pillImageSize",
    label: "Pill Image Size",
    type: "number",
    min: 24,
    max: 48,
    step: 4
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Checkmark badge
  { key: "checkmarkBgColor", label: "Checkmark Background", type: "color" },
  { key: "checkmarkIconColor", label: "Checkmark Icon Color", type: "color" },
  {
    key: "checkmarkSize",
    label: "Checkmark Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Price text
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "priceFontWeightNormal",
    label: "Price Font Weight",
    type: "options",
    options: [...te]
  },
  {
    key: "priceFontWeightSelected",
    label: "Price Weight (Selected)",
    type: "options",
    options: [...te]
  },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font"
  },
  // Variant name text
  { key: "nameColor", label: "Name Color", type: "color" },
  {
    key: "nameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "nameFontSizeCompact",
    label: "Name Font Size (Compact)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "nameFontWeightNormal",
    label: "Name Font Weight",
    type: "options",
    options: [...te]
  },
  {
    key: "nameFontWeightSelected",
    label: "Name Weight (Selected)",
    type: "options",
    options: [...te]
  },
  {
    key: "nameFontFamily",
    label: "Name Font Family",
    type: "font"
  },
  // Divider
  { key: "dividerColor", label: "Divider Color", type: "color" },
  {
    key: "dividerColorSelected",
    label: "Divider Color (Selected)",
    type: "color"
  }
], Tl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    resolveColor: g,
    canSave: f
  } = V(
    t,
    { ...Ni, ...e },
    qt
  ), w = i.priceFontFamily, C = w && w !== "inherit" ? d[w] : null, b = i.nameFontFamily, y = b && b !== "inherit" ? d[b] : null, k = C && C.format === "google" ? C.url : null, P = y && y.format === "google" ? y.url : null;
  if (J(() => {
    k && Vt(k);
  }, [k]), J(() => {
    P && Vt(P);
  }, [P]), a)
    return /* @__PURE__ */ r(G, {});
  const x = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", M = y ? y.format === "system" ? y.url : `"${y.name}", sans-serif` : "inherit", v = C && C.format !== "system" && C.format !== "google", R = y && y.format !== "system" && y.format !== "google", W = `variant-picker-${t || "default"}`, S = `
    ${v ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${R ? `
      @font-face {
        font-family: "${y.name}";
        src: url("${y.url}") format("${y.format}");
        font-display: swap;
      }
    ` : ""}
    ${x !== "inherit" ? `.${W} [data-price-text] { font-family: ${x} !important; }` : ""}
    ${M !== "inherit" ? `.${W} [data-name-text] { font-family: ${M} !important; }` : ""}
  `.trim(), H = {
    ...i,
    priceFontFamilyCss: x,
    nameFontFamilyCss: M
  }, D = /* @__PURE__ */ u(G, { children: [
    S && /* @__PURE__ */ r("style", { children: S }),
    n(H, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: qt,
      editValues: i,
      onEditChange: m,
      onSave: f ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      children: D
    }
  );
}, Di = {
  // ============================================
  // 1. HEADER SECTION (Search results toggle)
  // ============================================
  headerIconColor: c("rgba(0, 0, 0, 0.5)"),
  headerIconSize: 14,
  headerLabelText: "Search results",
  headerLabelColor: c("rgba(0, 0, 0, 0.5)"),
  headerLabelFontSize: 14,
  headerLabelFontWeight: "medium",
  headerLabelFontFamily: "inherit",
  headerChevronColor: c("rgba(0, 0, 0, 0.5)"),
  headerChevronSize: 16,
  headerGap: 6,
  headerMarginBottom: 16,
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  containerMarginBottom: 12,
  pillsGap: 8,
  pillsSectionMarginBottom: 24,
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  defaultExpanded: !0,
  autoCollapse: !0,
  autoCollapseDelay: 1500,
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  thinkingEnabled: !0,
  thinkingText: "Thinking...",
  thinkingTextColor: c("#666666"),
  thinkingTextFontSize: 14,
  thinkingBgColor: T("secondary"),
  thinkingPaddingX: 16,
  thinkingPaddingY: 12,
  thinkingBorderRadius: 18,
  thinkingBorderRadiusBottomLeft: 5,
  shimmerDuration: 1.5,
  shimmerColor: c("#e0e0e0"),
  // ============================================
  // 5. ANIMATION
  // ============================================
  animationsEnabled: !0,
  productAnimationDuration: 800,
  chevronRotationDuration: 200
}, Kt = [
  // ============================================
  // 1. HEADER SECTION
  // ============================================
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  {
    key: "headerIconSize",
    label: "Header Icon Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  { key: "headerLabelText", label: "Header Label Text", type: "text" },
  { key: "headerLabelColor", label: "Header Label Color", type: "color" },
  {
    key: "headerLabelFontSize",
    label: "Header Label Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  {
    key: "headerLabelFontWeight",
    label: "Header Label Font Weight",
    type: "options",
    options: te
  },
  {
    key: "headerLabelFontFamily",
    label: "Header Label Font Family",
    type: "font"
  },
  { key: "headerChevronColor", label: "Header Chevron Color", type: "color" },
  {
    key: "headerChevronSize",
    label: "Header Chevron Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "headerGap",
    label: "Header Gap",
    type: "number",
    min: 2,
    max: 16,
    step: 1
  },
  {
    key: "headerMarginBottom",
    label: "Header Margin Bottom",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "pillsGap",
    label: "Pills Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillsSectionMarginBottom",
    label: "Pills Section Margin Bottom",
    type: "number",
    min: 8,
    max: 48,
    step: 4
  },
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  { key: "defaultExpanded", label: "Default Expanded", type: "toggle" },
  { key: "autoCollapse", label: "Auto Collapse", type: "toggle" },
  {
    key: "autoCollapseDelay",
    label: "Auto Collapse Delay (ms)",
    type: "number",
    min: 500,
    max: 5e3,
    step: 100
  },
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  {
    key: "thinkingEnabled",
    label: "Thinking Indicator Enabled",
    type: "toggle"
  },
  { key: "thinkingText", label: "Thinking Text", type: "text" },
  { key: "thinkingTextColor", label: "Thinking Text Color", type: "color" },
  {
    key: "thinkingTextFontSize",
    label: "Thinking Text Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  { key: "thinkingBgColor", label: "Thinking Background", type: "color" },
  {
    key: "thinkingPaddingX",
    label: "Thinking Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  {
    key: "thinkingPaddingY",
    label: "Thinking Padding Y",
    type: "number",
    min: 6,
    max: 24,
    step: 2
  },
  {
    key: "thinkingBorderRadius",
    label: "Thinking Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "thinkingBorderRadiusBottomLeft",
    label: "Thinking Bottom Left Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "shimmerDuration",
    label: "Shimmer Duration (s)",
    type: "number",
    min: 0.5,
    max: 4,
    step: 0.1
  },
  { key: "shimmerColor", label: "Shimmer Color", type: "color" },
  // ============================================
  // 5. ANIMATION
  // ============================================
  { key: "animationsEnabled", label: "Animations Enabled", type: "toggle" },
  {
    key: "productAnimationDuration",
    label: "Product Animation Duration (ms)",
    type: "number",
    min: 200,
    max: 2e3,
    step: 100
  },
  {
    key: "chevronRotationDuration",
    label: "Chevron Rotation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  }
], Ml = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    themeIcons: g,
    resolveColor: f,
    canSave: w
  } = V(
    t,
    { ...Di, ...e },
    Kt
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const C = n(i, f);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: Kt,
      editValues: i,
      onEditChange: m,
      onSave: w ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      themeIcons: g,
      children: C
    }
  );
}, Oi = {
  // Container styling
  containerBgColor: c("#FFFFFF"),
  containerBorderRadius: 16,
  containerPaddingX: 24,
  containerPaddingY: 24,
  containerBorderWidth: 1,
  containerBorderColor: c("#E8EAF0"),
  // Icon styling
  iconBgColor: T("primary"),
  iconColor: c("#FFFFFF"),
  iconSize: 40,
  // Title styling
  titleColor: T("textPrimary"),
  titleFontSize: 16,
  titleFontWeight: "700",
  // Description styling
  descriptionColor: c("#6B7280"),
  descriptionFontSize: 14,
  // Button styling
  buttonBgColor: T("primary"),
  buttonTextColor: c("#FFFFFF"),
  buttonFontSize: 14,
  buttonFontWeight: "600",
  buttonBorderRadius: 10,
  buttonPaddingX: 20,
  buttonPaddingY: 10
}, _t = [
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24
  },
  {
    key: "containerBorderWidth",
    label: "Container Border Width",
    type: "number",
    min: 0,
    max: 4
  },
  { key: "containerBorderColor", label: "Container Border Color", type: "color" },
  { key: "iconBgColor", label: "Icon Background", type: "color" },
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 24
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 10,
    max: 20
  },
  { key: "buttonBgColor", label: "Button Background", type: "color" },
  { key: "buttonTextColor", label: "Button Text Color", type: "color" },
  {
    key: "buttonBorderRadius",
    label: "Button Border Radius",
    type: "number",
    min: 0,
    max: 24
  }
], ji = ({ size: e, color: t }) => /* @__PURE__ */ u(
  "svg",
  {
    width: e * 0.5,
    height: e * 0.5,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ r("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2", ry: "2" }),
      /* @__PURE__ */ r("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
    ]
  }
), El = ({
  widgetId: e,
  title: t,
  description: o,
  buttonText: n,
  onSignIn: i,
  initialState: a
}) => {
  const {
    state: s,
    handleEditChange: m,
    handleSave: p,
    isSaving: h,
    getEditValues: d,
    resolveColor: g,
    themeColors: f,
    themeFonts: w,
    themeIcons: C
  } = V(
    e,
    { ...Oi, ...a },
    _t
  );
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: "Login Wall",
      editFields: _t,
      editValues: d(),
      onEditChange: m,
      onSave: p,
      isSaving: h,
      themeColors: f,
      themeFonts: w,
      themeIcons: C,
      children: /* @__PURE__ */ u(
        "div",
        {
          style: {
            backgroundColor: g(s.containerBgColor),
            borderRadius: `${s.containerBorderRadius}px`,
            padding: `${s.containerPaddingY}px ${s.containerPaddingX}px`,
            border: `${s.containerBorderWidth}px solid ${g(s.containerBorderColor)}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "center",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)"
          },
          children: [
            /* @__PURE__ */ r(
              "div",
              {
                style: {
                  width: `${s.iconSize}px`,
                  height: `${s.iconSize}px`,
                  borderRadius: "50%",
                  backgroundColor: g(s.iconBgColor),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                },
                children: /* @__PURE__ */ r(
                  ji,
                  {
                    size: s.iconSize,
                    color: g(s.iconColor)
                  }
                )
              }
            ),
            /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    color: g(s.titleColor),
                    fontSize: `${s.titleFontSize}px`,
                    fontWeight: s.titleFontWeight,
                    lineHeight: 1.4
                  },
                  children: t
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    color: g(s.descriptionColor),
                    fontSize: `${s.descriptionFontSize}px`,
                    lineHeight: 1.5
                  },
                  children: o
                }
              )
            ] }),
            i && /* @__PURE__ */ r(
              "button",
              {
                onClick: i,
                style: {
                  backgroundColor: g(s.buttonBgColor),
                  color: g(s.buttonTextColor),
                  fontSize: `${s.buttonFontSize}px`,
                  fontWeight: s.buttonFontWeight,
                  borderRadius: `${s.buttonBorderRadius}px`,
                  padding: `${s.buttonPaddingY}px ${s.buttonPaddingX}px`,
                  border: "none",
                  cursor: "pointer",
                  transition: "opacity 0.15s ease",
                  width: "100%",
                  maxWidth: "200px",
                  letterSpacing: "0.01em"
                },
                onMouseEnter: (b) => {
                  b.currentTarget.style.opacity = "0.88";
                },
                onMouseLeave: (b) => {
                  b.currentTarget.style.opacity = "1";
                },
                children: n
              }
            )
          ]
        }
      )
    }
  );
}, Gi = {
  // =========================================================================
  // A-Series: Minimal / brand-focused layouts
  // =========================================================================
  /** A1 - Minimal: Logo only + search bar */
  A1: {
    logoPosition: "hero",
    brandLabelPosition: "hidden",
    showGreeting: !1,
    showGreetingIcon: !1,
    subtitlePosition: "hidden",
    startersMode: "hidden",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    mobile_logoPosition: "hero",
    mobile_startersMode: "inherit"
  },
  /** A2 - Logo + Subtitle: Logo with assistant intro text */
  A2: {
    logoPosition: "hero",
    brandLabelPosition: "hidden",
    showGreeting: !1,
    showGreetingIcon: !1,
    subtitlePosition: "under-hero-logo",
    startersMode: "hidden",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    mobile_logoPosition: "hero",
    mobile_startersMode: "inherit"
  },
  /** A3 - Branded Logo: "CONCIERGE BY" label above logo */
  A3: {
    logoPosition: "hero",
    brandLabelPosition: "above-hero-logo",
    showGreeting: !1,
    showGreetingIcon: !1,
    subtitlePosition: "hidden",
    startersMode: "hidden",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    mobile_logoPosition: "hero",
    mobile_startersMode: "inherit"
  },
  /** A4 - Subtitle + Pills: Subtitle text with pill starters, logo in footer */
  A4: {
    logoPosition: "footer",
    brandLabelPosition: "hidden",
    showGreeting: !1,
    showGreetingIcon: !1,
    subtitlePosition: "under-greeting",
    startersMode: "pills",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    footerPaddingBottom: 16,
    mobile_logoPosition: "header",
    mobile_startersMode: "inherit"
  },
  /** A5 - Greeting + Pills: Personalized greeting with pill starters */
  A5: {
    logoPosition: "footer",
    brandLabelPosition: "hidden",
    showGreeting: !0,
    showGreetingIcon: !1,
    subtitlePosition: "under-greeting",
    startersMode: "pills",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    footerPaddingBottom: 16,
    mobile_logoPosition: "header",
    mobile_startersMode: "inherit"
  },
  /** A6 - Inline Icon Greeting + Pills: Greeting with inline icon before text and pill starters */
  A6: {
    logoPosition: "footer",
    brandLabelPosition: "hidden",
    showGreeting: !0,
    showGreetingIcon: !0,
    greetingIconPosition: "inline",
    subtitlePosition: "under-greeting",
    startersMode: "pills",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    footerPaddingBottom: 16,
    mobile_logoPosition: "header",
    mobile_startersMode: "inherit"
  },
  /** A7 - Icon Above Greeting + Pills: Greeting with icon above text and pill starters */
  A7: {
    logoPosition: "footer",
    brandLabelPosition: "hidden",
    showGreeting: !0,
    showGreetingIcon: !0,
    greetingIconPosition: "above",
    subtitlePosition: "under-greeting",
    startersMode: "pills",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    footerPaddingBottom: 16,
    mobile_logoPosition: "header",
    mobile_startersMode: "inherit"
  },
  // =========================================================================
  // B-Series: Greeting + conversation starters focused
  // =========================================================================
  /** B1 - Card Starters Row: Greeting with 4 cards in a horizontal row */
  B1: {
    logoPosition: "footer",
    brandLabelPosition: "hidden",
    showGreeting: !0,
    showGreetingIcon: !1,
    subtitlePosition: "under-greeting",
    startersMode: "cards-row",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    footerPaddingBottom: 64,
    mobile_logoPosition: "header",
    mobile_startersMode: "cards-grid"
  },
  /** B2 - Icon Pills: Greeting with 3 icon-pill starters, logo after content */
  B2: {
    logoPosition: "after-content",
    brandLabelPosition: "hidden",
    showGreeting: !0,
    showGreetingIcon: !1,
    subtitlePosition: "under-greeting",
    startersMode: "pills-icons",
    maxStarters: 3,
    cardLayoutDirection: "stacked",
    footerGap: 56,
    mobile_logoPosition: "header",
    mobile_startersMode: "inherit"
  },
  /** B3 - Icon Pills + Branded Footer: 3 icon-pill starters with "CONCIERGE BY" footer */
  B3: {
    logoPosition: "footer",
    brandLabelPosition: "above-footer-logo",
    showGreeting: !0,
    showGreetingIcon: !1,
    subtitlePosition: "under-greeting",
    startersMode: "pills-icons",
    maxStarters: 3,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    footerPaddingBottom: 56,
    mobile_logoPosition: "header",
    mobile_startersMode: "inherit"
  },
  /** B4 - Card Grid: Greeting with 2x2 inline-icon card grid */
  B4: {
    logoPosition: "footer",
    brandLabelPosition: "hidden",
    showGreeting: !0,
    showGreetingIcon: !1,
    subtitlePosition: "under-greeting",
    startersMode: "cards-grid",
    maxStarters: 4,
    cardLayoutDirection: "inline",
    footerGap: 8,
    footerPaddingBottom: 56,
    mobile_logoPosition: "header",
    mobile_startersMode: "pills-icons-list"
  },
  /** B5 - Pills + Branded Footer: Greeting with pills and "EMBER BY" footer */
  B5: {
    logoPosition: "footer",
    brandLabelPosition: "above-footer-logo",
    showGreeting: !0,
    showGreetingIcon: !1,
    subtitlePosition: "under-greeting",
    startersMode: "pills",
    maxStarters: 4,
    cardLayoutDirection: "stacked",
    footerGap: 8,
    footerPaddingBottom: 56,
    mobile_logoPosition: "header",
    mobile_startersMode: "inherit"
  }
}, Yi = {
  A1: "A1 - Minimal (Logo only)",
  A2: "A2 - Logo + Subtitle",
  A3: "A3 - Branded Logo",
  A4: "A4 - Subtitle + Pills",
  A5: "A5 - Greeting + Pills",
  A6: "A6 - Inline Icon Greeting + Pills",
  A7: "A7 - Icon Above Greeting + Pills",
  B1: "B1 - Card Starters (Row)",
  B2: "B2 - Icon Pills",
  B3: "B3 - Icon Pills + Branded Footer",
  B4: "B4 - Card Starters (Grid)",
  B5: "B5 - Pills + Branded Footer",
  custom: "Custom"
}, $i = {
  layoutPreset: "A1",
  backgroundStyle: "colored",
  backgroundColor: T("background"),
  elementStyle: "default",
  logoPosition: "hero",
  brandLabelPosition: "hidden",
  showGreeting: !1,
  showGreetingIcon: !1,
  greetingIconPosition: "above",
  subtitlePosition: "hidden",
  startersMode: "hidden",
  maxStarters: 4,
  cardLayoutDirection: "stacked",
  footerGap: 8,
  footerPaddingBottom: 16,
  mobile_logoPosition: "hero",
  mobile_startersMode: "inherit"
}, Qi = Object.entries(Yi).map(([e, t]) => ({
  label: t,
  value: e
})), eo = [
  // Preset
  {
    key: "layoutPreset",
    label: "Layout Preset",
    type: "options",
    options: Qi,
    group: "Preset"
  },
  // Background
  {
    key: "backgroundStyle",
    label: "Background",
    type: "options",
    options: [
      { label: "Colored", value: "colored" },
      { label: "White", value: "white" }
    ],
    group: "Background"
  },
  {
    key: "backgroundColor",
    label: "Background Color",
    type: "color",
    group: "Background",
    condition: { field: "backgroundStyle", value: "colored" }
  },
  {
    key: "elementStyle",
    label: "Element Style",
    type: "options",
    options: [
      { label: "Default", value: "default" },
      { label: "Grey Fill", value: "grey-fill" },
      { label: "Grey Fill + Stroke", value: "grey-fill-stroke" }
    ],
    group: "Background"
  },
  // Sections
  {
    key: "logoPosition",
    label: "Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "After Content", value: "after-content" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "brandLabelPosition",
    label: "Brand Label",
    type: "options",
    options: [
      { label: "Above Hero Logo", value: "above-hero-logo" },
      { label: "Above Footer Logo", value: "above-footer-logo" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "showGreeting",
    label: "Show Greeting",
    type: "toggle",
    group: "Sections"
  },
  {
    key: "showGreetingIcon",
    label: "Show Greeting Icon",
    type: "toggle",
    group: "Sections",
    condition: "showGreeting"
  },
  {
    key: "greetingIconPosition",
    label: "Icon Position",
    type: "options",
    options: [
      { label: "Above Greeting", value: "above" },
      { label: "Inline (before text)", value: "inline" }
    ],
    group: "Sections",
    condition: "showGreetingIcon"
  },
  {
    key: "subtitlePosition",
    label: "Subtitle Position",
    type: "options",
    options: [
      { label: "Under Hero Logo", value: "under-hero-logo" },
      { label: "Under Greeting", value: "under-greeting" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "startersMode",
    label: "Starters Layout",
    type: "options",
    options: [
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Sections"
  },
  {
    key: "maxStarters",
    label: "Max Starters",
    type: "number",
    min: 1,
    max: 6,
    step: 1,
    group: "Sections",
    condition: { field: "startersMode", value: "hidden", operator: "not_equals" }
  },
  {
    key: "cardLayoutDirection",
    label: "Card Layout",
    type: "options",
    options: [
      { label: "Stacked (icon above text)", value: "stacked" },
      { label: "Inline (icon beside text)", value: "inline" }
    ],
    group: "Sections",
    condition: { field: "startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "footerGap",
    label: "Footer / After-Content Gap",
    type: "number",
    min: 0,
    max: 80,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: ["footer", "after-content"], operator: "includes" }
  },
  {
    key: "footerPaddingBottom",
    label: "Footer Bottom Padding",
    type: "number",
    min: 0,
    max: 120,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: "footer" }
  },
  // Mobile overrides (responsive)
  {
    key: "mobile_logoPosition",
    label: "Mobile Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Header (top bar)", value: "header" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "Hidden", value: "hidden" },
      { label: "Inherit from Desktop", value: "inherit" }
    ],
    group: "Mobile"
  },
  {
    key: "mobile_startersMode",
    label: "Mobile Starters Layout",
    type: "options",
    options: [
      { label: "Inherit from Desktop", value: "inherit" },
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Mobile"
  }
], Al = ({
  widgetId: e = "concierge-home-layout",
  displayName: t = "Home Layout",
  initialState: o = {},
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    resolveColor: d,
    canSave: g
  } = V(
    e,
    { ...$i, ...o },
    eo
  ), f = pe(
    (C, b) => {
      if (C === "layoutPreset" && b !== "custom") {
        const y = Gi[b];
        y && Object.entries(y).forEach(([k, P]) => {
          m(k, P);
        });
      }
      m(C, b);
    },
    [m]
  );
  if (a)
    return /* @__PURE__ */ r("div", { style: { flex: 1, display: "flex", flexDirection: "column" } });
  const w = n(i, d);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: eo,
      editValues: i,
      onEditChange: f,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      triggerMode: "persistent",
      triggerIcon: "gear",
      triggerPosition: "bottom-right",
      triggerLabel: "Edit Home Layout",
      children: w
    }
  );
}, Xi = {
  logoIcon: "default",
  logoWidth: 200,
  logoMaxHeight: 80,
  logoOpacity: 1,
  mobile_logoWidth: 140
}, to = [
  {
    key: "logoIcon",
    label: "Logo Image",
    type: "icon"
  },
  {
    key: "logoWidth",
    label: "Logo Width",
    type: "number",
    min: 60,
    max: 400,
    step: 10,
    responsive: !0
  },
  {
    key: "logoMaxHeight",
    label: "Max Height",
    type: "number",
    min: 30,
    max: 200,
    step: 10
  },
  {
    key: "logoOpacity",
    label: "Opacity",
    type: "number",
    min: 0.1,
    max: 1,
    step: 0.1
  }
], Wl = ({
  widgetId: e = "concierge-home-logo",
  displayName: t = "Brand Logo",
  initialState: o = {},
  logoUrl: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeIcons: d,
    canSave: g
  } = V(
    e,
    { ...Xi, ...o },
    to
  ), f = i.logoIcon && i.logoIcon !== "default" ? d[i.logoIcon] : null, w = f ? f.url : n;
  if (a || !w)
    return /* @__PURE__ */ r(G, {});
  const C = /* @__PURE__ */ r(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%"
      },
      children: /* @__PURE__ */ r(
        "img",
        {
          src: w,
          alt: f ? f.name : "Brand logo",
          style: {
            width: i.logoWidth,
            maxHeight: i.logoMaxHeight,
            opacity: i.logoOpacity,
            objectFit: "contain"
          }
        }
      )
    }
  );
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: to,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeIcons: d,
      children: C
    }
  );
}, Ji = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Zi = {
  text: "CONCIERGE BY",
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  color: T("foreground"),
  letterSpacing: 2,
  textTransform: "uppercase",
  marginBottom: 8
}, oo = [
  { key: "text", label: "Label Text", type: "text" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [...te]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: 0,
    max: 10,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  }
], Rl = ({
  widgetId: e = "concierge-home-brand-label",
  displayName: t = "Brand Label",
  initialState: o = {}
}) => {
  const {
    state: n,
    isLoading: i,
    isSaving: a,
    handleEditChange: s,
    handleSave: m,
    themeColors: p,
    themeFonts: h,
    resolveColor: d,
    canSave: g
  } = V(
    e,
    { ...Zi, ...o },
    oo
  ), f = n.fontFamily, w = f && f !== "inherit" ? h[f] : null, C = w && w.format === "google" ? w.url : null;
  if (J(() => {
    C && Ji(C);
  }, [C]), i)
    return /* @__PURE__ */ r(G, {});
  const b = w ? w.format === "system" ? w.url : `"${w.name}", sans-serif` : "inherit", y = w && w.format !== "system" && w.format !== "google", k = `brand-label-${e || "default"}`, P = `
    ${y ? `
      @font-face {
        font-family: "${w.name}";
        src: url("${w.url}") format("${w.format}");
        font-display: swap;
      }
    ` : ""}
    ${b !== "inherit" ? `.${k} { font-family: ${b} !important; }` : ""}
  `.trim(), x = n.fontWeight === "normal" ? 400 : n.fontWeight === "medium" ? 500 : n.fontWeight === "semibold" ? 600 : 700, M = /* @__PURE__ */ u(G, { children: [
    P && /* @__PURE__ */ r("style", { children: P }),
    /* @__PURE__ */ r(
      "div",
      {
        className: b !== "inherit" ? k : void 0,
        style: {
          textAlign: "center",
          marginBottom: n.marginBottom
        },
        children: /* @__PURE__ */ r(
          "span",
          {
            style: {
              fontSize: n.fontSize,
              fontWeight: x,
              color: d(n.color),
              letterSpacing: n.letterSpacing,
              textTransform: n.textTransform
            },
            children: n.text
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: oo,
      editValues: n,
      onEditChange: s,
      onSave: g ? m : void 0,
      isSaving: a,
      themeColors: p,
      themeFonts: h,
      children: M
    }
  );
}, Ui = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Vi = ({
  size: e,
  color: t
}) => /* @__PURE__ */ r(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M48 22.8232H29.0836L46.1268 14.4962L45.1182 12.3764L28.0749 20.7034L39.8703 5.69848L38.0548 4.23074L26.2622 19.2357L30.4697 0.52336L28.2104 0L24 18.7123L19.7896 0L17.5274 0.52336L21.7378 19.2357L9.94236 4.23074L8.12968 5.69848L19.9222 20.7034L2.87896 12.3764L1.8732 14.4962L18.9164 22.8232H0V25.1768H18.9164L1.8732 33.5038L2.87896 35.6265L19.9222 27.2995L8.12968 42.3044L9.94236 43.7722L21.7378 28.7673L17.5274 47.4766L19.7896 48L24 29.2906L28.2104 48L30.4697 47.4766L26.2622 28.7673L38.0548 43.7722L39.8703 42.3044L28.0749 27.2995L45.1182 35.6265L46.1268 33.5038L29.0836 25.1768H48V22.8232Z",
        fill: t
      }
    )
  }
), qi = {
  greetingTemplate: "Hi, {name}.",
  greetingFontSize: 24,
  greetingFontWeight: "medium",
  greetingFontFamily: "inherit",
  greetingColor: T("foreground"),
  showUserName: !0,
  iconType: "brand-icon",
  emoji: "👋",
  brandIcon: "",
  iconSize: 32,
  iconColor: T("primary"),
  iconRotationAnimation: !1,
  iconRotationDuration: 8,
  iconMarginBottom: 8,
  greetingMarginBottom: 8,
  mobile_greetingFontSize: 20,
  mobile_iconSize: 28
}, ro = [
  // Greeting text
  {
    key: "greetingTemplate",
    label: "Greeting Text",
    type: "text",
    group: "Greeting Text"
  },
  {
    key: "showUserName",
    label: "Show User Name",
    type: "toggle",
    group: "Greeting Text"
  },
  {
    key: "greetingFontSize",
    label: "Font Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Greeting Text",
    responsive: !0
  },
  {
    key: "greetingFontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Greeting Text"
  },
  {
    key: "greetingFontFamily",
    label: "Font Family",
    type: "font",
    group: "Greeting Text"
  },
  {
    key: "greetingColor",
    label: "Color",
    type: "color",
    group: "Greeting Text"
  },
  {
    key: "greetingMarginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Greeting Text"
  },
  // Icon
  {
    key: "iconType",
    label: "Icon Type",
    type: "options",
    options: [
      { label: "Brand Icon", value: "brand-icon" },
      { label: "Emoji", value: "emoji" }
    ],
    group: "Greeting Icon"
  },
  {
    key: "emoji",
    label: "Emoji",
    type: "text",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "emoji" }
  },
  {
    key: "brandIcon",
    label: "Icon",
    type: "icon",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Greeting Icon",
    responsive: !0
  },
  {
    key: "iconColor",
    label: "Icon Color",
    type: "color",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconRotationAnimation",
    label: "Rotation Animation",
    type: "toggle",
    group: "Greeting Icon"
  },
  {
    key: "iconRotationDuration",
    label: "Rotation Speed (seconds)",
    type: "number",
    min: 1,
    max: 30,
    step: 1,
    group: "Greeting Icon",
    condition: "iconRotationAnimation"
  },
  {
    key: "iconMarginBottom",
    label: "Icon Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 4,
    group: "Greeting Icon"
  }
], Ll = ({
  widgetId: e = "concierge-home-greeting",
  displayName: t = "Greeting",
  initialState: o = {},
  userName: n,
  showIcon: i = !1,
  iconPosition: a = "above"
}) => {
  const {
    state: s,
    isLoading: m,
    isSaving: p,
    handleEditChange: h,
    handleSave: d,
    themeColors: g,
    themeFonts: f,
    themeIcons: w,
    resolveColor: C,
    canSave: b
  } = V(
    e,
    { ...qi, ...o },
    ro
  ), y = s.greetingFontFamily, k = y && y !== "inherit" ? f[y] : null, P = k && k.format === "google" ? k.url : null;
  if (J(() => {
    P && Ui(P);
  }, [P]), m)
    return /* @__PURE__ */ r(G, {});
  const x = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", M = k && k.format !== "system" && k.format !== "google", v = `greeting-${e || "default"}`, R = `
    ${M ? `
      @font-face {
        font-family: "${k.name}";
        src: url("${k.url}") format("${k.format}");
        font-display: swap;
      }
    ` : ""}
    ${x !== "inherit" ? `.${v} { font-family: ${x} !important; }` : ""}
  `.trim();
  let W = s.greetingTemplate;
  s.showUserName && n ? W = W.replace("{name}", n) : (W = W.replace(/,?\s*\{name\}/g, "").replace(/^Hi\.$/, "Hello!"), W.trim() || (W = "Hello!"));
  const S = s.greetingFontWeight === "normal" ? 400 : s.greetingFontWeight === "medium" ? 500 : s.greetingFontWeight === "semibold" ? 600 : 700, H = C(s.iconColor), D = `greeting-icon-spin-${e || "default"}`, E = s.iconRotationAnimation ? `@keyframes ${D} { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }` : "", O = s.iconRotationAnimation ? {
    animation: `${D} ${s.iconRotationDuration}s linear infinite`
  } : {}, F = () => {
    if (!i) return null;
    let j = null;
    return s.iconType === "emoji" ? j = /* @__PURE__ */ r("span", { style: { fontSize: s.iconSize }, children: s.emoji }) : s.brandIcon && w[s.brandIcon] ? j = /* @__PURE__ */ r(
      "div",
      {
        style: {
          width: s.iconSize,
          height: s.iconSize,
          backgroundColor: H,
          WebkitMaskImage: `url(${w[s.brandIcon].url})`,
          WebkitMaskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskImage: `url(${w[s.brandIcon].url})`,
          maskSize: "contain",
          maskRepeat: "no-repeat",
          maskPosition: "center"
        }
      }
    ) : j = /* @__PURE__ */ r(Vi, { size: s.iconSize, color: H }), /* @__PURE__ */ r(
      "div",
      {
        style: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          ...O
        },
        children: j
      }
    );
  }, L = a === "inline", Y = /* @__PURE__ */ u(G, { children: [
    R && /* @__PURE__ */ r("style", { children: R }),
    E && /* @__PURE__ */ r("style", { children: E }),
    /* @__PURE__ */ u(
      "div",
      {
        className: x !== "inherit" ? v : void 0,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          marginBottom: s.greetingMarginBottom
        },
        children: [
          i && !L && /* @__PURE__ */ r("div", { style: { marginBottom: s.iconMarginBottom }, children: F() }),
          /* @__PURE__ */ u(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                gap: L && i ? 8 : 0,
                fontSize: s.greetingFontSize,
                fontWeight: S,
                color: C(s.greetingColor),
                lineHeight: 1.3
              },
              children: [
                i && L && F(),
                W
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: ro,
      editValues: s,
      onEditChange: h,
      onSave: b ? d : void 0,
      isSaving: p,
      themeColors: g,
      themeFonts: f,
      themeIcons: w,
      children: Y
    }
  );
}, Ki = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, _i = {
  textTemplate: "I'm {concierge_name}, your shopping assistant for {brand}.",
  fontSize: 24,
  fontWeight: "normal",
  fontFamily: "inherit",
  color: T("foreground"),
  lineHeight: 1.4,
  maxWidth: 700,
  marginBottom: 16,
  mobile_fontSize: 18
}, no = [
  { key: "textTemplate", label: "Subtitle Text", type: "text" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 32,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 200,
    max: 800,
    step: 50
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 48,
    step: 4
  }
], Hl = ({
  widgetId: e = "concierge-home-subtitle",
  displayName: t = "Subtitle",
  initialState: o = {},
  brandName: n = "",
  conciergeName: i = "Concierge"
}) => {
  const {
    state: a,
    isLoading: s,
    isSaving: m,
    handleEditChange: p,
    handleSave: h,
    themeColors: d,
    themeFonts: g,
    resolveColor: f,
    canSave: w
  } = V(
    e,
    { ..._i, ...o },
    no
  ), C = a.fontFamily, b = C && C !== "inherit" ? g[C] : null, y = b && b.format === "google" ? b.url : null;
  if (J(() => {
    y && Ki(y);
  }, [y]), s)
    return /* @__PURE__ */ r(G, {});
  const k = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", P = b && b.format !== "system" && b.format !== "google", x = `subtitle-${e || "default"}`, M = `
    ${P ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
    ${k !== "inherit" ? `.${x} { font-family: ${k} !important; }` : ""}
  `.trim(), v = a.textTemplate.replace("{concierge_name}", i).replace("{brand}", n), R = a.fontWeight === "normal" ? 400 : a.fontWeight === "medium" ? 500 : a.fontWeight === "semibold" ? 600 : 700, W = /* @__PURE__ */ u(G, { children: [
    M && /* @__PURE__ */ r("style", { children: M }),
    /* @__PURE__ */ r(
      "div",
      {
        className: k !== "inherit" ? x : void 0,
        style: {
          textAlign: "center",
          marginBottom: a.marginBottom,
          width: "100%"
        },
        children: /* @__PURE__ */ r(
          "p",
          {
            style: {
              fontSize: a.fontSize,
              fontWeight: R,
              color: f(a.color),
              lineHeight: a.lineHeight,
              maxWidth: a.maxWidth,
              margin: "0 auto"
            },
            children: v
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: no,
      editValues: a,
      onEditChange: p,
      onSave: w ? h : void 0,
      isSaving: m,
      themeColors: d,
      themeFonts: g,
      children: W
    }
  );
}, ea = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIxKSI+CjxwYXRoIGQ9Ik0xOC4wMDE3IDAuMDAwNjI1NjFDMjcuOTQyMyAwLjAwMDYyNTYxIDM2LjAwMjkgOC4wNTg5NSAzNi4wMDI5IDE4LjAwMTdDMzYuMDAyOSAyNy45NDQ1IDI3Ljk0NDUgMzYuMDAyOSAxOC4wMDE3IDM2LjAwMjlDOC4wNTg5NSAzNi4wMDI5IDAuMDAwNjI1NjEgMjcuOTQyMyAwLjAwMDYyNTYxIDE4LjAwMTdIMTguMDAxN1YwLjAwMDYyNTYxWiIgZmlsbD0iI0Q2OTM4QSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXIxIj4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", ta = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIyKSI+CjxwYXRoIGQ9Ik0wIDM2QzAgMjYuMDU5MiA4LjA1OTIgMTggMTggMThDMjcuOTQwOCAxOCAzNiAyNi4wNTkyIDM2IDM2SDBaIiBmaWxsPSIjOEFCMkJGIi8+CjxwYXRoIGQ9Ik0zNiAwQzM2IDkuOTQwOCAyNy45NDA4IDE4IDE4IDE4QzguMDU5MiAxOCAwIDkuOTQwOCAwIDBIMzZaIiBmaWxsPSIjOEFCMkJGIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfc3RhcnRlcjIiPgo8cmVjdCB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+", oa = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIzKSI+CjxwYXRoIGQ9Ik0wIDBMMTggMThWMEgwWiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMzYgMFYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPHBhdGggZD0iTTM2IDM2TDE4IDE4VjM2SDM2WiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMCAzNlYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF9zdGFydGVyMyI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=", ra = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXI0KSI+CjxwYXRoIGQ9Ik0zMi41NjU4IDYuODg0NjdMMjYuNTYwOSAxNS4wODA2TDM2IDE4LjAwOUwyNi41NTg3IDIwLjkyODRMMzIuNTU2OCAyOS4xMzExTDIzLjI4NTkgMjUuNjU4NEwyMy41NTI5IDM2TDE3Ljk5NDQgMjcuNDYyMkwxMi40MjkyIDM1Ljk5NTVMMTIuNzA3MyAyNS42NTM5TDMuNDMxOTkgMjkuMTE3Nkw5LjQzOTA5IDIwLjkxOTRMMCAxNy45OTFMOS40NDEzNCAxNS4wNzE2TDMuNDQzMjEgNi44NzExN0wxMi43MTQxIDEwLjM0MzlMMTIuNDQ0OSAwTDE4LjAwMzQgOC41Mzc4TDIzLjU3MDggMC4wMDQ0OTgzMUwyMy4yOTI3IDEwLjM0ODRMMzIuNTY1OCA2Ljg4NDY3WiIgZmlsbD0iIzlBNzI2MSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXI0Ij4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", na = [
  ea,
  ta,
  oa,
  ra
], ia = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, aa = {
  // Pill styling
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 28,
  pillBorderWidth: 1,
  pillBorderColor: c("#e5e7eb"),
  pillBgColor: c("transparent"),
  pillBgColorHover: c("#f3f4f6"),
  pillTextColor: T("foreground"),
  pillFontSize: 14,
  pillFontWeight: "normal",
  pillGap: 8,
  fontFamily: "inherit",
  // Card styling
  cardWidth: 183,
  cardHeight: 124,
  cardPadding: 16,
  cardBorderRadius: 12,
  cardBorderWidth: 0,
  cardBorderColor: c("#e5e7eb"),
  cardBgColor: c("#ffffff"),
  cardBgColorHover: c("#f9fafb"),
  cardTextColor: T("foreground"),
  cardFontSize: 14,
  cardGap: 12,
  cardIconSize: 32,
  // Default icons (will be replaced by bundled SVGs)
  starterIcon1: "",
  starterIcon2: "",
  starterIcon3: "",
  starterIcon4: "",
  // Container
  containerMaxWidth: 768,
  containerMarginTop: 16,
  // Mobile overrides
  mobile_pillFontSize: 13,
  mobile_cardGap: 8
}, io = [
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 28,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderColor",
    label: "Pill Border Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColor",
    label: "Pill Background",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColorHover",
    label: "Pill Bg (Hover)",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillTextColor",
    label: "Pill Text Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Pill Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  // Card styling
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 120,
    max: 240,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardHeight",
    label: "Card Height",
    type: "number",
    min: 80,
    max: 180,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColorHover",
    label: "Card Bg (Hover)",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardTextColor",
    label: "Card Text Color",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardFontSize",
    label: "Card Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 4,
    group: "Card Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardIconSize",
    label: "Card Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  // Icons
  { key: "starterIcon1", label: "Starter 1 Icon", type: "icon", group: "Icons" },
  { key: "starterIcon2", label: "Starter 2 Icon", type: "icon", group: "Icons" },
  { key: "starterIcon3", label: "Starter 3 Icon", type: "icon", group: "Icons" },
  { key: "starterIcon4", label: "Starter 4 Icon", type: "icon", group: "Icons" },
  // Typography
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // Container
  {
    key: "containerMaxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 900,
    step: 50,
    group: "Container"
  },
  {
    key: "containerMarginTop",
    label: "Margin Top",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Container"
  }
], Nl = ({
  widgetId: e = "concierge-home-starters",
  displayName: t = "Conversation Starters",
  initialState: o = {},
  mode: n,
  elementStyle: i = "default",
  cardLayoutDirection: a = "stacked",
  maxStarters: s = 4,
  queries: m,
  onSearch: p
}) => {
  const {
    state: h,
    isLoading: d,
    isSaving: g,
    handleEditChange: f,
    handleSave: w,
    themeColors: C,
    themeFonts: b,
    themeIcons: y,
    resolveColor: k,
    canSave: P
  } = V(
    e,
    { ...aa, ...o, _startersMode: n },
    io
  ), x = { ...h, _startersMode: n }, M = x.fontFamily, v = M && M !== "inherit" ? b[M] : null, R = v && v.format === "google" ? v.url : null;
  if (J(() => {
    R && ia(R);
  }, [R]), d || n === "hidden" || m.length === 0)
    return /* @__PURE__ */ r(G, {});
  const W = v ? v.format === "system" ? v.url : `"${v.name}", sans-serif` : "inherit", S = v && v.format !== "system" && v.format !== "google", H = `starters-font-${e || "default"}`, D = `
    ${S ? `
      @font-face {
        font-family: "${v.name}";
        src: url("${v.url}") format("${v.format}");
        font-display: swap;
      }
    ` : ""}
    ${W !== "inherit" ? `.${H} { font-family: ${W} !important; }` : ""}
  `.trim(), E = m.slice(0, s), O = [
    x.starterIcon1,
    x.starterIcon2,
    x.starterIcon3,
    x.starterIcon4
  ], F = (X) => {
    const U = O[X];
    return U && y[U] ? y[U].url : na[X] || null;
  }, L = () => {
    if (i === "grey-fill" || i === "grey-fill-stroke")
      return "#f6f8fa";
  }, Y = () => {
    if (i === "grey-fill-stroke")
      return "1px solid #e5e7eb";
    if (i === "grey-fill")
      return "none";
  }, j = (X) => X === "normal" ? 400 : X === "medium" ? 500 : X === "semibold" ? 600 : 700, B = (X, U) => {
    const ee = n === "pills-icons", re = F(U), oe = L(), q = Y();
    return /* @__PURE__ */ u(
      "button",
      {
        onClick: () => p(X),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: `${x.pillPaddingY}px ${x.pillPaddingX}px`,
          borderRadius: x.pillBorderRadius,
          border: q ?? `${x.pillBorderWidth}px solid ${k(x.pillBorderColor)}`,
          backgroundColor: oe ?? k(x.pillBgColor),
          color: k(x.pillTextColor),
          fontSize: x.pillFontSize,
          fontWeight: j(x.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          whiteSpace: "nowrap"
        },
        onMouseEnter: (Z) => {
          Z.currentTarget.style.backgroundColor = k(x.pillBgColorHover) || oe || k(x.pillBgColor);
        },
        onMouseLeave: (Z) => {
          Z.currentTarget.style.backgroundColor = oe ?? k(x.pillBgColor);
        },
        children: [
          ee && re && /* @__PURE__ */ r(
            "img",
            {
              src: re,
              alt: "",
              style: { width: 24, height: 24, objectFit: "contain", flexShrink: 0 }
            }
          ),
          X
        ]
      },
      U
    );
  }, A = (X, U) => {
    const ee = F(U), re = L(), oe = Y(), q = a === "inline";
    return /* @__PURE__ */ u(
      "button",
      {
        onClick: () => p(X),
        style: {
          display: "flex",
          flexDirection: q ? "row" : "column",
          alignItems: q ? "center" : void 0,
          gap: q ? "16px" : "12px",
          padding: x.cardPadding,
          borderRadius: x.cardBorderRadius,
          border: oe ?? (x.cardBorderWidth > 0 ? `${x.cardBorderWidth}px solid ${k(x.cardBorderColor)}` : "none"),
          backgroundColor: re ?? k(x.cardBgColor),
          color: k(x.cardTextColor),
          fontSize: x.cardFontSize,
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          width: n === "cards-grid" ? "100%" : x.cardWidth,
          minHeight: q ? void 0 : x.cardHeight,
          flexShrink: 0
        },
        onMouseEnter: (Z) => {
          Z.currentTarget.style.backgroundColor = k(x.cardBgColorHover) || re || k(x.cardBgColor);
        },
        onMouseLeave: (Z) => {
          Z.currentTarget.style.backgroundColor = re ?? k(x.cardBgColor);
        },
        children: [
          ee && /* @__PURE__ */ r(
            "img",
            {
              src: ee,
              alt: "",
              style: {
                width: x.cardIconSize,
                height: x.cardIconSize,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          /* @__PURE__ */ r("span", { style: { lineHeight: 1.4 }, children: X })
        ]
      },
      U
    );
  }, I = (X, U) => {
    const ee = F(U), re = L(), oe = Y();
    return /* @__PURE__ */ u(
      "button",
      {
        onClick: () => p(X),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          padding: `${x.pillPaddingY}px ${x.pillPaddingX}px`,
          borderRadius: x.pillBorderRadius > 20 ? 10 : x.pillBorderRadius,
          border: oe ?? `${x.pillBorderWidth}px solid ${k(x.pillBorderColor)}`,
          backgroundColor: re ?? k(x.pillBgColor),
          color: k(x.pillTextColor),
          fontSize: x.pillFontSize,
          fontWeight: j(x.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          boxSizing: "border-box"
        },
        onMouseEnter: (q) => {
          q.currentTarget.style.backgroundColor = k(x.pillBgColorHover) || re || k(x.pillBgColor);
        },
        onMouseLeave: (q) => {
          q.currentTarget.style.backgroundColor = re ?? k(x.pillBgColor);
        },
        children: [
          ee && /* @__PURE__ */ r(
            "img",
            {
              src: ee,
              alt: "",
              style: { width: 16, height: 16, objectFit: "contain", flexShrink: 0 }
            }
          ),
          X
        ]
      },
      U
    );
  }, $ = () => n === "pills" || n === "pills-icons" ? /* @__PURE__ */ r(
    "div",
    {
      style: {
        display: "flex",
        flexWrap: "wrap",
        gap: x.pillGap,
        justifyContent: "center",
        maxWidth: x.containerMaxWidth,
        margin: "0 auto",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch"
      },
      className: "concierge-home-starters-pills",
      children: E.map((X, U) => B(X, U))
    }
  ) : n === "pills-icons-list" ? /* @__PURE__ */ r(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: x.pillGap,
        maxWidth: x.containerMaxWidth,
        margin: "0 auto",
        width: "100%"
      },
      className: "concierge-home-starters-pills-list",
      children: E.map((X, U) => I(X, U))
    }
  ) : n === "cards-row" ? /* @__PURE__ */ r(
    "div",
    {
      style: {
        display: "flex",
        gap: x.cardGap,
        justifyContent: "center",
        maxWidth: x.containerMaxWidth,
        margin: "0 auto",
        flexWrap: "wrap"
      },
      className: "concierge-home-starters-cards-row",
      children: E.map((X, U) => A(X, U))
    }
  ) : n === "cards-grid" ? /* @__PURE__ */ r(
    "div",
    {
      style: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: x.cardGap,
        maxWidth: x.containerMaxWidth,
        margin: "0 auto"
      },
      className: "concierge-home-starters-cards-grid",
      children: E.map((X, U) => A(X, U))
    }
  ) : null, Q = /* @__PURE__ */ u(
    "div",
    {
      className: W !== "inherit" ? H : void 0,
      style: { marginTop: x.containerMarginTop, width: "100%" },
      children: [
        /* @__PURE__ */ r("style", { children: `
        ${D || ""}
        /* Responsive: pills become horizontally scrollable on mobile */
        @media (max-width: 767px) {
          .concierge-home-starters-pills {
            flex-wrap: nowrap !important;
            justify-content: flex-start !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            padding-bottom: 4px;
          }
          .concierge-home-starters-pills::-webkit-scrollbar {
            display: none;
          }
          /* Cards row becomes 2-column grid on mobile */
          .concierge-home-starters-cards-row {
            display: grid !important;
            grid-template-columns: repeat(2, 1fr) !important;
            gap: ${x.mobile_cardGap}px !important;
          }
          .concierge-home-starters-cards-row > button {
            width: 100% !important;
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-row > button img {
            width: 16px !important;
            height: 16px !important;
          }
          /* Cards grid stays 2-column on mobile with compact sizing */
          .concierge-home-starters-cards-grid {
            gap: ${x.mobile_cardGap}px !important;
          }
          .concierge-home-starters-cards-grid > button {
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-grid > button img {
            width: 16px !important;
            height: 16px !important;
          }
        }
      ` }),
        $()
      ]
    }
  );
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: io,
      editValues: x,
      onEditChange: f,
      onSave: P ? w : void 0,
      isSaving: g,
      themeColors: C,
      themeFonts: b,
      themeIcons: y,
      children: Q
    }
  );
}, la = {
  // Hamburger icon
  hamburgerIcon: "default",
  hamburgerIconSize: 32,
  hamburgerIconColor: T("textPrimary"),
  // Close icon
  closeIcon: "default",
  closeIconSize: 32,
  closeIconColor: T("textPrimary"),
  // Logo visibility
  showLogo: !0,
  // Layout
  navHeight: 80,
  navPaddingX: 24,
  navPaddingY: 24,
  navBgColor: c("transparent")
}, ao = [
  // Hamburger icon
  {
    key: "hamburgerIcon",
    label: "Menu Icon",
    type: "icon",
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconColor",
    label: "Color",
    type: "color",
    group: "Menu Icon"
  },
  // Close icon
  {
    key: "closeIcon",
    label: "Close Icon",
    type: "icon",
    group: "Close Icon"
  },
  {
    key: "closeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Close Icon"
  },
  {
    key: "closeIconColor",
    label: "Color",
    type: "color",
    group: "Close Icon"
  },
  // Logo visibility
  {
    key: "showLogo",
    label: "Show Logo",
    type: "toggle",
    group: "Logo"
  },
  // Layout
  {
    key: "navHeight",
    label: "Height",
    type: "number",
    min: 40,
    max: 120,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navBgColor",
    label: "Background",
    type: "color",
    group: "Layout"
  }
], Dl = ({
  widgetId: e = "concierge-home-mobile-nav",
  displayName: t = "Mobile Nav Header",
  initialState: o = {},
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeIcons: d,
    resolveColor: g,
    canSave: f
  } = V(
    e,
    { ...la, ...o },
    ao
  ), w = i.hamburgerIcon && i.hamburgerIcon !== "default" ? d[i.hamburgerIcon] : null, C = i.closeIcon && i.closeIcon !== "default" ? d[i.closeIcon] : null, b = {
    hamburgerIconUrl: w ? w.url : null,
    closeIconUrl: C ? C.url : null
  };
  if (a)
    return /* @__PURE__ */ r(G, {});
  const y = n(i, b, g);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: ao,
      editValues: i,
      onEditChange: m,
      onSave: f ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeIcons: d,
      children: y
    }
  );
}, sa = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, da = {
  // Carousel properties
  carouselGap: 15,
  itemWidth: 240,
  itemWidthMobile: 180,
  // Card container
  cardBorderColor: c("#dcdddc"),
  cardBorderRadius: 12,
  cardBgColor: c("#ffffff00"),
  cardBgColorHover: c("#F6F8FA"),
  cardPadding: 16,
  cardPaddingMobile: 10,
  // Title
  titleColor: T("textPrimary"),
  titleFontFamily: "inherit",
  titleFontSize: 14,
  titleFontWeight: 500,
  titleLineClamp: 2,
  titleLineHeight: 1.5,
  titleMarginTop: 20,
  // Price
  priceColor: T("textPrimary"),
  priceFontFamily: "inherit",
  priceFontSize: 20,
  priceFontSizeMobile: 16,
  priceFontWeight: 600,
  // Retailer icons
  retailerIconSize: 25,
  retailerIconSizeMobile: 15,
  showRetailers: !1,
  // Button
  buttonBgColor: c("#000000"),
  buttonTextColor: c("#ffffff"),
  buttonBorderRadius: 100,
  buttonFontSize: 16,
  buttonFontWeight: 600,
  buttonHeight: 42,
  // Image container
  imageMaxWidth: 190
}, lo = [
  // Carousel properties
  {
    key: "carouselGap",
    label: "Gap Between Items (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 1,
    group: "Carousel"
  },
  {
    key: "itemWidth",
    label: "Item Width (Desktop)",
    type: "number",
    min: 150,
    max: 300,
    step: 10,
    group: "Carousel"
  },
  {
    key: "itemWidthMobile",
    label: "Item Width (Mobile)",
    type: "number",
    min: 120,
    max: 220,
    step: 10,
    group: "Carousel"
  },
  // Card container
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBgColorHover",
    label: "Card Hover Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardPadding",
    label: "Card Padding (Desktop)",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardPaddingMobile",
    label: "Card Padding (Mobile)",
    type: "number",
    min: 4,
    max: 24,
    step: 2,
    group: "Card Container"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color", group: "Title" },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font",
    group: "Title"
  },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: we,
    group: "Title"
  },
  {
    key: "titleLineClamp",
    label: "Title Line Clamp",
    type: "number",
    min: 1,
    max: 5,
    step: 1,
    group: "Title"
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1,
    group: "Title"
  },
  {
    key: "titleMarginTop",
    label: "Title Margin Top (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Title"
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color", group: "Price" },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font",
    group: "Price"
  },
  {
    key: "priceFontSize",
    label: "Price Font Size (Desktop)",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontSizeMobile",
    label: "Price Font Size (Mobile)",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: At,
    group: "Price"
  },
  // Retailer icons
  {
    key: "showRetailers",
    label: "Show Retailer Icons",
    type: "toggle",
    group: "Retailer Icons"
  },
  {
    key: "retailerIconSize",
    label: "Retailer Icon Size (Desktop)",
    type: "number",
    min: 16,
    max: 40,
    step: 1,
    group: "Retailer Icons",
    condition: "showRetailers"
  },
  {
    key: "retailerIconSizeMobile",
    label: "Retailer Icon Size (Mobile)",
    type: "number",
    min: 12,
    max: 30,
    step: 1,
    group: "Retailer Icons",
    condition: "showRetailers"
  },
  // Button
  {
    key: "buttonBgColor",
    label: "Button Background",
    type: "color",
    group: "Button"
  },
  {
    key: "buttonTextColor",
    label: "Button Text Color",
    type: "color",
    group: "Button"
  },
  {
    key: "buttonBorderRadius",
    label: "Button Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Button"
  },
  {
    key: "buttonFontSize",
    label: "Button Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Button"
  },
  {
    key: "buttonFontWeight",
    label: "Button Font Weight",
    type: "options",
    options: At,
    group: "Button"
  },
  {
    key: "buttonHeight",
    label: "Button Height (px)",
    type: "number",
    min: 32,
    max: 56,
    step: 2,
    group: "Button"
  },
  // Image
  {
    key: "imageMaxWidth",
    label: "Image Max Width (px)",
    type: "number",
    min: 120,
    max: 250,
    step: 10,
    group: "Image"
  }
], ca = (e) => ({
  cardBorderColor: e.cardBorderColor,
  cardBorderRadius: e.cardBorderRadius,
  cardBgColor: e.cardBgColor,
  cardBgColorHover: e.cardBgColorHover,
  cardPadding: e.cardPadding,
  cardPaddingMobile: e.cardPaddingMobile,
  titleColor: e.titleColor,
  titleFontFamily: e.titleFontFamily,
  titleFontSize: e.titleFontSize,
  titleFontWeight: e.titleFontWeight,
  titleLineClamp: e.titleLineClamp,
  titleLineHeight: e.titleLineHeight,
  titleMarginTop: e.titleMarginTop,
  priceColor: e.priceColor,
  priceFontFamily: e.priceFontFamily,
  priceFontSize: e.priceFontSize,
  priceFontSizeMobile: e.priceFontSizeMobile,
  priceFontWeight: e.priceFontWeight,
  retailerIconSize: e.retailerIconSize,
  retailerIconSizeMobile: e.retailerIconSizeMobile,
  showRetailers: e.showRetailers,
  buttonBgColor: e.buttonBgColor,
  buttonTextColor: e.buttonTextColor,
  buttonBorderRadius: e.buttonBorderRadius,
  buttonFontSize: e.buttonFontSize,
  buttonFontWeight: e.buttonFontWeight,
  buttonHeight: e.buttonHeight,
  imageMaxWidth: e.imageMaxWidth
}), pa = (e) => ({
  carouselGap: e.carouselGap,
  itemWidth: e.itemWidth,
  itemWidthMobile: e.itemWidthMobile
}), Ol = ({ initialState: e = {}, widgetId: t, displayName: o, children: n }) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    resolveColor: g,
    canSave: f,
    getEditValues: w
  } = V(
    t,
    { ...da, ...e },
    lo
  ), C = i.titleFontFamily, b = C && C !== "inherit" ? d[C] : null, y = b && b.format === "google" ? b.url : null, k = i.priceFontFamily, P = k && k !== "inherit" ? d[k] : null, x = P && P.format === "google" ? P.url : null, M = le(() => {
    const S = [];
    return y && !S.includes(y) && S.push(y), x && !S.includes(x) && S.push(x), S;
  }, [y, x]);
  if (J(() => {
    for (const S of M)
      sa(S);
  }, [M]), a)
    return /* @__PURE__ */ r(G, {});
  const v = ca(i), R = pa(i), W = n(v, R, d, g);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: lo,
      editValues: w(),
      onEditChange: m,
      onSave: f ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      children: W
    }
  );
}, ga = {
  // Container
  containerGap: 8,
  containerMarginTop: 8,
  // Add to Bag button (primary state)
  addButtonBgColor: T("primary"),
  addButtonTextColor: T("secondary"),
  addButtonHeight: 40,
  addButtonHeightMobile: 36,
  addButtonFontSize: 14,
  addButtonFontSizeMobile: 12,
  addButtonBorderRadius: 8,
  // Added to Bag button (success state)
  addedButtonBorderColor: c("#6b7280"),
  addedButtonBorderColorHover: c("#4b5563"),
  addedButtonTextColor: c("#6b7280"),
  addedButtonBgColorHover: c("#f9fafb"),
  addedIconColor: c("#6b7280"),
  addedIconSize: 16,
  // Loading state
  loadingSpinnerColor: T("secondary"),
  loadingSpinnerSize: 14
}, so = [
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Add to Bag button
  { key: "addButtonBgColor", label: "Add Button Background", type: "color" },
  { key: "addButtonTextColor", label: "Add Button Text", type: "color" },
  {
    key: "addButtonHeight",
    label: "Add Button Height",
    type: "number",
    min: 32,
    max: 56,
    step: 2
  },
  {
    key: "addButtonHeightMobile",
    label: "Add Button Height (Mobile)",
    type: "number",
    min: 28,
    max: 48,
    step: 2
  },
  {
    key: "addButtonFontSize",
    label: "Add Button Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "addButtonFontSizeMobile",
    label: "Add Button Font Size (Mobile)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "addButtonBorderRadius",
    label: "Add Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Added to Bag button
  {
    key: "addedButtonBorderColor",
    label: "Added Button Border",
    type: "color"
  },
  {
    key: "addedButtonBorderColorHover",
    label: "Added Button Border (Hover)",
    type: "color"
  },
  { key: "addedButtonTextColor", label: "Added Button Text", type: "color" },
  {
    key: "addedButtonBgColorHover",
    label: "Added Button Bg (Hover)",
    type: "color"
  },
  { key: "addedIconColor", label: "Added Icon Color", type: "color" },
  {
    key: "addedIconSize",
    label: "Added Icon Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Loading state
  { key: "loadingSpinnerColor", label: "Loading Spinner Color", type: "color" },
  {
    key: "loadingSpinnerSize",
    label: "Loading Spinner Size",
    type: "number",
    min: 10,
    max: 24,
    step: 2
  }
], jl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    resolveColor: d,
    canSave: g
  } = V(
    t,
    { ...ga, ...e },
    so
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const f = n(i, d);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: so,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      children: f
    }
  );
}, ma = {
  // Container
  containerBgColor: T("secondary"),
  containerGap: 8,
  // Image carousel
  imageBgColor: c("#f7f7f7"),
  imagePadding: 16,
  carouselArrowSize: 28,
  carouselArrowBgColor: c("rgba(255, 255, 255, 0.9)"),
  // Title
  titleColor: T("textPrimary"),
  titleFontSize: 16,
  titleFontWeight: "semibold",
  titleLetterSpacing: 0.08,
  // Rating
  ratingStarColor: c("#ED792F"),
  ratingTextColor: T("textPrimary"),
  ratingFontSize: 14,
  // Price
  priceColor: T("textPrimary"),
  priceFontSize: 24,
  priceFontWeight: "semibold",
  priceLetterSpacing: 0.24,
  // Feature bullets
  featureTitleColor: T("textPrimary"),
  featureTitleFontSize: 16,
  featureBulletColor: T("textPrimary"),
  featureBulletFontSize: 12,
  // Primary CTA button
  primaryButtonBgColor: T("primary"),
  primaryButtonTextColor: T("secondary"),
  primaryButtonBorderRadius: 9999,
  primaryButtonHeight: 46,
  primaryButtonFontSize: 16,
  primaryButtonFontWeight: "semibold",
  // Secondary CTA button
  secondaryButtonBorderColor: T("primary"),
  secondaryButtonTextColor: T("primary"),
  secondaryButtonBorderRadius: 9999,
  secondaryButtonHeight: 46,
  secondaryButtonFontSize: 16,
  secondaryButtonFontWeight: "semibold",
  // Content section
  contentPadding: 16,
  contentGap: 16
}, co = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 24,
    step: 4
  },
  // Image carousel
  { key: "imageBgColor", label: "Image Background", type: "color" },
  {
    key: "imagePadding",
    label: "Image Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "carouselArrowSize",
    label: "Carousel Arrow Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "carouselArrowBgColor",
    label: "Carousel Arrow Background",
    type: "color"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...te]
  },
  // Rating
  { key: "ratingStarColor", label: "Rating Star Color", type: "color" },
  { key: "ratingTextColor", label: "Rating Text Color", type: "color" },
  {
    key: "ratingFontSize",
    label: "Rating Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 18,
    max: 36,
    step: 2
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...te]
  },
  // Feature bullets
  { key: "featureTitleColor", label: "Features Title Color", type: "color" },
  {
    key: "featureTitleFontSize",
    label: "Features Title Size",
    type: "number",
    min: 14,
    max: 20,
    step: 1
  },
  { key: "featureBulletColor", label: "Feature Bullet Color", type: "color" },
  {
    key: "featureBulletFontSize",
    label: "Feature Bullet Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Primary CTA button
  {
    key: "primaryButtonBgColor",
    label: "Primary Button Background",
    type: "color"
  },
  {
    key: "primaryButtonTextColor",
    label: "Primary Button Text",
    type: "color"
  },
  {
    key: "primaryButtonBorderRadius",
    label: "Primary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "primaryButtonHeight",
    label: "Primary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "primaryButtonFontSize",
    label: "Primary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Secondary CTA button
  {
    key: "secondaryButtonBorderColor",
    label: "Secondary Button Border",
    type: "color"
  },
  {
    key: "secondaryButtonTextColor",
    label: "Secondary Button Text",
    type: "color"
  },
  {
    key: "secondaryButtonBorderRadius",
    label: "Secondary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "secondaryButtonHeight",
    label: "Secondary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "secondaryButtonFontSize",
    label: "Secondary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Content section
  {
    key: "contentPadding",
    label: "Content Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "contentGap",
    label: "Content Gap",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  }
], Gl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    resolveColor: d,
    canSave: g
  } = V(
    t,
    { ...ma, ...e },
    co
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const f = n(i, d);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: co,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      children: f
    }
  );
}, ua = {
  // Card styling
  cardBgColor: T("secondary"),
  cardBorderColor: c("#DCDDDC"),
  cardBorderRadius: 8,
  cardShadowColor: T("primary"),
  cardShadowOpacity: 0.08,
  cardPadding: 12,
  // Retailer logo
  logoContainerSize: 40,
  logoContainerBgColor: c("#F6F8FA"),
  logoContainerBorderRadius: 50,
  // Card text
  cardTitleFontSize: 14,
  cardTitleFontWeight: "semibold",
  cardTitleColor: T("textPrimary"),
  cardSubtitleFontSize: 12,
  cardSubtitleColor: c("rgba(0, 0, 0, 0.7)"),
  // Card button
  cardButtonBgColor: c("#F6F8FA"),
  cardButtonTextColor: T("textPrimary"),
  cardButtonFontSize: 12,
  cardButtonBorderRadius: 18,
  cardButtonPaddingX: 14,
  cardButtonPaddingY: 4,
  // Search bar
  searchBgColor: T("secondary"),
  searchBorderColor: c("#DCDDDC"),
  searchBorderRadius: 100,
  searchHeight: 44,
  searchPlaceholderColor: c("rgba(0, 0, 0, 0.5)"),
  searchTextColor: T("textPrimary"),
  searchIconColor: c("rgba(0, 0, 0, 0.6)"),
  // Detail panel
  panelBgColor: T("secondary"),
  panelWidth: 300,
  panelBorderRadius: 10,
  panelImageHeight: 164,
  // Status colors
  statusOpenColor: T("success"),
  statusClosedColor: T("error"),
  // Section titles
  sectionTitleFontSize: 12,
  sectionTitleFontWeight: "bold",
  sectionTitleColor: T("textPrimary"),
  // Loading/empty states
  loadingBgColor: c("#F6F8FA"),
  emptyStateTextColor: c("#666666"),
  emptyStateFontSize: 14
}, po = [
  // Card styling
  { key: "cardBgColor", label: "Card Background", type: "color" },
  { key: "cardBorderColor", label: "Card Border Color", type: "color" },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  { key: "cardShadowColor", label: "Card Shadow Color", type: "color" },
  {
    key: "cardShadowOpacity",
    label: "Card Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Retailer logo
  {
    key: "logoContainerSize",
    label: "Logo Container Size",
    type: "number",
    min: 24,
    max: 56,
    step: 4
  },
  {
    key: "logoContainerBgColor",
    label: "Logo Container Background",
    type: "color"
  },
  {
    key: "logoContainerBorderRadius",
    label: "Logo Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Card text
  {
    key: "cardTitleFontSize",
    label: "Card Title Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "cardTitleFontWeight",
    label: "Card Title Weight",
    type: "options",
    options: [...te]
  },
  { key: "cardTitleColor", label: "Card Title Color", type: "color" },
  {
    key: "cardSubtitleFontSize",
    label: "Card Subtitle Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  { key: "cardSubtitleColor", label: "Card Subtitle Color", type: "color" },
  // Card button
  { key: "cardButtonBgColor", label: "Card Button Background", type: "color" },
  { key: "cardButtonTextColor", label: "Card Button Text", type: "color" },
  {
    key: "cardButtonFontSize",
    label: "Card Button Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "cardButtonBorderRadius",
    label: "Card Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingX",
    label: "Card Button Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingY",
    label: "Card Button Padding Y",
    type: "number",
    min: 2,
    max: 12,
    step: 2
  },
  // Search bar
  { key: "searchBgColor", label: "Search Background", type: "color" },
  { key: "searchBorderColor", label: "Search Border Color", type: "color" },
  {
    key: "searchBorderRadius",
    label: "Search Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "searchHeight",
    label: "Search Height",
    type: "number",
    min: 36,
    max: 56,
    step: 2
  },
  {
    key: "searchPlaceholderColor",
    label: "Search Placeholder Color",
    type: "color"
  },
  { key: "searchTextColor", label: "Search Text Color", type: "color" },
  { key: "searchIconColor", label: "Search Icon Color", type: "color" },
  // Detail panel
  { key: "panelBgColor", label: "Panel Background", type: "color" },
  {
    key: "panelWidth",
    label: "Panel Width",
    type: "number",
    min: 240,
    max: 400,
    step: 20
  },
  {
    key: "panelBorderRadius",
    label: "Panel Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "panelImageHeight",
    label: "Panel Image Height",
    type: "number",
    min: 100,
    max: 240,
    step: 10
  },
  // Status colors
  { key: "statusOpenColor", label: "Status Open Color", type: "color" },
  { key: "statusClosedColor", label: "Status Closed Color", type: "color" },
  // Section titles
  {
    key: "sectionTitleFontSize",
    label: "Section Title Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "sectionTitleFontWeight",
    label: "Section Title Weight",
    type: "options",
    options: [...te]
  },
  { key: "sectionTitleColor", label: "Section Title Color", type: "color" },
  // Loading/empty states
  { key: "loadingBgColor", label: "Loading Background", type: "color" },
  { key: "emptyStateTextColor", label: "Empty State Text", type: "color" },
  {
    key: "emptyStateFontSize",
    label: "Empty State Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  }
], Yl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    resolveColor: d,
    canSave: g
  } = V(
    t,
    { ...ua, ...e },
    po
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const f = n(i, d);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: po,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      children: f
    }
  );
}, ha = {
  // Container
  maxWidth: 600,
  paddingX: 16,
  paddingY: 16,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 18,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 16,
  // Order card
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Order info
  orderIdFontSize: 14,
  orderIdFontWeight: "semibold",
  orderIdColor: "#1a1a1a",
  orderDateFontSize: 13,
  orderDateColor: "#6b7280",
  orderStatusFontSize: 12,
  // Item styling
  itemImageSize: 48,
  itemTitleFontSize: 14,
  itemTitleColor: "#1a1a1a",
  itemPriceFontSize: 14,
  itemPriceColor: "#374151",
  // Total
  totalFontSize: 15,
  totalFontWeight: "semibold",
  totalColor: "#1a1a1a",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, ot = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, ar = (e) => `$${e.toFixed(2)}`, ya = (e) => new Date(e).toLocaleDateString("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric"
}), ba = ({ size: e, color: t }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ r("path", { d: "M16.5 9.4L7.5 4.21M21 16V8C20.9996 7.6481 20.9071 7.3024 20.7315 6.99847C20.556 6.69454 20.3037 6.44327 20 6.27L13 2.27C12.696 2.09674 12.3511 2.0053 12 2.0053C11.6489 2.0053 11.304 2.09674 11 2.27L4 6.27C3.69626 6.44327 3.44398 6.69454 3.26846 6.99847C3.09294 7.3024 3.00036 7.6481 3 8V16C3.00036 16.3519 3.09294 16.6976 3.26846 17.0015C3.44398 17.3055 3.69626 17.5567 4 17.73L11 21.73C11.304 21.9033 11.6489 21.9947 12 21.9947C12.3511 21.9947 12.696 21.9033 13 21.73L20 17.73C20.3037 17.5567 20.556 17.3055 20.7315 17.0015C20.9071 16.6976 20.9996 16.3519 21 16Z", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M3.27002 6.96L12 12.01L20.73 6.96", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M12 22.08V12", strokeLinecap: "round", strokeLinejoin: "round" })
] }), go = ({ size: e, color: t }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ r("path", { d: "M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M3 6H21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10", strokeLinecap: "round", strokeLinejoin: "round" })
] }), fa = ({ item: e, state: t, onClick: o }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: o,
    style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      cursor: o ? "pointer" : "default"
    },
    children: [
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.itemImageSize,
            height: t.itemImageSize,
            borderRadius: 8,
            overflow: "hidden",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: e.imageUrl ? /* @__PURE__ */ r(
            "img",
            {
              src: e.imageUrl,
              alt: e.title || e.retailerSku,
              style: { width: "100%", height: "100%", objectFit: "cover" }
            }
          ) : /* @__PURE__ */ r(ba, { size: t.itemImageSize * 0.5, color: "#9ca3af" })
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.itemTitleFontSize,
              color: t.itemTitleColor,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: e.title || e.retailerSku
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            style: {
              display: "flex",
              gap: 8,
              fontSize: t.itemPriceFontSize,
              color: t.itemPriceColor
            },
            children: [
              /* @__PURE__ */ r("span", { children: ar(e.price) }),
              /* @__PURE__ */ u("span", { children: [
                "× ",
                e.quantity
              ] })
            ]
          }
        )
      ] })
    ]
  }
), xa = ({ order: e, state: t, onOrderClick: o, onItemClick: n }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: o,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: o ? "pointer" : "default"
    },
    children: [
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 12
          },
          children: [
            /* @__PURE__ */ u("div", { children: [
              /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    fontSize: t.orderIdFontSize,
                    fontWeight: ot(t.orderIdFontWeight),
                    color: t.orderIdColor
                  },
                  children: [
                    "Order #",
                    e.orderId.slice(-8).toUpperCase()
                  ]
                }
              ),
              e.retailerName && /* @__PURE__ */ r("div", { style: { fontSize: t.orderDateFontSize, color: t.orderDateColor, marginTop: 2 }, children: e.retailerName })
            ] }),
            /* @__PURE__ */ u("div", { style: { textAlign: "right" }, children: [
              /* @__PURE__ */ r("div", { style: { fontSize: t.orderDateFontSize, color: t.orderDateColor }, children: ya(e.orderDate) }),
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    fontSize: t.orderStatusFontSize,
                    color: e.status === "delivered" ? "#10b981" : "#f59e0b",
                    marginTop: 2,
                    textTransform: "capitalize"
                  },
                  children: e.status
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: 10 }, children: [
        e.items.slice(0, 2).map((i, a) => /* @__PURE__ */ r(
          fa,
          {
            item: i,
            state: t,
            onClick: n ? () => n(i) : void 0
          },
          a
        )),
        e.items.length > 2 && /* @__PURE__ */ u("div", { style: { fontSize: t.itemTitleFontSize, color: t.orderDateColor }, children: [
          "+",
          e.items.length - 2,
          " more item",
          e.items.length - 2 !== 1 ? "s" : ""
        ] })
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${t.cardBorderColor}`
          },
          children: [
            /* @__PURE__ */ r("span", { style: { fontSize: t.totalFontSize, color: t.orderDateColor }, children: "Total" }),
            /* @__PURE__ */ r(
              "span",
              {
                style: {
                  fontSize: t.totalFontSize,
                  fontWeight: ot(t.totalFontWeight),
                  color: t.totalColor
                },
                children: ar(e.totalAmount)
              }
            )
          ]
        }
      )
    ]
  }
), $l = ({
  widgetId: e,
  orders: t,
  isAuthenticated: o = !0,
  isLoading: n = !1,
  error: i,
  onOrderClick: a,
  onItemClick: s,
  emptyMessage: m = "No orders yet",
  className: p,
  children: h
}) => {
  const { state: d } = V(
    e,
    ha,
    []
    // No edit fields for now
  );
  return h ? /* @__PURE__ */ r(G, { children: h(d, t) }) : n ? /* @__PURE__ */ r(
    "div",
    {
      className: p,
      style: {
        maxWidth: d.maxWidth,
        padding: `${d.paddingY}px ${d.paddingX}px`,
        textAlign: "center"
      },
      children: /* @__PURE__ */ r("div", { style: { fontSize: d.emptyTextFontSize, color: d.emptyTextColor }, children: "Loading orders..." })
    }
  ) : i ? /* @__PURE__ */ r(
    "div",
    {
      className: p,
      style: {
        maxWidth: d.maxWidth,
        padding: `${d.paddingY}px ${d.paddingX}px`,
        textAlign: "center"
      },
      children: /* @__PURE__ */ r("div", { style: { fontSize: d.emptyTextFontSize, color: "#ef4444" }, children: i })
    }
  ) : o ? t.length === 0 ? /* @__PURE__ */ u(
    "div",
    {
      className: p,
      style: {
        maxWidth: d.maxWidth,
        padding: `${d.paddingY}px ${d.paddingX}px`,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ r(go, { size: d.emptyIconSize, color: d.emptyTextColor }),
        /* @__PURE__ */ r("div", { style: { fontSize: d.emptyTextFontSize, color: d.emptyTextColor, marginTop: 12 }, children: m })
      ]
    }
  ) : /* @__PURE__ */ u(
    "div",
    {
      className: p,
      style: {
        maxWidth: d.maxWidth,
        padding: `${d.paddingY}px ${d.paddingX}px`,
        backgroundColor: d.backgroundColor,
        borderRadius: d.borderRadius
      },
      children: [
        /* @__PURE__ */ u(
          "h3",
          {
            style: {
              fontSize: d.headerFontSize,
              fontWeight: ot(d.headerFontWeight),
              color: d.headerColor,
              marginBottom: d.headerMarginBottom,
              margin: 0,
              marginBlockEnd: d.headerMarginBottom
            },
            children: [
              t.length,
              " Order",
              t.length !== 1 ? "s" : ""
            ]
          }
        ),
        /* @__PURE__ */ r("div", { style: { display: "flex", flexDirection: "column", gap: d.cardGap }, children: t.map((g) => /* @__PURE__ */ r(
          xa,
          {
            order: g,
            state: d,
            onOrderClick: a ? () => a(g) : void 0,
            onItemClick: s ? (f) => s(f, g) : void 0
          },
          g.orderId
        )) })
      ]
    }
  ) : /* @__PURE__ */ u(
    "div",
    {
      className: p,
      style: {
        maxWidth: d.maxWidth,
        padding: `${d.paddingY}px ${d.paddingX}px`,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ r(go, { size: d.emptyIconSize, color: d.emptyTextColor }),
        /* @__PURE__ */ r("div", { style: { fontSize: d.emptyTextFontSize, color: d.emptyTextColor, marginTop: 12 }, children: "Please login to view your order history" })
      ]
    }
  );
}, Ca = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 12,
  cardGap: 12,
  // Product image
  imageSize: 64,
  imageBorderRadius: 8,
  // Content
  titleFontSize: 14,
  titleFontWeight: "medium",
  titleColor: "#1a1a1a",
  brandNameFontSize: 12,
  brandNameColor: "#6b7280",
  // Price
  priceFontSize: 14,
  priceColor: "#1a1a1a",
  // Reward badge
  rewardFontSize: 13,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Urgency badge
  urgencyFontSize: 11,
  urgencyColor: "#dc2626",
  urgencyBgColor: "#fef2f2",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, ka = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], mo = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Image
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 48,
    max: 120,
    step: 8,
    group: "Image"
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Image"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: ka,
    group: "Title"
  },
  // Brand
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  }
], rt = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, nt = (e) => `$${e.toFixed(2)}`, va = ({
  size: e,
  color: t
}) => /* @__PURE__ */ r(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), wa = ({ deal: e, state: t, onClick: o }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: o,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: o ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      o && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.imageUrl && /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.imageSize,
            height: t.imageSize,
            borderRadius: t.imageBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ r(
            "img",
            {
              src: e.imageUrl,
              alt: e.title,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.brandNameFontSize,
              color: t.brandNameColor,
              marginBottom: 2
            },
            children: e.brandName
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: rt(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: 4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.title
          }
        ),
        e.price && /* @__PURE__ */ r("div", { style: { fontSize: t.priceFontSize, color: t.priceColor }, children: nt(e.price) }),
        e.retailerName && /* @__PURE__ */ u(
          "div",
          {
            style: {
              fontSize: t.brandNameFontSize,
              color: t.brandNameColor,
              marginTop: 4
            },
            children: [
              "at ",
              e.retailerName
            ]
          }
        )
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 6,
            flexShrink: 0
          },
          children: [
            /* @__PURE__ */ u(
              "div",
              {
                style: {
                  fontSize: t.rewardFontSize,
                  fontWeight: rt(t.rewardFontWeight),
                  color: t.rewardColor,
                  backgroundColor: t.rewardBgColor,
                  padding: "6px 10px",
                  borderRadius: t.rewardBorderRadius,
                  whiteSpace: "nowrap"
                },
                children: [
                  "+",
                  nt(e.rewardAmount)
                ]
              }
            ),
            (e.isLimitedQuantity || e.expiresAt) && /* @__PURE__ */ r(
              "div",
              {
                style: {
                  fontSize: t.urgencyFontSize,
                  color: t.urgencyColor,
                  backgroundColor: t.urgencyBgColor,
                  padding: "3px 8px",
                  borderRadius: 4,
                  whiteSpace: "nowrap"
                },
                children: e.isLimitedQuantity ? "🔥 Limited" : "⏰ Limited Time"
              }
            )
          ]
        }
      )
    ]
  }
), Ql = ({
  widgetId: e,
  displayName: t = "Daily Deals",
  deals: o,
  isLoading: n = !1,
  error: i,
  onDealClick: a,
  headerText: s,
  showHeader: m = !0,
  emptyMessage: p = "No daily deals available right now",
  className: h,
  children: d
}) => {
  const {
    state: g,
    handleEditChange: f,
    handleSave: w,
    isSaving: C,
    themeColors: b,
    themeFonts: y,
    canSave: k
  } = V(
    e,
    Ca,
    mo
  );
  if (d)
    return /* @__PURE__ */ r(G, { children: d(g, o) });
  if (n)
    return /* @__PURE__ */ r(
      "div",
      {
        className: h,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: g.emptyTextFontSize,
              color: g.emptyTextColor
            },
            children: "Finding today's deals..."
          }
        )
      }
    );
  if (i)
    return /* @__PURE__ */ r(
      "div",
      {
        className: h,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: g.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (o.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: h,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ r(va, { size: g.emptyIconSize, color: g.emptyTextColor }),
          /* @__PURE__ */ r(
            "div",
            {
              style: {
                fontSize: g.emptyTextFontSize,
                color: g.emptyTextColor,
                marginTop: 12
              },
              children: p
            }
          )
        ]
      }
    );
  const P = o.reduce((v, R) => v + R.rewardAmount, 0), x = s || `${o.length} Daily Deal${o.length !== 1 ? "s" : ""} (${nt(P)} cashback)`, M = /* @__PURE__ */ u(
    "div",
    {
      className: h,
      style: {
        maxWidth: g.maxWidth,
        padding: `${g.paddingY}px ${g.paddingX}px`,
        backgroundColor: g.backgroundColor,
        borderRadius: g.borderRadius
      },
      children: [
        m && /* @__PURE__ */ r(
          "h3",
          {
            style: {
              fontSize: g.headerFontSize,
              fontWeight: rt(g.headerFontWeight),
              color: g.headerColor,
              marginBottom: g.headerMarginBottom,
              margin: 0,
              marginBlockEnd: g.headerMarginBottom
            },
            children: x
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            style: { display: "flex", flexDirection: "column", gap: g.cardGap },
            children: o.map((v) => /* @__PURE__ */ r(
              wa,
              {
                deal: v,
                state: g,
                onClick: a ? () => a(v) : void 0
              },
              v.stacklineSku
            ))
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: mo,
      editValues: g,
      onEditChange: f,
      onSave: k ? w : void 0,
      isSaving: C,
      themeColors: b,
      themeFonts: y,
      children: M
    }
  );
}, lr = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Brand logo
  brandLogoSize: 48,
  brandLogoBorderRadius: 8,
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#181d56",
  // Brandclub primary color
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Meta info
  metaFontSize: 12,
  metaColor: "#9ca3af",
  // Reward badge
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Survey badge
  surveyBadgeFontSize: 11,
  surveyBadgeColor: "#1d4ed8",
  surveyBadgeBgColor: "#dbeafe",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Sa = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], uo = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Brand logo
  {
    key: "brandLogoSize",
    label: "Logo Size",
    type: "number",
    min: 32,
    max: 80,
    step: 4,
    group: "Logo"
  },
  {
    key: "brandLogoBorderRadius",
    label: "Logo Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Logo"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Sa,
    group: "Title"
  },
  // Brand name
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  },
  // Survey badge
  {
    key: "surveyBadgeColor",
    label: "Badge Text Color",
    type: "color",
    group: "Badge"
  },
  {
    key: "surveyBadgeBgColor",
    label: "Badge Background",
    type: "color",
    group: "Badge"
  }
], it = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, sr = (e) => `$${e.toFixed(2)}`, Ba = ({ size: e, color: t }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ r("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("rect", { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M9 12h6", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M9 16h6", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Fa = ({ survey: e, state: t, onClick: o }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: o,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: o ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      o && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      (e.previewImageUrl || e.brandLogoUrl) && /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.brandLogoSize,
            height: t.brandLogoSize,
            borderRadius: t.brandLogoBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ r(
            "img",
            {
              src: e.previewImageUrl || e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }, children: [
          /* @__PURE__ */ r(
            "span",
            {
              style: {
                fontSize: t.surveyBadgeFontSize,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 4,
                backgroundColor: t.surveyBadgeBgColor,
                color: t.surveyBadgeColor,
                whiteSpace: "nowrap"
              },
              children: "📋 Survey"
            }
          ),
          /* @__PURE__ */ r("span", { style: { fontSize: t.brandNameFontSize, color: t.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: it(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        /* @__PURE__ */ u("div", { style: { display: "flex", gap: 12, marginTop: 6 }, children: [
          e.estimatedMinutes && /* @__PURE__ */ u("span", { style: { fontSize: t.metaFontSize, color: t.metaColor }, children: [
            "~",
            e.estimatedMinutes,
            " min"
          ] }),
          e.questionCount && /* @__PURE__ */ u("span", { style: { fontSize: t.metaFontSize, color: t.metaColor }, children: [
            e.questionCount,
            " questions"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            fontWeight: it(t.rewardFontWeight),
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "6px 10px",
            borderRadius: t.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            sr(e.rewardAmount)
          ]
        }
      )
    ]
  }
), Xl = ({
  widgetId: e,
  displayName: t = "Surveys",
  surveys: o,
  isLoading: n = !1,
  error: i,
  onSurveyClick: a,
  headerText: s,
  showHeader: m = !0,
  emptyMessage: p = "No surveys available right now",
  className: h,
  children: d
}) => {
  const {
    state: g,
    handleEditChange: f,
    handleSave: w,
    isSaving: C,
    themeColors: b,
    themeFonts: y,
    canSave: k
  } = V(
    e,
    lr,
    uo
  );
  if (d)
    return /* @__PURE__ */ r(G, { children: d(g, o) });
  if (n)
    return /* @__PURE__ */ r(
      "div",
      {
        className: h,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: g.emptyTextFontSize, color: g.emptyTextColor }, children: "Finding available surveys..." })
      }
    );
  if (i)
    return /* @__PURE__ */ r(
      "div",
      {
        className: h,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: g.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (o.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: h,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ r(Ba, { size: g.emptyIconSize, color: g.emptyTextColor }),
          /* @__PURE__ */ r("div", { style: { fontSize: g.emptyTextFontSize, color: g.emptyTextColor, marginTop: 12 }, children: p })
        ]
      }
    );
  const P = o.reduce((v, R) => v + R.rewardAmount, 0), x = s || `${o.length} Survey${o.length !== 1 ? "s" : ""} (${sr(P)} potential)`, M = /* @__PURE__ */ u(
    "div",
    {
      className: h,
      style: {
        maxWidth: g.maxWidth,
        padding: `${g.paddingY}px ${g.paddingX}px`,
        backgroundColor: g.backgroundColor,
        borderRadius: g.borderRadius
      },
      children: [
        m && /* @__PURE__ */ r(
          "h3",
          {
            style: {
              fontSize: g.headerFontSize,
              fontWeight: it(g.headerFontWeight),
              color: g.headerColor,
              marginBottom: g.headerMarginBottom,
              margin: 0,
              marginBlockEnd: g.headerMarginBottom
            },
            children: x
          }
        ),
        /* @__PURE__ */ r("div", { style: { display: "flex", flexDirection: "column", gap: g.cardGap }, children: o.map((v) => /* @__PURE__ */ r(
          Fa,
          {
            survey: v,
            state: g,
            onClick: a ? () => a(v) : void 0
          },
          v.campaignId
        )) })
      ]
    }
  );
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: e,
      displayName: t,
      editFields: uo,
      editValues: g,
      onEditChange: f,
      onSave: k ? w : void 0,
      isSaving: C,
      themeColors: b,
      themeFonts: y,
      children: M
    }
  );
}, Ia = "#181d56", ho = {
  bg: "rgba(162, 34, 114, 0.3)",
  text: "rgb(162, 34, 114)"
}, za = "https://media.brandclub.com/brandclub/image_asset/survey-reward-icon.webp", Pa = (e) => `$${e.toFixed(2)}`, Ta = (e) => `https://media.brandclub.com/b/428x428/${e}.jpg`, Ma = ({
  size: e = 40,
  color: t = "#9ca3af"
}) => /* @__PURE__ */ u(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r(
        "path",
        {
          d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M9 12H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M9 16H13",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), Jl = ({
  survey: e,
  state: t,
  onClick: o,
  className: n,
  width: i = 280
}) => {
  const [a, s] = N(!1);
  ({ ...lr, ...t });
  const m = () => {
    o ? o() : window.location.href = `/survey/${e.campaignId}`;
  }, p = e.brandLogoUrl || (e.brandId ? Ta(e.brandId) : void 0), h = !!p;
  return /* @__PURE__ */ u(
    "div",
    {
      className: n,
      onClick: m,
      onMouseEnter: () => s(!0),
      onMouseLeave: () => s(!1),
      style: {
        width: typeof i == "number" ? `${i}px` : i,
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: a ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
        display: "flex",
        flexDirection: "column"
      },
      children: [
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              height: 160,
              backgroundColor: "#ffffff",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20
            },
            children: h ? /* @__PURE__ */ r(
              "img",
              {
                src: p,
                alt: e.brandName,
                style: {
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain"
                }
              }
            ) : /* @__PURE__ */ r(Ma, { size: 48, color: "#d1d5db" })
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            style: {
              padding: 16,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f9fafb"
            },
            children: [
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    fontSize: 15,
                    fontWeight: 600,
                    color: Ia,
                    lineHeight: 1.4,
                    marginBottom: 6,
                    height: 42,
                    // Fixed height for 2 lines (15px * 1.4 * 2)
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.title
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    fontSize: 13,
                    color: "#6b7280",
                    lineHeight: 1.5,
                    marginBottom: 12,
                    height: 20,
                    // Fixed height for 1 line
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.description || `Share your feedback with ${e.brandName}.`
                }
              ),
              /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 7
                  },
                  children: [
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          backgroundColor: ho.bg,
                          color: ho.text,
                          borderRadius: 25,
                          padding: "5px 13px",
                          fontSize: 14,
                          fontWeight: 600
                        },
                        children: [
                          /* @__PURE__ */ r(
                            "img",
                            {
                              src: za,
                              alt: "survey-reward-icon",
                              style: {
                                width: 14,
                                height: 14,
                                objectFit: "contain"
                              }
                            }
                          ),
                          /* @__PURE__ */ r("span", { children: Pa(e.rewardAmount) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ r(
                      "span",
                      {
                        style: {
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#181d56"
                        },
                        children: "survey reward"
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Ea = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Type badge
  typeBadgeFontSize: 11,
  typeBadgePaddingX: 8,
  typeBadgePaddingY: 4,
  typeBadgeBorderRadius: 4,
  surveyBadgeBgColor: "#dbeafe",
  surveyBadgeTextColor: "#1d4ed8",
  contentBadgeBgColor: "#fce7f3",
  contentBadgeTextColor: "#be185d",
  membershipBadgeBgColor: "#d1fae5",
  membershipBadgeTextColor: "#047857",
  reviewBadgeBgColor: "#fef3c7",
  reviewBadgeTextColor: "#b45309",
  referralBadgeBgColor: "#e0e7ff",
  referralBadgeTextColor: "#4338ca",
  affiliateBadgeBgColor: "#f3e8ff",
  affiliateBadgeTextColor: "#7c3aed",
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Reward amount
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Brand logo
  brandLogoSize: 40,
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, at = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, dr = (e) => `$${e.toFixed(2)}`, Aa = {
  survey: "📋 Survey",
  content: "🎬 Content",
  membership: "🏆 Club",
  review: "⭐ Review",
  referral: "👥 Referral",
  affiliate: "🔗 Affiliate"
}, Wa = ({ size: e, color: t }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ r("rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M12 8V21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M19 12V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V12", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M7.5 8C6.67157 8 6 7.32843 6 6.5C6 5.67157 6.67157 5 7.5 5C9.5 5 12 8 12 8C12 8 14.5 5 16.5 5C17.3284 5 18 5.67157 18 6.5C18 7.32843 17.3284 8 16.5 8", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Ra = ({ type: e, state: t }) => {
  const n = ((i) => {
    switch (i) {
      case "survey":
        return { bg: t.surveyBadgeBgColor, text: t.surveyBadgeTextColor };
      case "content":
        return { bg: t.contentBadgeBgColor, text: t.contentBadgeTextColor };
      case "membership":
        return { bg: t.membershipBadgeBgColor, text: t.membershipBadgeTextColor };
      case "review":
        return { bg: t.reviewBadgeBgColor, text: t.reviewBadgeTextColor };
      case "referral":
        return { bg: t.referralBadgeBgColor, text: t.referralBadgeTextColor };
      case "affiliate":
        return { bg: t.affiliateBadgeBgColor, text: t.affiliateBadgeTextColor };
      default:
        return { bg: "#f3f4f6", text: "#374151" };
    }
  })(e);
  return /* @__PURE__ */ r(
    "span",
    {
      style: {
        fontSize: t.typeBadgeFontSize,
        fontWeight: 600,
        padding: `${t.typeBadgePaddingY}px ${t.typeBadgePaddingX}px`,
        borderRadius: t.typeBadgeBorderRadius,
        backgroundColor: n.bg,
        color: n.text,
        whiteSpace: "nowrap"
      },
      children: Aa[e] || e
    }
  );
}, La = ({ opportunity: e, state: t, onClick: o }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: o,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: o ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      o && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.brandLogoUrl && /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.brandLogoSize,
            height: t.brandLogoSize,
            borderRadius: 8,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ r(
            "img",
            {
              src: e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }, children: [
          /* @__PURE__ */ r(Ra, { type: e.type, state: t }),
          /* @__PURE__ */ r("span", { style: { fontSize: t.brandNameFontSize, color: t.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: at(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ r(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        e.estimatedMinutes && /* @__PURE__ */ u(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              marginTop: 4
            },
            children: [
              "~",
              e.estimatedMinutes,
              " min"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            fontWeight: at(t.rewardFontWeight),
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "6px 10px",
            borderRadius: t.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            dr(e.rewardAmount)
          ]
        }
      )
    ]
  }
), Zl = ({
  widgetId: e,
  opportunities: t,
  isLoading: o = !1,
  error: n,
  onOpportunityClick: i,
  headerText: a,
  showHeader: s = !0,
  emptyMessage: m = "No reward opportunities available",
  className: p,
  children: h
}) => {
  const { state: d } = V(
    e,
    Ea,
    []
    // No edit fields for now
  );
  if (h)
    return /* @__PURE__ */ r(G, { children: h(d, t) });
  if (o)
    return /* @__PURE__ */ r(
      "div",
      {
        className: p,
        style: {
          maxWidth: d.maxWidth,
          padding: `${d.paddingY}px ${d.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: d.emptyTextFontSize, color: d.emptyTextColor }, children: "Finding reward opportunities..." })
      }
    );
  if (n)
    return /* @__PURE__ */ r(
      "div",
      {
        className: p,
        style: {
          maxWidth: d.maxWidth,
          padding: `${d.paddingY}px ${d.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: d.emptyTextFontSize, color: "#ef4444" }, children: n })
      }
    );
  if (t.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: p,
        style: {
          maxWidth: d.maxWidth,
          padding: `${d.paddingY}px ${d.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ r(Wa, { size: d.emptyIconSize, color: d.emptyTextColor }),
          /* @__PURE__ */ r("div", { style: { fontSize: d.emptyTextFontSize, color: d.emptyTextColor, marginTop: 12 }, children: m })
        ]
      }
    );
  const g = t.reduce((w, C) => w + C.rewardAmount, 0), f = a || `${t.length} Reward Opportunity${t.length !== 1 ? "s" : ""} (${dr(g)} potential)`;
  return /* @__PURE__ */ u(
    "div",
    {
      className: p,
      style: {
        maxWidth: d.maxWidth,
        padding: `${d.paddingY}px ${d.paddingX}px`,
        backgroundColor: d.backgroundColor,
        borderRadius: d.borderRadius
      },
      children: [
        s && /* @__PURE__ */ r(
          "h3",
          {
            style: {
              fontSize: d.headerFontSize,
              fontWeight: at(d.headerFontWeight),
              color: d.headerColor,
              marginBottom: d.headerMarginBottom,
              margin: 0,
              marginBlockEnd: d.headerMarginBottom
            },
            children: f
          }
        ),
        /* @__PURE__ */ r("div", { style: { display: "flex", flexDirection: "column", gap: d.cardGap }, children: t.map((w) => /* @__PURE__ */ r(
          La,
          {
            opportunity: w,
            state: d,
            onClick: i ? () => i(w) : void 0
          },
          w.id || w.campaignId || `${w.type}-${w.title}`
        )) })
      ]
    }
  );
}, Ha = {
  // Container
  maxWidth: 900,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 18,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 16,
  // Product card
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 12,
  cardGap: 12,
  // Product image
  imageSize: 120,
  imageBorderRadius: 8,
  // Product title
  titleFontSize: 14,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  titleMaxLines: 2,
  // Brand name
  brandFontSize: 12,
  brandColor: "#6b7280",
  // Price
  priceFontSize: 16,
  priceFontWeight: "bold",
  priceColor: "#1a1a1a",
  // Reward
  rewardFontSize: 12,
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  // Rating
  ratingStarSize: 14,
  ratingStarColor: "#f59e0b",
  ratingStarEmptyColor: "#d1d5db",
  ratingTextFontSize: 12,
  ratingTextColor: "#6b7280",
  // Comparison table
  rowBgColor: "#ffffff",
  rowBgColorAlt: "#f9fafb",
  rowBorderColor: "#e5e7eb",
  labelFontSize: 13,
  labelFontWeight: "medium",
  labelColor: "#374151",
  valueFontSize: 13,
  valueColor: "#1a1a1a",
  // Highlight
  highlightBgColor: "#ecfdf5",
  highlightBorderColor: "#10b981",
  // Empty state
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Oe = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, lt = (e) => `$${e.toFixed(2)}`, Na = ({ rating: e, maxRating: t = 5, starSize: o, starColor: n, emptyColor: i }) => {
  const a = [];
  for (let s = 1; s <= t; s++) {
    const m = Math.min(Math.max(e - s + 1, 0), 1) * 100;
    a.push(
      /* @__PURE__ */ u("svg", { width: o, height: o, viewBox: "0 0 24 24", children: [
        /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ u("linearGradient", { id: `star-fill-${s}-${e}`, children: [
          /* @__PURE__ */ r("stop", { offset: `${m}%`, stopColor: n }),
          /* @__PURE__ */ r("stop", { offset: `${m}%`, stopColor: i })
        ] }) }),
        /* @__PURE__ */ r(
          "path",
          {
            fill: `url(#star-fill-${s}-${e})`,
            d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          }
        )
      ] }, s)
    );
  }
  return /* @__PURE__ */ r("div", { style: { display: "flex", gap: 2 }, children: a });
}, Da = ({ size: e, color: t }) => /* @__PURE__ */ r("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "1.5", children: /* @__PURE__ */ r("path", { d: "M16.5 9.4L7.5 4.21M21 16V8C20.9996 7.6481 20.9071 7.3024 20.7315 6.99847C20.556 6.69454 20.3037 6.44327 20 6.27L13 2.27C12.696 2.09674 12.3511 2.0053 12 2.0053C11.6489 2.0053 11.304 2.09674 11 2.27L4 6.27C3.69626 6.44327 3.44398 6.69454 3.26846 6.99847C3.09294 7.3024 3.00036 7.6481 3 8V16C3.00036 16.3519 3.09294 16.6976 3.26846 17.0015C3.44398 17.3055 3.69626 17.5567 4 17.73L11 21.73C11.304 21.9033 11.6489 21.9947 12 21.9947C12.3511 21.9947 12.696 21.9033 13 21.73L20 17.73C20.3037 17.5567 20.556 17.3055 20.7315 17.0015C20.9071 16.6976 20.9996 16.3519 21 16Z", strokeLinecap: "round", strokeLinejoin: "round" }) }), Oa = ({
  product: e,
  state: t,
  onClick: o,
  onAddToCart: n,
  showAddToCart: i
}) => /* @__PURE__ */ u(
  "div",
  {
    style: {
      flex: 1,
      minWidth: 150,
      maxWidth: 220,
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 8,
      cursor: o ? "pointer" : "default"
    },
    onClick: o,
    children: [
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            width: t.imageSize,
            height: t.imageSize,
            borderRadius: t.imageBorderRadius,
            overflow: "hidden",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: e.imageUrl ? /* @__PURE__ */ r(
            "img",
            {
              src: e.imageUrl,
              alt: e.title,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          ) : /* @__PURE__ */ r(Da, { size: t.imageSize * 0.4, color: "#9ca3af" })
        }
      ),
      e.brand && /* @__PURE__ */ r("div", { style: { fontSize: t.brandFontSize, color: t.brandColor }, children: e.brand }),
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            fontSize: t.titleFontSize,
            fontWeight: Oe(t.titleFontWeight),
            color: t.titleColor,
            textAlign: "center",
            display: "-webkit-box",
            WebkitLineClamp: t.titleMaxLines,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            lineHeight: 1.3
          },
          children: e.title
        }
      ),
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            fontSize: t.priceFontSize,
            fontWeight: Oe(t.priceFontWeight),
            color: t.priceColor
          },
          children: lt(e.price)
        }
      ),
      e.rewardAmount && e.rewardAmount > 0 && /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "4px 8px",
            borderRadius: 4
          },
          children: [
            "+",
            lt(e.rewardAmount),
            " reward"
          ]
        }
      ),
      e.reviewsRating !== void 0 && /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [
        /* @__PURE__ */ r(
          Na,
          {
            rating: e.reviewsRating,
            starSize: t.ratingStarSize,
            starColor: t.ratingStarColor,
            emptyColor: t.ratingStarEmptyColor
          }
        ),
        e.reviewsCount !== void 0 && /* @__PURE__ */ u("span", { style: { fontSize: t.ratingTextFontSize, color: t.ratingTextColor }, children: [
          "(",
          e.reviewsCount,
          ")"
        ] })
      ] }),
      i && n && /* @__PURE__ */ r(
        "button",
        {
          onClick: (a) => {
            a.stopPropagation(), n();
          },
          style: {
            marginTop: 8,
            padding: "8px 16px",
            fontSize: 13,
            fontWeight: 600,
            color: "#ffffff",
            backgroundColor: "#1a1a1a",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            width: "100%"
          },
          children: "Add to Cart"
        }
      )
    ]
  }
), ja = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((o) => {
    o.attributes && Object.keys(o.attributes).forEach((n) => t.add(n));
  }), Array.from(t).map((o) => ({
    key: o,
    label: o.charAt(0).toUpperCase() + o.slice(1).replace(/([A-Z])/g, " $1"),
    format: "text"
  }));
}, Ul = ({
  widgetId: e,
  products: t,
  attributes: o,
  isLoading: n = !1,
  error: i,
  onProductClick: a,
  onAddToCart: s,
  showAddToCart: m = !1,
  headerText: p,
  showHeader: h = !0,
  className: d,
  children: g
}) => {
  const { state: f } = V(
    e,
    Ha,
    []
    // No edit fields for now
  );
  if (g)
    return /* @__PURE__ */ r(G, { children: g(f, t) });
  if (n)
    return /* @__PURE__ */ r(
      "div",
      {
        className: d,
        style: {
          maxWidth: f.maxWidth,
          padding: `${f.paddingY}px ${f.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: f.emptyTextFontSize, color: f.emptyTextColor }, children: "Comparing products..." })
      }
    );
  if (i)
    return /* @__PURE__ */ r(
      "div",
      {
        className: d,
        style: {
          maxWidth: f.maxWidth,
          padding: `${f.paddingY}px ${f.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: f.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (t.length < 2)
    return /* @__PURE__ */ r(
      "div",
      {
        className: d,
        style: {
          maxWidth: f.maxWidth,
          padding: `${f.paddingY}px ${f.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ r("div", { style: { fontSize: f.emptyTextFontSize, color: f.emptyTextColor }, children: "At least 2 products are needed for comparison" })
      }
    );
  const w = o || ja(t), C = p || `Comparing ${t.length} Products`;
  return /* @__PURE__ */ u(
    "div",
    {
      className: d,
      style: {
        maxWidth: f.maxWidth,
        padding: `${f.paddingY}px ${f.paddingX}px`,
        backgroundColor: f.backgroundColor,
        borderRadius: f.borderRadius,
        overflowX: "auto"
      },
      children: [
        h && /* @__PURE__ */ r(
          "h3",
          {
            style: {
              fontSize: f.headerFontSize,
              fontWeight: Oe(f.headerFontWeight),
              color: f.headerColor,
              marginBottom: f.headerMarginBottom,
              margin: 0,
              marginBlockEnd: f.headerMarginBottom
            },
            children: C
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              display: "flex",
              gap: f.cardGap,
              marginBottom: w.length > 0 ? 16 : 0
            },
            children: t.map((b) => /* @__PURE__ */ r(
              Oa,
              {
                product: b,
                state: f,
                onClick: a ? () => a(b) : void 0,
                onAddToCart: s ? () => s(b) : void 0,
                showAddToCart: m
              },
              b.stacklineSku
            ))
          }
        ),
        w.length > 0 && /* @__PURE__ */ r(
          "div",
          {
            style: {
              border: `1px solid ${f.rowBorderColor}`,
              borderRadius: 8,
              overflow: "hidden"
            },
            children: w.map((b, y) => /* @__PURE__ */ u(
              "div",
              {
                style: {
                  display: "flex",
                  backgroundColor: y % 2 === 0 ? f.rowBgColor : f.rowBgColorAlt,
                  borderBottom: y < w.length - 1 ? `1px solid ${f.rowBorderColor}` : "none"
                },
                children: [
                  /* @__PURE__ */ r(
                    "div",
                    {
                      style: {
                        width: 120,
                        flexShrink: 0,
                        padding: "10px 12px",
                        fontSize: f.labelFontSize,
                        fontWeight: Oe(f.labelFontWeight),
                        color: f.labelColor,
                        borderRight: `1px solid ${f.rowBorderColor}`
                      },
                      children: b.label
                    }
                  ),
                  t.map((k) => {
                    var M;
                    const P = (M = k.attributes) == null ? void 0 : M[b.key];
                    let x = "-";
                    return P != null && (b.format === "currency" && typeof P == "number" ? x = lt(P) : b.format === "boolean" ? x = P ? "✓" : "✗" : x = String(P)), /* @__PURE__ */ r(
                      "div",
                      {
                        style: {
                          flex: 1,
                          minWidth: 150,
                          maxWidth: 220,
                          padding: "10px 12px",
                          fontSize: f.valueFontSize,
                          color: f.valueColor,
                          textAlign: "center",
                          borderRight: `1px solid ${f.rowBorderColor}`
                        },
                        children: x
                      },
                      k.stacklineSku
                    );
                  })
                ]
              },
              b.key
            ))
          }
        )
      ]
    }
  );
}, Ga = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, Ya = {
  content: "Default Text",
  fontFamily: "inherit",
  fontSize: 16,
  fontWeight: "medium",
  color: {
    type: "theme",
    value: "textPrimary"
  },
  textAlign: "left",
  lineHeight: 1.5,
  letterSpacing: 0,
  textTransform: "none"
}, yo = [
  { key: "content", label: "Text Content", type: "text" },
  { key: "fontFamily", label: "Font Family", type: "font" },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 72,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: te
  },
  { key: "color", label: "Text Color", type: "color" },
  {
    key: "textAlign",
    label: "Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 3,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  }
], Vl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o
}) => {
  const {
    state: n,
    isLoading: i,
    isSaving: a,
    handleEditChange: s,
    handleSave: m,
    themeColors: p,
    themeFonts: h,
    resolveColor: d,
    canSave: g
  } = V(
    t,
    { ...Ya, ...e },
    yo
  ), f = n.fontFamily, w = f && f !== "inherit" ? h[f] : null, C = w && w.format === "google" ? w.url : null;
  if (J(() => {
    C && Ga(C);
  }, [C]), i)
    return /* @__PURE__ */ r(G, {});
  const b = (v) => {
    const R = {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }, W = parseInt(v, 10);
    return isNaN(W) ? R[v] || 500 : W;
  }, y = w ? w.format === "system" ? w.url : `"${w.name}", sans-serif` : "inherit", k = `textbox-${t || "default"}`, x = `
    ${w && w.format !== "system" && w.format !== "google" ? `
      @font-face {
        font-family: "${w.name}";
        src: url("${w.url}") format("${w.format}");
        font-display: swap;
      }
    ` : ""}
    ${y !== "inherit" ? `.${k} { font-family: ${y} !important; }` : ""}
  `.trim(), M = /* @__PURE__ */ u(G, { children: [
    x && /* @__PURE__ */ r("style", { children: x }),
    /* @__PURE__ */ r(
      "span",
      {
        className: `textbox-content ${k}`,
        style: {
          // font-family is set via CSS class with !important, only use inline for inherit
          ...y === "inherit" ? { fontFamily: "inherit" } : {},
          fontSize: `${n.fontSize}px`,
          fontWeight: b(n.fontWeight),
          color: d(n.color),
          textAlign: n.textAlign,
          lineHeight: n.lineHeight,
          letterSpacing: `${n.letterSpacing}px`,
          textTransform: n.textTransform,
          display: "inline-block",
          width: "100%"
        },
        children: n.content
      }
    )
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: yo,
      editValues: n,
      onEditChange: s,
      onSave: g ? m : void 0,
      isSaving: a,
      themeColors: p,
      themeFonts: h,
      children: M
    }
  );
}, bo = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const o = document.createElement("link");
  o.rel = "stylesheet", o.href = e, document.head.appendChild(o);
}, $a = {
  // Instant reward (DailyDeals) - orange
  instantBgColor: c("rgba(236, 121, 46, 0.3)"),
  instantTextColor: c("rgb(236, 121, 46)"),
  // Purchase reward - magenta
  purchaseBgColor: c("rgba(162, 34, 114, 0.3)"),
  purchaseTextColor: c("rgb(162, 34, 114)"),
  // Affiliate reward - teal
  affiliateBgColor: c("rgba(22, 148, 155, 0.2)"),
  affiliateTextColor: c("rgb(22, 148, 155)"),
  // Content/Survey reward - magenta
  contentBgColor: c("rgba(162, 34, 114, 0.3)"),
  contentTextColor: c("rgb(162, 34, 114)"),
  // Pill styling
  pillBorderRadius: 25,
  pillPaddingMultiplier: 0.95,
  // Icon
  iconSizeMultiplier: 1,
  iconMarginMultiplier: 0.416,
  // Text
  pillFontWeight: "semibold",
  pillFontFamily: "inherit",
  subfixTextColor: T("textPrimary"),
  subfixFontWeight: "semibold",
  subfixFontFamily: "inherit",
  // Container
  containerGap: 7
}, fo = [
  // Instant reward
  { key: "instantBgColor", label: "Instant Reward Background", type: "color" },
  { key: "instantTextColor", label: "Instant Reward Text", type: "color" },
  // Purchase reward
  {
    key: "purchaseBgColor",
    label: "Purchase Reward Background",
    type: "color"
  },
  { key: "purchaseTextColor", label: "Purchase Reward Text", type: "color" },
  // Affiliate reward
  {
    key: "affiliateBgColor",
    label: "Affiliate Reward Background",
    type: "color"
  },
  { key: "affiliateTextColor", label: "Affiliate Reward Text", type: "color" },
  // Content/Survey reward
  { key: "contentBgColor", label: "Content Reward Background", type: "color" },
  { key: "contentTextColor", label: "Content Reward Text", type: "color" },
  // Pill styling
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillPaddingMultiplier",
    label: "Pill Padding Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.05
  },
  // Icon
  {
    key: "iconSizeMultiplier",
    label: "Icon Size Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.1
  },
  {
    key: "iconMarginMultiplier",
    label: "Icon Margin Multiplier",
    type: "number",
    min: 0.2,
    max: 0.8,
    step: 0.05
  },
  // Text
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...te]
  },
  {
    key: "pillFontFamily",
    label: "Pill Font Family",
    type: "font"
  },
  { key: "subfixTextColor", label: "Subfix Text Color", type: "color" },
  {
    key: "subfixFontWeight",
    label: "Subfix Font Weight",
    type: "options",
    options: [...te]
  },
  {
    key: "subfixFontFamily",
    label: "Subfix Font Family",
    type: "font"
  },
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  }
], ql = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    themeFonts: d,
    resolveColor: g,
    canSave: f
  } = V(
    t,
    { ...$a, ...e },
    fo
  ), w = i.pillFontFamily, C = w && w !== "inherit" ? d[w] : null, b = i.subfixFontFamily, y = b && b !== "inherit" ? d[b] : null, k = C && C.format === "google" ? C.url : null, P = y && y.format === "google" ? y.url : null;
  if (J(() => {
    k && bo(k);
  }, [k]), J(() => {
    P && bo(P);
  }, [P]), a)
    return /* @__PURE__ */ r(G, {});
  const x = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", M = y ? y.format === "system" ? y.url : `"${y.name}", sans-serif` : "inherit", v = C && C.format !== "system" && C.format !== "google", R = y && y.format !== "system" && y.format !== "google", W = `reward-pill-${t || "default"}`, S = `
    ${v ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${R ? `
      @font-face {
        font-family: "${y.name}";
        src: url("${y.url}") format("${y.format}");
        font-display: swap;
      }
    ` : ""}
    ${x !== "inherit" ? `.${W} [data-pill-text] { font-family: ${x} !important; }` : ""}
    ${M !== "inherit" ? `.${W} [data-subfix-text] { font-family: ${M} !important; }` : ""}
  `.trim(), H = {
    ...i,
    pillFontFamilyCss: x,
    subfixFontFamilyCss: M
  }, D = /* @__PURE__ */ u(G, { children: [
    S && /* @__PURE__ */ r("style", { children: S }),
    n(H, g)
  ] });
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: fo,
      editValues: i,
      onEditChange: m,
      onSave: f ? p : void 0,
      isSaving: s,
      themeColors: h,
      themeFonts: d,
      children: D
    }
  );
}, Qa = {
  // Icon size
  iconSize: 18,
  iconSizeMobile: 15,
  // Overlap and spacing
  overlapRatio: 0.46,
  counterMarginLeft: 7,
  // Border styling
  iconBorderRadius: 50,
  // percentage - 50 = circle
  // Counter text
  counterTextColor: T("textPrimary"),
  counterFontSize: 11,
  counterFontWeight: "semibold",
  // Display limits
  maxVisibleIcons: 4
}, xo = [
  // Icon size
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 32,
    step: 2
  },
  {
    key: "iconSizeMobile",
    label: "Icon Size (Mobile)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  // Overlap and spacing
  {
    key: "overlapRatio",
    label: "Overlap Ratio",
    type: "number",
    min: 0,
    max: 0.7,
    step: 0.05
  },
  {
    key: "counterMarginLeft",
    label: "Counter Margin Left",
    type: "number",
    min: 0,
    max: 16,
    step: 1
  },
  // Border styling
  {
    key: "iconBorderRadius",
    label: "Icon Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Counter text
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 8,
    max: 16,
    step: 1
  },
  {
    key: "counterFontWeight",
    label: "Counter Font Weight",
    type: "options",
    options: [...te]
  },
  // Display limits
  {
    key: "maxVisibleIcons",
    label: "Max Visible Icons",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  }
], Kl = ({
  initialState: e = {},
  widgetId: t,
  displayName: o,
  children: n
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: s,
    handleEditChange: m,
    handleSave: p,
    themeColors: h,
    resolveColor: d,
    canSave: g
  } = V(
    t,
    { ...Qa, ...e },
    xo
  );
  if (a)
    return /* @__PURE__ */ r(G, {});
  const f = n(i, d);
  return /* @__PURE__ */ r(
    K,
    {
      widgetId: t,
      displayName: o,
      editFields: xo,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: s,
      themeColors: h,
      children: f
    }
  );
}, Le = 60, Co = 420, ko = ({
  showSettings: e,
  viewMode: t,
  editorMode: o = "iframe"
}) => `
  /* Reset and base styles */
  .bc-theme-editor-shell {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .bc-theme-editor-shell * {
    box-sizing: border-box;
  }

  /* Top Bar */
  .bc-theme-editor-topbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${Le}px;
    background: #f5f5f7;
    border-bottom: 1px solid ${l.border_glass};
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 16px;
    z-index: 1000001;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }

  /* Logo/Brand */
  .bc-theme-editor-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 16px;
    border-right: 1px solid ${l.border_glass};
  }

  .bc-theme-editor-logo-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, ${l.blue_dark} 0%, #252b6e 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .bc-theme-editor-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: ${l.primary};
    letter-spacing: -0.3px;
  }

  /* Theme ID */
  .bc-theme-editor-theme-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-theme-label {
    font-size: 12px;
    color: ${l.gray_medium};
    font-weight: 500;
  }

  .bc-theme-editor-theme-id {
    font-size: 12px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${l.primary};
    background: ${l.white};
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid ${l.border_glass};
  }

  .bc-theme-editor-live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #4caf50;
    margin-left: 8px;
  }

  .bc-theme-editor-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
  }

  /* Viewport Toggle */
  .bc-theme-editor-viewport-toggle {
    display: flex;
    background: ${l.white};
    border-radius: 10px;
    padding: 4px;
    margin-left: 16px;
    border: 1px solid ${l.border_glass};
    gap: 2px;
  }

  /* Spacer */
  .bc-theme-editor-spacer {
    flex: 1;
  }

  /* Action Buttons */
  .bc-theme-editor-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  /* Preview Area */
  .bc-theme-editor-preview {
    position: fixed;
    top: ${Le}px;
    left: 0;
    right: ${e ? Co : 0}px;
    bottom: 0;
    background: #e8e8ed;
    transition: right 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
  }

  .bc-theme-editor-preview-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: ${t === "mobile" ? "24px" : "0"};
    transition: padding 0.3s ease;
  }

  .bc-theme-editor-iframe-wrapper {
    width: ${t === "desktop" ? "100%" : "375px"};
    height: ${t === "desktop" ? "100%" : "calc(100% - 48px)"};
    background: white;
    transition: all 0.3s ease;
    ${t === "mobile" ? `
      border-radius: 24px;
      box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    ` : ""}
  }

  .bc-theme-editor-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  /* Side Panel */
  @keyframes bc-slide-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes bc-slide-out {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  .bc-theme-editor-sidepanel {
    position: fixed;
    top: ${Le}px;
    right: 0;
    bottom: 0;
    width: ${Co}px;
    background: #fff;
    border-left: 1px solid ${l.border_subtle};
    z-index: 1000000;
    overflow-y: auto;
    animation: bc-slide-in 0.3s ease;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
  }

  .bc-theme-editor-sidepanel-header {
    position: sticky;
    top: 0;
    background: ${l.glass_bg_strong};
    backdrop-filter: blur(20px);
    padding: 20px 24px;
    border-bottom: 1px solid ${l.border_glass};
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }

  .bc-theme-editor-sidepanel-title {
    font-size: 16px;
    font-weight: 600;
    color: ${l.primary};
    margin: 0;
  }

  .bc-theme-editor-sidepanel-close {
    width: 32px;
    height: 32px;
    border: none;
    background: ${l.overlay_light};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${l.gray_medium};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-sidepanel-close:hover {
    background: ${l.gray_light};
    color: ${l.primary};
  }

  .bc-theme-editor-sidepanel-content {
    padding: 24px;
  }

  /* Messages */
  .bc-theme-editor-message {
    padding: 12px 16px;
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-message-success {
    background: rgba(113, 194, 133, 0.15);
    color: ${l.green};
    border: 1px solid rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-message-error {
    background: rgba(255, 83, 74, 0.1);
    color: ${l.red};
    border: 1px solid rgba(255, 83, 74, 0.2);
  }

  /* Sections */
  .bc-theme-editor-section {
    margin-bottom: 8px;
    background: ${l.white};
    border-radius: 12px;
    border: 1px solid ${l.border_glass};
    overflow: hidden;
  }

  .bc-theme-editor-section:last-child {
    margin-bottom: 0;
  }

  .bc-theme-editor-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;
  }

  .bc-theme-editor-section-header:hover {
    background: ${l.bg_light};
  }

  .bc-theme-editor-section-title {
    font-size: 12px;
    font-weight: 600;
    color: ${l.primary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-section-count {
    font-size: 11px;
    font-weight: 500;
    color: ${l.gray_medium};
    background: ${l.bg_light};
    padding: 2px 8px;
    border-radius: 10px;
  }

  .bc-theme-editor-section-chevron {
    color: ${l.gray_medium};
    transition: transform 0.2s ease;
  }

  .bc-theme-editor-section-chevron.expanded {
    transform: rotate(90deg);
  }

  .bc-theme-editor-section-content {
    padding: 0 16px 16px;
  }

  /* Color/Asset Lists */
  .bc-theme-editor-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bc-theme-editor-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: ${l.overlay_light};
    border-radius: 12px;
    border: 1px solid ${l.border_glass};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-row:hover {
    background: ${l.white};
    box-shadow: 0 2px 8px ${l.shadow_soft};
  }

  .bc-theme-editor-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${l.border_glass};
    border-radius: 8px;
    font-size: 13px;
    background: ${l.white};
    color: ${l.primary};
    outline: none;
    transition: all 0.15s ease;
    min-width: 0;
  }

  .bc-theme-editor-input:focus {
    border-color: ${l.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .bc-theme-editor-input:disabled {
    background: transparent;
    border-color: transparent;
    padding-left: 0;
  }

  .bc-theme-editor-color-picker {
    width: 44px;
    height: 36px;
    border: 2px solid ${l.border_glass};
    border-radius: 8px;
    cursor: pointer;
    outline: none;
    padding: 2px;
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-color-picker:hover:not(:disabled) {
    border-color: ${l.gray_border};
    transform: scale(1.05);
  }

  .bc-theme-editor-color-picker:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .bc-theme-editor-color-value {
    font-size: 11px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${l.gray_medium};
    width: 85px;
    text-align: right;
    background: ${l.bg_light};
    padding: 5px 8px;
    border-radius: 4px;
    flex-shrink: 0;
    display: inline-block;
  }

  /* Buttons */
  .bc-theme-editor-btn-small {
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .bc-theme-editor-btn-delete {
    background: linear-gradient(135deg, ${l.red} 0%, #e63e37 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(255, 83, 74, 0.2);
  }

  .bc-theme-editor-btn-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(255, 83, 74, 0.3);
  }

  .bc-theme-editor-btn-save {
    background: linear-gradient(135deg, ${l.green} 0%, #5fb077 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(113, 194, 133, 0.2);
  }

  .bc-theme-editor-btn-save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-btn-cancel {
    background: ${l.gray_light};
    color: ${l.gray_dark};
  }

  .bc-theme-editor-btn-cancel:hover:not(:disabled) {
    background: ${l.gray_border};
  }

  .bc-theme-editor-btn-small:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .bc-theme-editor-btn-add {
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    color: ${l.blue};
    border: 2px dashed ${l.gray_border};
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    margin-top: 4px;
  }

  .bc-theme-editor-btn-add:hover:not(:disabled) {
    background: ${l.blue_light};
    border-color: ${l.blue};
    border-style: solid;
  }

  .bc-theme-editor-btn-add:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Delete button (minimal red X) */
  .bc-theme-editor-delete-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${l.gray_medium};
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-delete-btn:hover:not(:disabled) {
    background: rgba(255, 83, 74, 0.1);
    color: ${l.red};
  }

  .bc-theme-editor-delete-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Font section specific */
  .bc-font-row {
    justify-content: space-between;
  }

  .bc-font-preview-name {
    font-size: 15px;
    color: ${l.primary};
    flex: 1;
    min-width: 0;
  }

  /* Asset specific */
  .bc-theme-editor-asset-preview {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: ${l.bg_light};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
  }

  .bc-theme-editor-asset-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .bc-theme-editor-asset-format {
    font-size: 10px;
    color: ${l.gray_medium};
    background: ${l.bg_light};
    padding: 3px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    flex-shrink: 0;
  }

  .bc-theme-editor-file-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .bc-theme-editor-file-btn {
    padding: 6px 10px;
    background: ${l.overlay_light};
    border: 1px solid ${l.border_glass};
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    color: ${l.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .bc-theme-editor-file-btn:hover:not(:disabled) {
    background: ${l.white};
    border-color: ${l.blue};
    color: ${l.blue};
  }

  .bc-theme-editor-file-name {
    font-size: 11px;
    color: ${l.gray_medium};
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bc-theme-editor-loading {
    text-align: center;
    padding: 24px;
    color: ${l.gray_medium};
    font-size: 13px;
  }

  /* Inline mode specific styles */
  ${o === "inline" ? `
  /* Push page content below the fixed top bar */
  body {
    padding-top: ${Le}px !important;
  }

  /* In inline mode, shell doesn't cover the entire viewport */
  .bc-theme-editor-shell {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
  }

  /* Hide viewport toggle in inline mode (no mobile preview available) */
  .bc-theme-editor-viewport-toggle {
    display: none;
  }
  ` : ""}
`, Xa = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black"
}, z = (e) => e.map((t) => ({
  weight: t,
  label: Xa[t] || `Weight ${t}`
})), je = [
  // === SANS-SERIF ===
  {
    name: "Inter",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Roboto",
    category: "sans-serif",
    variants: z([100, 300, 400, 500, 700, 900]),
    popular: !0
  },
  {
    name: "Open Sans",
    category: "sans-serif",
    variants: z([300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Lato",
    category: "sans-serif",
    variants: z([100, 300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Montserrat",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Poppins",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito Sans",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Sans 3",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Raleway",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Work Sans",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Oswald",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Rubik",
    category: "sans-serif",
    variants: z([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Quicksand",
    category: "sans-serif",
    variants: z([300, 400, 500, 600, 700])
  },
  {
    name: "Mulish",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow Condensed",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Kanit",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Manrope",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "DM Sans",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Outfit",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Plus Jakarta Sans",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Figtree",
    category: "sans-serif",
    variants: z([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cabin",
    category: "sans-serif",
    variants: z([400, 500, 600, 700])
  },
  {
    name: "Karla",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Archivo",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Josefin Sans",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Lexend",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Exo 2",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Titillium Web",
    category: "sans-serif",
    variants: z([200, 300, 400, 600, 700, 900])
  },
  {
    name: "Sora",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Space Grotesk",
    category: "sans-serif",
    variants: z([300, 400, 500, 600, 700])
  },
  {
    name: "Albert Sans",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Be Vietnam Pro",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Asap",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu",
    category: "sans-serif",
    variants: z([300, 400, 500, 700]),
    popular: !0
  },
  {
    name: "Dosis",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Noto Sans",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Noto Sans Display",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fira Sans",
    category: "sans-serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "PT Sans",
    category: "sans-serif",
    variants: z([400, 700])
  },
  {
    name: "PT Sans Narrow",
    category: "sans-serif",
    variants: z([400, 700])
  },
  {
    name: "Mukta",
    category: "sans-serif",
    variants: z([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Hind",
    category: "sans-serif",
    variants: z([300, 400, 500, 600, 700])
  },
  {
    name: "Rajdhani",
    category: "sans-serif",
    variants: z([300, 400, 500, 600, 700])
  },
  {
    name: "Varela Round",
    category: "sans-serif",
    variants: z([400])
  },
  {
    name: "Comic Neue",
    category: "sans-serif",
    variants: z([300, 400, 700])
  },
  // === SERIF ===
  {
    name: "Playfair Display",
    category: "serif",
    variants: z([400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Merriweather",
    category: "serif",
    variants: z([300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Lora",
    category: "serif",
    variants: z([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "PT Serif",
    category: "serif",
    variants: z([400, 700])
  },
  {
    name: "Noto Serif",
    category: "serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Serif 4",
    category: "serif",
    variants: z([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Libre Baskerville",
    category: "serif",
    variants: z([400, 700])
  },
  {
    name: "Crimson Text",
    category: "serif",
    variants: z([400, 600, 700])
  },
  {
    name: "Crimson Pro",
    category: "serif",
    variants: z([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Bitter",
    category: "serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant Garamond",
    category: "serif",
    variants: z([300, 400, 500, 600, 700])
  },
  {
    name: "EB Garamond",
    category: "serif",
    variants: z([400, 500, 600, 700, 800])
  },
  {
    name: "DM Serif Display",
    category: "serif",
    variants: z([400])
  },
  {
    name: "Spectral",
    category: "serif",
    variants: z([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Cardo",
    category: "serif",
    variants: z([400, 700])
  },
  {
    name: "Libre Caslon Text",
    category: "serif",
    variants: z([400, 700])
  },
  {
    name: "Bodoni Moda",
    category: "serif",
    variants: z([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fraunces",
    category: "serif",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant",
    category: "serif",
    variants: z([300, 400, 500, 600, 700])
  },
  {
    name: "Cinzel",
    category: "serif",
    variants: z([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Playfair Display SC",
    category: "serif",
    variants: z([400, 700, 900])
  },
  // === DISPLAY ===
  {
    name: "Bebas Neue",
    category: "display",
    variants: z([400]),
    popular: !0
  },
  {
    name: "Abril Fatface",
    category: "display",
    variants: z([400]),
    popular: !0
  },
  {
    name: "Righteous",
    category: "display",
    variants: z([400])
  },
  {
    name: "Alfa Slab One",
    category: "display",
    variants: z([400])
  },
  {
    name: "Fredoka",
    category: "display",
    variants: z([300, 400, 500, 600, 700])
  },
  {
    name: "Comfortaa",
    category: "display",
    variants: z([300, 400, 500, 600, 700])
  },
  {
    name: "Lobster",
    category: "display",
    variants: z([400])
  },
  {
    name: "Staatliches",
    category: "display",
    variants: z([400])
  },
  {
    name: "Bungee",
    category: "display",
    variants: z([400])
  },
  {
    name: "Monoton",
    category: "display",
    variants: z([400])
  },
  {
    name: "Black Ops One",
    category: "display",
    variants: z([400])
  },
  {
    name: "Permanent Marker",
    category: "display",
    variants: z([400])
  },
  {
    name: "Russo One",
    category: "display",
    variants: z([400])
  },
  {
    name: "Fugaz One",
    category: "display",
    variants: z([400])
  },
  {
    name: "Bangers",
    category: "display",
    variants: z([400])
  },
  {
    name: "Anton",
    category: "display",
    variants: z([400]),
    popular: !0
  },
  {
    name: "Creepster",
    category: "display",
    variants: z([400])
  },
  {
    name: "Orbitron",
    category: "display",
    variants: z([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Audiowide",
    category: "display",
    variants: z([400])
  },
  {
    name: "Bungee Inline",
    category: "display",
    variants: z([400])
  },
  {
    name: "Bungee Shade",
    category: "display",
    variants: z([400])
  },
  {
    name: "Faster One",
    category: "display",
    variants: z([400])
  },
  {
    name: "Press Start 2P",
    category: "display",
    variants: z([400])
  },
  // === HANDWRITING ===
  {
    name: "Dancing Script",
    category: "handwriting",
    variants: z([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Pacifico",
    category: "handwriting",
    variants: z([400]),
    popular: !0
  },
  {
    name: "Caveat",
    category: "handwriting",
    variants: z([400, 500, 600, 700])
  },
  {
    name: "Great Vibes",
    category: "handwriting",
    variants: z([400])
  },
  {
    name: "Satisfy",
    category: "handwriting",
    variants: z([400])
  },
  {
    name: "Sacramento",
    category: "handwriting",
    variants: z([400])
  },
  {
    name: "Kalam",
    category: "handwriting",
    variants: z([300, 400, 700])
  },
  {
    name: "Shadows Into Light",
    category: "handwriting",
    variants: z([400])
  },
  {
    name: "Indie Flower",
    category: "handwriting",
    variants: z([400])
  },
  {
    name: "Amatic SC",
    category: "handwriting",
    variants: z([400, 700])
  },
  {
    name: "Patrick Hand",
    category: "handwriting",
    variants: z([400])
  },
  {
    name: "Courgette",
    category: "handwriting",
    variants: z([400])
  },
  {
    name: "Shadows Into Light Two",
    category: "handwriting",
    variants: z([400]),
    popular: !0
  },
  {
    name: "Caveat Brush",
    category: "handwriting",
    variants: z([400])
  },
  // === MONOSPACE ===
  {
    name: "Fira Code",
    category: "monospace",
    variants: z([300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "JetBrains Mono",
    category: "monospace",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Source Code Pro",
    category: "monospace",
    variants: z([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Roboto Mono",
    category: "monospace",
    variants: z([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "IBM Plex Mono",
    category: "monospace",
    variants: z([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Space Mono",
    category: "monospace",
    variants: z([400, 700])
  },
  {
    name: "Inconsolata",
    category: "monospace",
    variants: z([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu Mono",
    category: "monospace",
    variants: z([400, 700])
  },
  {
    name: "Noto Sans Mono",
    category: "monospace",
    variants: z([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Courier Prime",
    category: "monospace",
    variants: z([400, 700])
  },
  {
    name: "Fira Mono",
    category: "monospace",
    variants: z([400, 500, 700])
  }
], Ja = (e, t = [500]) => {
  const o = e.replace(/ /g, "+"), n = t.join(";");
  return `https://fonts.googleapis.com/css2?family=${o}:wght@${n}&display=swap`;
}, Za = (e) => `https://fonts.googleapis.com/css2?${e.map((o) => {
  const n = o.name.replace(/ /g, "+"), i = o.weights.join(";");
  return `family=${n}:wght@${i}`;
}).join("&")}&display=swap`, Ua = (e) => {
  const t = je.find(
    (o) => o.name.toLowerCase() === e.toLowerCase()
  );
  return (t == null ? void 0 : t.variants) || [{ weight: 500, label: "Medium" }];
};
let He = null;
const cr = () => He || (He = new Promise((e) => {
  const t = je.map((i) => ({
    name: i.name,
    weights: [400, 500]
  })), o = Za(t), n = document.createElement("link");
  n.href = o, n.rel = "stylesheet", n.onload = () => {
    e();
  }, n.onerror = () => {
    console.warn("Failed to preload Google Fonts"), e();
  }, document.head.appendChild(n);
}), He), Va = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, vo = (e) => {
  const t = Va(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, ye = (e, t, o) => {
  var i;
  const n = {
    type: er,
    payload: { updateType: t, themeId: o }
  };
  (i = e == null ? void 0 : e.current) != null && i.contentWindow ? e.current.contentWindow.postMessage(
    n,
    window.location.origin
  ) : window.postMessage(n, window.location.origin);
}, qa = (e) => {
  var o;
  switch ((o = e.split(".").pop()) == null ? void 0 : o.toLowerCase()) {
    case "woff2":
      return "woff2";
    case "woff":
      return "woff";
    case "ttf":
      return "truetype";
    case "otf":
      return "opentype";
    default:
      return "woff2";
  }
}, Ka = ({
  themeId: e,
  editThemeToken: t,
  iframeRef: o,
  refreshThemeColors: n,
  refreshThemeFonts: i,
  refreshThemeIcons: a
}) => {
  const [s, m] = N(!1), [p, h] = N(null), [d, g] = N(null), [f, w] = N(!1), [C, b] = N(""), [y, k] = N("#000000ff"), [P, x] = N(
    null
  ), M = async () => {
    if (!C.trim()) {
      h("Color name is required");
      return;
    }
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    m(!0), h(null), g(null);
    try {
      await Pt({
        themeId: e,
        colorKey: C.trim(),
        colorValue: vo(y),
        editThemeToken: t
      }), await n(), ye(o, "colors", e), b(""), k("#000000ff"), w(!1), g("Color added successfully"), setTimeout(() => g(null), 2e3);
    } catch (B) {
      h(B.message || "Failed to add color");
    } finally {
      m(!1);
    }
  }, v = async (B, A) => {
    if (!(!t || !e)) {
      m(!0), h(null), g(null);
      try {
        await Pt({
          themeId: e,
          colorKey: B,
          colorValue: vo(A),
          editThemeToken: t
        }), await n(), ye(o, "colors", e), g("Color updated successfully"), setTimeout(() => g(null), 2e3);
      } catch (I) {
        h(I.message || "Failed to update color");
      } finally {
        m(!1);
      }
    }
  }, R = async (B, A) => {
    if (!(!t || !e)) {
      if (!A.trim()) {
        h("Color name is required");
        return;
      }
      if (B !== A.trim()) {
        m(!0), h(null), g(null);
        try {
          await Gn({
            themeId: e,
            oldColorKey: B,
            newColorKey: A.trim(),
            editThemeToken: t
          }), await n(), ye(o, "colors", e), g("Color renamed successfully"), setTimeout(() => g(null), 2e3);
        } catch (I) {
          h(I.message || "Failed to rename color");
        } finally {
          m(!1);
        }
      }
    }
  }, W = (B) => {
    !t || !e || x({ type: "color", key: B });
  }, S = async (B) => {
    if (!(!t || !e)) {
      m(!0), h(null), g(null);
      try {
        await jn({
          themeId: e,
          colorKey: B,
          editThemeToken: t
        }), await n(), ye(o, "colors", e), g("Color deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (A) {
        h(A.message || "Failed to delete color");
      } finally {
        m(!1);
      }
    }
  }, H = async (B) => {
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    m(!0), h(null), g(null);
    try {
      let A, I;
      switch (B.type) {
        case "system":
          A = B.value || B.name, I = "system";
          break;
        case "google":
          const Q = Ua(B.name).map((ee) => ee.weight);
          Q.includes(800) || Q.push(800), Q.includes(900) || Q.push(900), A = Ja(B.name, Q), I = "google";
          break;
        case "upload":
          if (!B.file)
            throw new Error("No font file provided");
          const { signedUploadUrl: X, objectPublicUrl: U } = await Tt({
            themeId: e,
            fileName: B.file.name,
            contentType: B.file.type || "font/woff2",
            assetType: "font",
            editThemeToken: t
          });
          await Mt({
            file: B.file,
            signedUploadUrl: X
          }), A = U, I = qa(B.file.name);
          break;
        default:
          throw new Error("Unknown font type");
      }
      await Yn({
        themeId: e,
        fontKey: B.name.toLowerCase().replace(/\s+/g, "-"),
        fontValue: {
          name: B.name,
          url: A,
          format: I
        },
        editThemeToken: t
      }), await i(), ye(o, "fonts", e), g("Font added successfully"), setTimeout(() => g(null), 2e3);
    } catch (A) {
      h(A.message || "Failed to add font");
    } finally {
      m(!1);
    }
  }, D = (B) => {
    !t || !e || x({ type: "font", key: B });
  }, E = async (B) => {
    if (!(!t || !e)) {
      m(!0), h(null), g(null);
      try {
        await $n({
          themeId: e,
          fontKey: B,
          editThemeToken: t
        }), await i(), ye(o, "fonts", e), g("Font deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (A) {
        h(A.message || "Failed to delete font");
      } finally {
        m(!1);
      }
    }
  }, O = async (B) => {
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    m(!0), h(null), g(null);
    try {
      let A;
      switch (B.type) {
        case "lucide":
          if (A = B.url || "", !A)
            throw new Error("No icon URL provided");
          break;
        case "upload":
          if (!B.file)
            throw new Error("No icon file provided");
          const { signedUploadUrl: I, objectPublicUrl: $ } = await Tt({
            themeId: e,
            fileName: B.file.name,
            contentType: B.file.type || "image/svg+xml",
            assetType: "icon",
            editThemeToken: t
          });
          await Mt({
            file: B.file,
            signedUploadUrl: I
          }), A = $;
          break;
        default:
          throw new Error("Unknown icon type");
      }
      await Qn({
        themeId: e,
        iconKey: B.name.toLowerCase().replace(/\s+/g, "-"),
        iconValue: {
          name: B.name,
          url: A
        },
        editThemeToken: t
      }), await a(), ye(o, "icons", e), g("Icon added successfully"), setTimeout(() => g(null), 2e3);
    } catch (A) {
      h(A.message || "Failed to add icon");
    } finally {
      m(!1);
    }
  }, F = (B) => {
    !t || !e || x({ type: "icon", key: B });
  }, L = async (B) => {
    if (!(!t || !e)) {
      m(!0), h(null), g(null);
      try {
        await Xn({
          themeId: e,
          iconKey: B,
          editThemeToken: t
        }), await a(), ye(o, "icons", e), g("Icon deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (A) {
        h(A.message || "Failed to delete icon");
      } finally {
        m(!1);
      }
    }
  };
  return {
    // Loading and messages
    isLoading: s,
    error: p,
    successMessage: d,
    // Color state
    isAddingColor: f,
    setIsAddingColor: w,
    newColorKey: C,
    setNewColorKey: b,
    newColorValue: y,
    setNewColorValue: k,
    // Color Handlers
    handleAddColor: M,
    handleUpdateColor: v,
    handleRenameColor: R,
    handleDeleteColor: W,
    // Font Handlers
    handleAddFont: H,
    handleDeleteFont: D,
    // Icon Handlers
    handleAddIcon: O,
    handleDeleteIcon: F,
    // Delete confirmation
    pendingDelete: P,
    confirmDelete: async () => {
      if (!P) return;
      const { type: B, key: A } = P;
      switch (x(null), B) {
        case "color":
          await S(A);
          break;
        case "font":
          await E(A);
          break;
        case "icon":
          await L(A);
          break;
      }
    },
    cancelDelete: () => {
      x(null);
    }
  };
}, wo = ({
  onClose: e,
  successMessage: t,
  error: o,
  children: n
}) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel", children: [
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel-header", children: [
    /* @__PURE__ */ r("h2", { className: "bc-theme-editor-sidepanel-title", children: "Theme Settings" }),
    /* @__PURE__ */ r(
      _,
      {
        variant: "icon",
        size: "sm",
        onClick: e,
        "aria-label": "Close settings",
        children: /* @__PURE__ */ r(xe, { size: 16 })
      }
    )
  ] }),
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel-content", children: [
    t && /* @__PURE__ */ u("div", { className: "bc-theme-editor-message bc-theme-editor-message-success", children: [
      /* @__PURE__ */ r(Br, { size: 14 }),
      " ",
      t
    ] }),
    o && /* @__PURE__ */ u("div", { className: "bc-theme-editor-message bc-theme-editor-message-error", children: [
      /* @__PURE__ */ r(Ir, { size: 14 }),
      " ",
      o
    ] }),
    n
  ] })
] }), So = ({
  themeFonts: e,
  isExpanded: t,
  onToggle: o,
  isLoading: n,
  onDeleteFont: i,
  onOpenFontPicker: a
}) => {
  const [s, m] = N(!1);
  J(() => {
    t && !s && cr().then(() => m(!0));
  }, [t, s]);
  const p = (h) => {
    switch (h) {
      case "google":
        return "Google Fonts";
      case "system":
        return "System";
      case "woff2":
      case "woff":
      case "truetype":
      case "opentype":
        return "Uploaded";
      default:
        return h;
    }
  };
  return /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
      /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
        "Fonts",
        /* @__PURE__ */ r("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ r(
        dt,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ r("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([h, d]) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-row bc-font-row", children: [
        /* @__PURE__ */ r(
          "span",
          {
            className: "bc-font-preview-name",
            style: {
              fontFamily: s ? `'${d.name}', sans-serif` : "inherit"
            },
            children: d.name
          }
        ),
        /* @__PURE__ */ r("span", { className: "bc-theme-editor-asset-format", children: p(d.format) }),
        /* @__PURE__ */ r(
          "button",
          {
            className: "bc-theme-editor-delete-btn",
            onClick: () => i(h),
            disabled: n,
            "aria-label": "Delete font",
            children: /* @__PURE__ */ r(xe, { size: 16 })
          }
        )
      ] }, h)),
      /* @__PURE__ */ r(
        _,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ r(ct, { size: 12 }),
          onClick: a,
          disabled: n,
          children: "Add Font"
        }
      )
    ] }) })
  ] });
}, Bo = ({
  themeIcons: e,
  isExpanded: t,
  onToggle: o,
  isLoading: n,
  onDeleteIcon: i,
  onOpenIconPicker: a
}) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: o, children: [
    /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
      "Icons",
      /* @__PURE__ */ r("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
    ] }),
    /* @__PURE__ */ r(
      dt,
      {
        size: 16,
        className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
      }
    )
  ] }),
  t && /* @__PURE__ */ r("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
    Object.entries(e).map(([s, m]) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
      /* @__PURE__ */ r("div", { className: "bc-theme-editor-asset-preview", children: /* @__PURE__ */ r("img", { src: m.url, alt: m.name }) }),
      /* @__PURE__ */ r(
        "input",
        {
          type: "text",
          className: "bc-theme-editor-input",
          value: m.name,
          disabled: !0
        }
      ),
      /* @__PURE__ */ r(
        "button",
        {
          className: "bc-theme-editor-delete-btn",
          onClick: () => i(s),
          disabled: n,
          "aria-label": "Delete icon",
          children: /* @__PURE__ */ r(xe, { size: 16 })
        }
      )
    ] }, s)),
    /* @__PURE__ */ r(
      _,
      {
        variant: "ghost",
        size: "sm",
        leftIcon: /* @__PURE__ */ r(ct, { size: 12 }),
        onClick: a,
        disabled: n,
        children: "Add Icon"
      }
    )
  ] }) })
] }), Fo = [
  // Sans-serif
  {
    name: "System UI",
    value: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    category: "sans-serif"
  },
  {
    name: "SF Pro",
    value: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
    category: "sans-serif"
  },
  {
    name: "Helvetica",
    value: "Helvetica, Arial, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Arial",
    value: "Arial, Helvetica, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Segoe UI",
    value: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Verdana",
    value: "Verdana, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Tahoma",
    value: "Tahoma, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    category: "sans-serif"
  },
  // Serif
  {
    name: "New York",
    value: "'New York', 'Iowan Old Style', Georgia, serif",
    category: "serif"
  },
  {
    name: "Georgia",
    value: "Georgia, 'Times New Roman', serif",
    category: "serif"
  },
  {
    name: "Times New Roman",
    value: "'Times New Roman', Times, serif",
    category: "serif"
  },
  {
    name: "Palatino",
    value: "'Palatino Linotype', Palatino, 'Book Antiqua', serif",
    category: "serif"
  },
  {
    name: "Garamond",
    value: "Garamond, 'Times New Roman', serif",
    category: "serif"
  },
  // Monospace
  {
    name: "SF Mono",
    value: "'SF Mono', Menlo, Monaco, monospace",
    category: "monospace"
  },
  {
    name: "Menlo",
    value: "Menlo, Monaco, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Monaco",
    value: "Monaco, Menlo, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Consolas",
    value: "Consolas, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Courier New",
    value: "'Courier New', Courier, monospace",
    category: "monospace"
  }
], _a = () => `
  /* Overlay */
  .font-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: font-picker-fade-in 0.2s ease;
  }

  @keyframes font-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .font-picker-modal {
    background: ${l.white};
    border-radius: 16px;
    width: 90%;
    max-width: 560px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: font-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes font-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${l.border_glass};
  }

  .font-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${l.primary};
    margin: 0;
  }

  /* Search */
  .font-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${l.border_glass};
    position: relative;
  }

  .font-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${l.gray_medium};
  }

  .font-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${l.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${l.primary};
    background: ${l.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-search-input:focus {
    border-color: ${l.blue};
    background: ${l.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .font-picker-search-input::placeholder {
    color: ${l.gray_medium};
  }

  /* Tabs */
  .font-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${l.border_glass};
  }

  .font-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${l.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .font-picker-tab:hover {
    color: ${l.primary};
  }

  .font-picker-tab.active {
    color: ${l.primary};
  }

  .font-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${l.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .font-picker-content {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .font-picker-description {
    font-size: 13px;
    color: ${l.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Font List */
  .font-picker-list {
    padding-bottom: 16px;
  }

  .font-picker-category {
    margin-bottom: 8px;
  }

  .font-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${l.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
  }

  .font-picker-item {
    display: flex;
    align-items: center;
    padding: 14px 24px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${l.border_glass};
  }

  .font-picker-item:hover {
    background: ${l.bg_light};
  }

  .font-picker-item.selected {
    background: rgba(85, 114, 183, 0.08);
  }

  .font-picker-item-name {
    flex: 1;
    font-size: 16px;
    color: ${l.primary};
  }

  .font-picker-popular {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${l.blue};
    background: rgba(85, 114, 183, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
    margin-right: 12px;
  }

  .font-picker-check {
    color: ${l.blue};
    flex-shrink: 0;
  }

  /* Variant Selector */
  .font-picker-variant-selector {
    padding: 8px 24px 8px 48px;
    background: ${l.bg_light};
    border-bottom: 1px solid ${l.border_glass};
  }

  .font-picker-variant-select {
    padding: 8px 32px 8px 12px;
    border: 1px solid ${l.border_glass};
    border-radius: 8px;
    font-size: 13px;
    color: ${l.primary};
    background: ${l.white};
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    transition: all 0.15s ease;
  }

  .font-picker-variant-select:focus {
    border-color: ${l.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Upload Tab */
  .font-picker-upload {
    padding: 16px 24px;
  }

  .font-picker-upload-zone {
    border: 2px dashed ${l.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .font-picker-upload-zone:hover {
    border-color: ${l.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .font-picker-upload-icon {
    color: ${l.gray_medium};
  }

  .font-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${l.primary};
  }

  .font-picker-upload-hint {
    font-size: 12px;
    color: ${l.gray_medium};
  }

  .font-picker-upload-preview {
    margin-top: 16px;
  }

  .font-picker-upload-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: ${l.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .font-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${l.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .font-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .font-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${l.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .font-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${l.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${l.primary};
    background: ${l.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-upload-input:focus {
    border-color: ${l.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .font-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${l.border_glass};
    background: ${l.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, Io = ({
  isOpen: e,
  onClose: t,
  onSelect: o,
  isLoading: n = !1
}) => {
  const [i, a] = N("system"), [s, m] = N(""), [p, h] = N(null), [d, g] = N(null), [f, w] = N(""), C = ie(null), [b, y] = N(!1);
  J(() => {
    e && (m(""), h(null), g(null), w(""));
  }, [e]), J(() => {
    i === "google" && !b && cr().then(() => {
      y(!0);
    });
  }, [i, b]);
  const k = le(() => {
    if (!s) return Fo;
    const F = s.toLowerCase();
    return Fo.filter(
      (L) => L.name.toLowerCase().includes(F) || L.category.toLowerCase().includes(F)
    );
  }, [s]), P = le(() => {
    if (!s) return je;
    const F = s.toLowerCase();
    return je.filter(
      (L) => L.name.toLowerCase().includes(F) || L.category.toLowerCase().includes(F)
    );
  }, [s]), x = (F) => {
    h({
      type: "system",
      name: F.name,
      value: F.value
    });
  }, M = (F) => {
    h({
      type: "google",
      name: F.name
    });
  }, v = (F) => {
    var Y;
    const L = (Y = F.target.files) == null ? void 0 : Y[0];
    if (L) {
      g(L);
      const j = L.name.replace(/\.[^/.]+$/, "");
      w(j), h({
        type: "upload",
        name: j,
        file: L,
        format: R(L.name)
      });
    }
  }, R = (F) => {
    var Y;
    switch ((Y = F.split(".").pop()) == null ? void 0 : Y.toLowerCase()) {
      case "woff2":
        return "woff2";
      case "woff":
        return "woff";
      case "ttf":
        return "truetype";
      case "otf":
        return "opentype";
      default:
        return "woff2";
    }
  }, W = (F) => {
    w(F), (p == null ? void 0 : p.type) === "upload" && d && h({
      ...p,
      name: F
    });
  }, S = () => {
    p && (o(p), t());
  }, H = n || !p || p.type === "upload" && (!d || !f.trim()), D = le(() => {
    const F = {};
    return P.forEach((L) => {
      F[L.category] || (F[L.category] = []), F[L.category].push(L);
    }), F;
  }, [P]), E = le(() => {
    const F = {};
    return k.forEach((L) => {
      F[L.category] || (F[L.category] = []), F[L.category].push(L);
    }), F;
  }, [k]);
  if (!e) return null;
  const O = /* @__PURE__ */ u(G, { children: [
    /* @__PURE__ */ r("style", { children: _a() }),
    /* @__PURE__ */ r("div", { className: "font-picker-overlay", onClick: t, children: /* @__PURE__ */ u("div", { className: "font-picker-modal", onClick: (F) => F.stopPropagation(), children: [
      /* @__PURE__ */ u("div", { className: "font-picker-header", children: [
        /* @__PURE__ */ r("h2", { className: "font-picker-title", children: "Select font" }),
        /* @__PURE__ */ r(
          _,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ r(xe, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-search", children: [
        /* @__PURE__ */ r(Lo, { size: 16, className: "font-picker-search-icon" }),
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            placeholder: "Search",
            value: s,
            onChange: (F) => m(F.target.value),
            className: "font-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-tabs", children: [
        /* @__PURE__ */ r(
          "button",
          {
            className: `font-picker-tab ${i === "system" ? "active" : ""}`,
            onClick: () => a("system"),
            children: "System Fonts"
          }
        ),
        /* @__PURE__ */ r(
          "button",
          {
            className: `font-picker-tab ${i === "google" ? "active" : ""}`,
            onClick: () => a("google"),
            children: "Google Fonts"
          }
        ),
        /* @__PURE__ */ r(
          "button",
          {
            className: `font-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => a("upload"),
            children: "Upload"
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-content", children: [
        i === "system" && /* @__PURE__ */ u("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ r("p", { className: "font-picker-description", children: "These fonts load faster and might appear differently on various devices." }),
          Object.entries(E).map(
            ([F, L]) => /* @__PURE__ */ u("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ r("h4", { className: "font-picker-category-title", children: F.charAt(0).toUpperCase() + F.slice(1) }),
              L.map((Y) => /* @__PURE__ */ u(
                "div",
                {
                  className: `font-picker-item ${(p == null ? void 0 : p.type) === "system" && (p == null ? void 0 : p.name) === Y.name ? "selected" : ""}`,
                  onClick: () => x(Y),
                  children: [
                    /* @__PURE__ */ r(
                      "span",
                      {
                        className: "font-picker-item-name",
                        style: { fontFamily: Y.value },
                        children: Y.name
                      }
                    ),
                    (p == null ? void 0 : p.type) === "system" && (p == null ? void 0 : p.name) === Y.name && /* @__PURE__ */ r(Fe, { size: 16, className: "font-picker-check" })
                  ]
                },
                Y.name
              ))
            ] }, F)
          )
        ] }),
        i === "google" && /* @__PURE__ */ u("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ r("p", { className: "font-picker-description", children: "These fonts are downloaded onto a visitor's computer and might cause slower load times." }),
          Object.entries(D).map(
            ([F, L]) => /* @__PURE__ */ u("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ r("h4", { className: "font-picker-category-title", children: F.charAt(0).toUpperCase() + F.slice(1) }),
              L.map((Y) => {
                const j = (p == null ? void 0 : p.type) === "google" && (p == null ? void 0 : p.name) === Y.name;
                return /* @__PURE__ */ r("div", { children: /* @__PURE__ */ u(
                  "div",
                  {
                    className: `font-picker-item ${j ? "selected" : ""}`,
                    onClick: () => M(Y),
                    children: [
                      /* @__PURE__ */ r(
                        "span",
                        {
                          className: "font-picker-item-name",
                          style: {
                            fontFamily: b ? `'${Y.name}', sans-serif` : "inherit"
                          },
                          children: Y.name
                        }
                      ),
                      j && /* @__PURE__ */ r(
                        Fe,
                        {
                          size: 16,
                          className: "font-picker-check"
                        }
                      )
                    ]
                  }
                ) }, Y.name);
              })
            ] }, F)
          )
        ] }),
        i === "upload" && /* @__PURE__ */ u("div", { className: "font-picker-upload", children: [
          /* @__PURE__ */ r("p", { className: "font-picker-description", children: "Upload your own font file. Supported formats: WOFF2, WOFF, TTF, OTF." }),
          /* @__PURE__ */ r(
            "input",
            {
              ref: C,
              type: "file",
              accept: ".woff2,.woff,.ttf,.otf",
              onChange: v,
              style: { display: "none" }
            }
          ),
          d ? /* @__PURE__ */ u("div", { className: "font-picker-upload-preview", children: [
            /* @__PURE__ */ u("div", { className: "font-picker-upload-file", children: [
              /* @__PURE__ */ r("span", { className: "font-picker-upload-filename", children: d.name }),
              /* @__PURE__ */ r(
                _,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => {
                    var F;
                    return (F = C.current) == null ? void 0 : F.click();
                  },
                  children: "Change"
                }
              )
            ] }),
            /* @__PURE__ */ u("div", { className: "font-picker-upload-name", children: [
              /* @__PURE__ */ r("label", { className: "font-picker-upload-label", children: "Font name" }),
              /* @__PURE__ */ r(
                "input",
                {
                  type: "text",
                  value: f,
                  onChange: (F) => W(F.target.value),
                  placeholder: "Enter font name",
                  className: "font-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u(
            "div",
            {
              className: "font-picker-upload-zone",
              onClick: () => {
                var F;
                return (F = C.current) == null ? void 0 : F.click();
              },
              children: [
                /* @__PURE__ */ r(No, { size: 32, className: "font-picker-upload-icon" }),
                /* @__PURE__ */ r("span", { className: "font-picker-upload-text", children: "Click to upload font file" }),
                /* @__PURE__ */ r("span", { className: "font-picker-upload-hint", children: "WOFF2, WOFF, TTF, or OTF" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-footer", children: [
        /* @__PURE__ */ r(_, { variant: "outline", onClick: t, disabled: n, children: "Cancel" }),
        /* @__PURE__ */ r(
          _,
          {
            variant: "primary",
            onClick: S,
            disabled: H,
            children: n ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return fe.createPortal(O, Ye());
}, zo = [
  "arrows",
  "commerce",
  "communication",
  "devices",
  "files",
  "layout",
  "media",
  "navigation",
  "social",
  "symbols",
  "text",
  "weather"
], Ge = [
  // === ARROWS ===
  { name: "arrow-up", tags: ["up", "direction"], category: "arrows" },
  { name: "arrow-down", tags: ["down", "direction"], category: "arrows" },
  {
    name: "arrow-left",
    tags: ["left", "direction", "back"],
    category: "arrows"
  },
  {
    name: "arrow-right",
    tags: ["right", "direction", "forward"],
    category: "arrows"
  },
  {
    name: "arrow-up-right",
    tags: ["diagonal", "external"],
    category: "arrows"
  },
  { name: "arrow-down-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-up-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-down-right", tags: ["diagonal"], category: "arrows" },
  { name: "chevron-up", tags: ["up", "expand"], category: "arrows" },
  { name: "chevron-down", tags: ["down", "collapse"], category: "arrows" },
  { name: "chevron-left", tags: ["left", "back"], category: "arrows" },
  { name: "chevron-right", tags: ["right", "forward"], category: "arrows" },
  { name: "chevrons-up", tags: ["up", "double"], category: "arrows" },
  { name: "chevrons-down", tags: ["down", "double"], category: "arrows" },
  { name: "chevrons-left", tags: ["left", "double"], category: "arrows" },
  { name: "chevrons-right", tags: ["right", "double"], category: "arrows" },
  { name: "move", tags: ["drag", "reorder"], category: "arrows" },
  { name: "move-horizontal", tags: ["drag", "resize"], category: "arrows" },
  { name: "move-vertical", tags: ["drag", "resize"], category: "arrows" },
  {
    name: "refresh-cw",
    tags: ["reload", "sync", "refresh"],
    category: "arrows"
  },
  { name: "refresh-ccw", tags: ["reload", "undo"], category: "arrows" },
  { name: "rotate-cw", tags: ["rotate", "clockwise"], category: "arrows" },
  { name: "rotate-ccw", tags: ["rotate", "counter"], category: "arrows" },
  { name: "undo", tags: ["back", "reverse"], category: "arrows" },
  { name: "redo", tags: ["forward"], category: "arrows" },
  { name: "repeat", tags: ["loop", "cycle"], category: "arrows" },
  { name: "corner-down-left", tags: ["enter", "return"], category: "arrows" },
  { name: "corner-down-right", tags: ["turn"], category: "arrows" },
  { name: "corner-up-left", tags: ["turn"], category: "arrows" },
  { name: "corner-up-right", tags: ["turn"], category: "arrows" },
  // === COMMERCE ===
  {
    name: "shopping-cart",
    tags: ["cart", "buy", "ecommerce"],
    category: "commerce"
  },
  { name: "shopping-bag", tags: ["bag", "buy", "store"], category: "commerce" },
  {
    name: "credit-card",
    tags: ["payment", "card", "money"],
    category: "commerce"
  },
  { name: "wallet", tags: ["money", "payment"], category: "commerce" },
  { name: "receipt", tags: ["invoice", "bill"], category: "commerce" },
  { name: "tag", tags: ["label", "price"], category: "commerce" },
  { name: "tags", tags: ["labels", "prices"], category: "commerce" },
  { name: "percent", tags: ["discount", "sale"], category: "commerce" },
  {
    name: "dollar-sign",
    tags: ["money", "currency", "price"],
    category: "commerce"
  },
  {
    name: "banknote",
    tags: ["money", "cash", "payment"],
    category: "commerce"
  },
  { name: "coins", tags: ["money", "currency"], category: "commerce" },
  { name: "gift", tags: ["present", "reward"], category: "commerce" },
  {
    name: "package",
    tags: ["box", "shipping", "delivery"],
    category: "commerce"
  },
  { name: "truck", tags: ["delivery", "shipping"], category: "commerce" },
  { name: "store", tags: ["shop", "retail"], category: "commerce" },
  { name: "barcode", tags: ["scan", "product"], category: "commerce" },
  { name: "qr-code", tags: ["scan", "code"], category: "commerce" },
  // === COMMUNICATION ===
  {
    name: "mail",
    tags: ["email", "message", "envelope"],
    category: "communication"
  },
  { name: "mail-open", tags: ["email", "read"], category: "communication" },
  { name: "inbox", tags: ["email", "messages"], category: "communication" },
  {
    name: "send",
    tags: ["email", "message", "submit"],
    category: "communication"
  },
  {
    name: "message-circle",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "message-square",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "messages-square",
    tags: ["chat", "conversation"],
    category: "communication"
  },
  { name: "phone", tags: ["call", "contact"], category: "communication" },
  { name: "phone-call", tags: ["calling", "ring"], category: "communication" },
  {
    name: "phone-incoming",
    tags: ["call", "receive"],
    category: "communication"
  },
  { name: "phone-outgoing", tags: ["call", "dial"], category: "communication" },
  { name: "phone-missed", tags: ["call", "missed"], category: "communication" },
  {
    name: "video",
    tags: ["camera", "call", "meeting"],
    category: "communication"
  },
  {
    name: "video-off",
    tags: ["camera", "disabled"],
    category: "communication"
  },
  {
    name: "mic",
    tags: ["microphone", "audio", "voice"],
    category: "communication"
  },
  { name: "mic-off", tags: ["mute", "silent"], category: "communication" },
  { name: "bell", tags: ["notification", "alert"], category: "communication" },
  {
    name: "bell-off",
    tags: ["notification", "mute"],
    category: "communication"
  },
  {
    name: "bell-ring",
    tags: ["notification", "alert"],
    category: "communication"
  },
  { name: "at-sign", tags: ["email", "mention"], category: "communication" },
  // === DEVICES ===
  {
    name: "smartphone",
    tags: ["phone", "mobile", "device"],
    category: "devices"
  },
  { name: "tablet", tags: ["ipad", "device"], category: "devices" },
  { name: "laptop", tags: ["computer", "device"], category: "devices" },
  {
    name: "monitor",
    tags: ["screen", "display", "desktop"],
    category: "devices"
  },
  { name: "tv", tags: ["television", "screen"], category: "devices" },
  { name: "watch", tags: ["time", "wearable"], category: "devices" },
  { name: "headphones", tags: ["audio", "music"], category: "devices" },
  { name: "speaker", tags: ["audio", "sound"], category: "devices" },
  { name: "camera", tags: ["photo", "picture"], category: "devices" },
  { name: "printer", tags: ["print", "document"], category: "devices" },
  { name: "keyboard", tags: ["input", "type"], category: "devices" },
  { name: "mouse", tags: ["input", "click"], category: "devices" },
  { name: "gamepad", tags: ["game", "controller"], category: "devices" },
  { name: "cpu", tags: ["processor", "chip"], category: "devices" },
  { name: "hard-drive", tags: ["storage", "disk"], category: "devices" },
  { name: "usb", tags: ["cable", "port"], category: "devices" },
  {
    name: "wifi",
    tags: ["internet", "network", "wireless"],
    category: "devices"
  },
  { name: "bluetooth", tags: ["wireless", "connect"], category: "devices" },
  { name: "battery", tags: ["power", "charge"], category: "devices" },
  { name: "battery-charging", tags: ["power", "charge"], category: "devices" },
  { name: "plug", tags: ["power", "electric"], category: "devices" },
  // === FILES ===
  { name: "file", tags: ["document", "page"], category: "files" },
  { name: "file-text", tags: ["document", "text"], category: "files" },
  { name: "file-image", tags: ["picture", "photo"], category: "files" },
  { name: "file-video", tags: ["movie", "media"], category: "files" },
  { name: "file-audio", tags: ["music", "sound"], category: "files" },
  { name: "file-code", tags: ["code", "programming"], category: "files" },
  { name: "file-json", tags: ["data", "code"], category: "files" },
  { name: "file-spreadsheet", tags: ["excel", "data"], category: "files" },
  { name: "file-archive", tags: ["zip", "compress"], category: "files" },
  { name: "file-plus", tags: ["add", "new"], category: "files" },
  { name: "file-minus", tags: ["remove", "delete"], category: "files" },
  { name: "file-check", tags: ["done", "complete"], category: "files" },
  { name: "file-x", tags: ["delete", "remove"], category: "files" },
  { name: "folder", tags: ["directory"], category: "files" },
  { name: "folder-open", tags: ["directory", "open"], category: "files" },
  { name: "folder-plus", tags: ["add", "new"], category: "files" },
  { name: "folder-minus", tags: ["remove"], category: "files" },
  { name: "clipboard", tags: ["copy", "paste"], category: "files" },
  { name: "clipboard-check", tags: ["done", "complete"], category: "files" },
  { name: "copy", tags: ["duplicate", "clipboard"], category: "files" },
  { name: "scissors", tags: ["cut"], category: "files" },
  { name: "download", tags: ["save", "get"], category: "files" },
  { name: "upload", tags: ["send", "share"], category: "files" },
  { name: "cloud", tags: ["storage", "online"], category: "files" },
  { name: "cloud-download", tags: ["download", "sync"], category: "files" },
  { name: "cloud-upload", tags: ["upload", "sync"], category: "files" },
  { name: "archive", tags: ["box", "storage"], category: "files" },
  { name: "trash", tags: ["delete", "remove"], category: "files" },
  { name: "trash-2", tags: ["delete", "remove"], category: "files" },
  // === LAYOUT ===
  { name: "layout", tags: ["template", "design"], category: "layout" },
  { name: "layout-grid", tags: ["grid", "template"], category: "layout" },
  { name: "layout-list", tags: ["list", "rows"], category: "layout" },
  {
    name: "layout-dashboard",
    tags: ["dashboard", "widgets"],
    category: "layout"
  },
  { name: "grid-2x2", tags: ["grid", "squares"], category: "layout" },
  { name: "grid-3x3", tags: ["grid", "squares"], category: "layout" },
  { name: "list", tags: ["items", "menu"], category: "layout" },
  { name: "list-ordered", tags: ["numbers", "ol"], category: "layout" },
  { name: "list-checks", tags: ["todo", "tasks"], category: "layout" },
  { name: "table", tags: ["data", "spreadsheet"], category: "layout" },
  { name: "columns", tags: ["layout", "split"], category: "layout" },
  { name: "rows", tags: ["layout", "split"], category: "layout" },
  { name: "sidebar", tags: ["panel", "nav"], category: "layout" },
  { name: "panel-left", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-right", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-top", tags: ["header", "layout"], category: "layout" },
  { name: "panel-bottom", tags: ["footer", "layout"], category: "layout" },
  { name: "maximize", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "maximize-2", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "minimize", tags: ["exit", "shrink"], category: "layout" },
  { name: "minimize-2", tags: ["exit", "shrink"], category: "layout" },
  { name: "split", tags: ["divide", "separate"], category: "layout" },
  { name: "merge", tags: ["combine", "join"], category: "layout" },
  // === MEDIA ===
  { name: "play", tags: ["start", "video", "audio"], category: "media" },
  { name: "pause", tags: ["stop", "wait"], category: "media" },
  { name: "stop-circle", tags: ["end", "halt"], category: "media" },
  { name: "skip-back", tags: ["previous", "rewind"], category: "media" },
  { name: "skip-forward", tags: ["next", "forward"], category: "media" },
  { name: "rewind", tags: ["backward", "reverse"], category: "media" },
  { name: "fast-forward", tags: ["forward", "speed"], category: "media" },
  { name: "volume", tags: ["sound", "audio"], category: "media" },
  { name: "volume-1", tags: ["sound", "low"], category: "media" },
  { name: "volume-2", tags: ["sound", "high"], category: "media" },
  { name: "volume-x", tags: ["mute", "silent"], category: "media" },
  { name: "music", tags: ["audio", "song"], category: "media" },
  { name: "music-2", tags: ["audio", "notes"], category: "media" },
  { name: "music-3", tags: ["audio", "notes"], category: "media" },
  { name: "music-4", tags: ["audio", "notes"], category: "media" },
  { name: "image", tags: ["picture", "photo"], category: "media" },
  { name: "images", tags: ["pictures", "gallery"], category: "media" },
  { name: "film", tags: ["movie", "video"], category: "media" },
  { name: "clapperboard", tags: ["movie", "film"], category: "media" },
  { name: "disc", tags: ["cd", "dvd", "music"], category: "media" },
  { name: "radio", tags: ["music", "broadcast"], category: "media" },
  { name: "podcast", tags: ["audio", "broadcast"], category: "media" },
  { name: "cast", tags: ["stream", "broadcast"], category: "media" },
  { name: "airplay", tags: ["stream", "mirror"], category: "media" },
  { name: "screen-share", tags: ["present", "stream"], category: "media" },
  { name: "screen-share-off", tags: ["stop", "stream"], category: "media" },
  // === NAVIGATION ===
  { name: "home", tags: ["house", "main"], category: "navigation" },
  { name: "menu", tags: ["hamburger", "nav"], category: "navigation" },
  {
    name: "more-horizontal",
    tags: ["dots", "options"],
    category: "navigation"
  },
  { name: "more-vertical", tags: ["dots", "options"], category: "navigation" },
  { name: "grip-horizontal", tags: ["drag", "handle"], category: "navigation" },
  { name: "grip-vertical", tags: ["drag", "handle"], category: "navigation" },
  { name: "search", tags: ["find", "magnify"], category: "navigation" },
  { name: "zoom-in", tags: ["magnify", "enlarge"], category: "navigation" },
  { name: "zoom-out", tags: ["shrink", "reduce"], category: "navigation" },
  { name: "filter", tags: ["sort", "funnel"], category: "navigation" },
  {
    name: "settings",
    tags: ["gear", "config", "preferences"],
    category: "navigation"
  },
  { name: "settings-2", tags: ["sliders", "config"], category: "navigation" },
  {
    name: "sliders-horizontal",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  {
    name: "sliders-vertical",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  { name: "map", tags: ["location", "navigation"], category: "navigation" },
  { name: "map-pin", tags: ["location", "marker"], category: "navigation" },
  { name: "navigation", tags: ["direction", "arrow"], category: "navigation" },
  {
    name: "compass",
    tags: ["direction", "navigation"],
    category: "navigation"
  },
  { name: "globe", tags: ["world", "earth", "web"], category: "navigation" },
  { name: "locate", tags: ["gps", "position"], category: "navigation" },
  { name: "crosshair", tags: ["target", "aim"], category: "navigation" },
  { name: "bookmark", tags: ["save", "favorite"], category: "navigation" },
  { name: "flag", tags: ["mark", "report"], category: "navigation" },
  { name: "hash", tags: ["tag", "number"], category: "navigation" },
  { name: "link", tags: ["url", "chain"], category: "navigation" },
  { name: "link-2", tags: ["url", "chain"], category: "navigation" },
  { name: "unlink", tags: ["break", "disconnect"], category: "navigation" },
  {
    name: "external-link",
    tags: ["open", "new window"],
    category: "navigation"
  },
  { name: "log-in", tags: ["sign in", "enter"], category: "navigation" },
  { name: "log-out", tags: ["sign out", "exit"], category: "navigation" },
  // === SOCIAL ===
  { name: "user", tags: ["person", "account", "profile"], category: "social" },
  { name: "user-plus", tags: ["add", "follow"], category: "social" },
  { name: "user-minus", tags: ["remove", "unfollow"], category: "social" },
  { name: "user-check", tags: ["verified", "approved"], category: "social" },
  { name: "user-x", tags: ["delete", "remove"], category: "social" },
  { name: "users", tags: ["people", "team", "group"], category: "social" },
  { name: "user-circle", tags: ["avatar", "profile"], category: "social" },
  { name: "contact", tags: ["person", "card"], category: "social" },
  { name: "heart", tags: ["like", "love", "favorite"], category: "social" },
  { name: "thumbs-up", tags: ["like", "approve"], category: "social" },
  { name: "thumbs-down", tags: ["dislike", "disapprove"], category: "social" },
  { name: "star", tags: ["favorite", "rating"], category: "social" },
  { name: "award", tags: ["achievement", "badge"], category: "social" },
  { name: "trophy", tags: ["winner", "achievement"], category: "social" },
  { name: "medal", tags: ["achievement", "award"], category: "social" },
  { name: "share", tags: ["social", "send"], category: "social" },
  { name: "share-2", tags: ["social", "network"], category: "social" },
  { name: "rss", tags: ["feed", "subscribe"], category: "social" },
  { name: "smile", tags: ["emoji", "happy"], category: "social" },
  { name: "frown", tags: ["emoji", "sad"], category: "social" },
  { name: "meh", tags: ["emoji", "neutral"], category: "social" },
  { name: "laugh", tags: ["emoji", "happy"], category: "social" },
  { name: "angry", tags: ["emoji", "mad"], category: "social" },
  // === SYMBOLS ===
  { name: "check", tags: ["done", "complete", "yes"], category: "symbols" },
  { name: "check-circle", tags: ["done", "success"], category: "symbols" },
  { name: "check-square", tags: ["done", "checkbox"], category: "symbols" },
  { name: "x", tags: ["close", "cancel", "no"], category: "symbols" },
  { name: "x-circle", tags: ["close", "error"], category: "symbols" },
  { name: "x-square", tags: ["close", "cancel"], category: "symbols" },
  { name: "plus", tags: ["add", "new", "create"], category: "symbols" },
  { name: "plus-circle", tags: ["add", "new"], category: "symbols" },
  { name: "plus-square", tags: ["add", "new"], category: "symbols" },
  { name: "minus", tags: ["remove", "subtract"], category: "symbols" },
  { name: "minus-circle", tags: ["remove"], category: "symbols" },
  { name: "minus-square", tags: ["remove"], category: "symbols" },
  { name: "circle", tags: ["shape", "dot"], category: "symbols" },
  { name: "square", tags: ["shape", "box"], category: "symbols" },
  { name: "triangle", tags: ["shape", "warning"], category: "symbols" },
  { name: "octagon", tags: ["stop", "shape"], category: "symbols" },
  { name: "info", tags: ["information", "help"], category: "symbols" },
  { name: "alert-circle", tags: ["warning", "error"], category: "symbols" },
  { name: "alert-triangle", tags: ["warning", "caution"], category: "symbols" },
  { name: "help-circle", tags: ["question", "support"], category: "symbols" },
  { name: "ban", tags: ["block", "forbidden"], category: "symbols" },
  { name: "shield", tags: ["security", "protect"], category: "symbols" },
  { name: "shield-check", tags: ["secure", "verified"], category: "symbols" },
  { name: "lock", tags: ["secure", "private"], category: "symbols" },
  { name: "unlock", tags: ["open", "public"], category: "symbols" },
  { name: "key", tags: ["password", "access"], category: "symbols" },
  { name: "eye", tags: ["view", "visible", "show"], category: "symbols" },
  { name: "eye-off", tags: ["hide", "invisible"], category: "symbols" },
  { name: "zap", tags: ["lightning", "fast", "power"], category: "symbols" },
  { name: "flame", tags: ["fire", "hot", "trending"], category: "symbols" },
  { name: "sparkles", tags: ["magic", "new", "ai"], category: "symbols" },
  { name: "wand", tags: ["magic", "transform"], category: "symbols" },
  { name: "target", tags: ["goal", "aim"], category: "symbols" },
  { name: "clock", tags: ["time", "schedule"], category: "symbols" },
  { name: "timer", tags: ["countdown", "stopwatch"], category: "symbols" },
  {
    name: "calendar",
    tags: ["date", "schedule", "event"],
    category: "symbols"
  },
  { name: "hourglass", tags: ["time", "wait"], category: "symbols" },
  { name: "infinity", tags: ["endless", "loop"], category: "symbols" },
  // === TEXT ===
  { name: "type", tags: ["text", "font"], category: "text" },
  { name: "bold", tags: ["text", "strong"], category: "text" },
  { name: "italic", tags: ["text", "emphasis"], category: "text" },
  { name: "underline", tags: ["text", "format"], category: "text" },
  { name: "strikethrough", tags: ["text", "delete"], category: "text" },
  { name: "align-left", tags: ["text", "paragraph"], category: "text" },
  { name: "align-center", tags: ["text", "paragraph"], category: "text" },
  { name: "align-right", tags: ["text", "paragraph"], category: "text" },
  { name: "align-justify", tags: ["text", "paragraph"], category: "text" },
  { name: "indent", tags: ["text", "tab"], category: "text" },
  { name: "outdent", tags: ["text", "tab"], category: "text" },
  { name: "heading-1", tags: ["text", "h1"], category: "text" },
  { name: "heading-2", tags: ["text", "h2"], category: "text" },
  { name: "heading-3", tags: ["text", "h3"], category: "text" },
  { name: "heading-4", tags: ["text", "h4"], category: "text" },
  { name: "heading-5", tags: ["text", "h5"], category: "text" },
  { name: "heading-6", tags: ["text", "h6"], category: "text" },
  { name: "pilcrow", tags: ["paragraph", "text"], category: "text" },
  { name: "quote", tags: ["blockquote", "cite"], category: "text" },
  { name: "code", tags: ["programming", "syntax"], category: "text" },
  { name: "braces", tags: ["code", "curly"], category: "text" },
  { name: "brackets", tags: ["code", "square"], category: "text" },
  { name: "parentheses", tags: ["code", "round"], category: "text" },
  { name: "terminal", tags: ["code", "command"], category: "text" },
  { name: "pencil", tags: ["edit", "write"], category: "text" },
  { name: "pen", tags: ["edit", "write"], category: "text" },
  { name: "highlighter", tags: ["mark", "highlight"], category: "text" },
  { name: "eraser", tags: ["delete", "remove"], category: "text" },
  { name: "text-cursor", tags: ["input", "caret"], category: "text" },
  { name: "text-cursor-input", tags: ["input", "field"], category: "text" },
  { name: "spell-check", tags: ["grammar", "correct"], category: "text" },
  { name: "languages", tags: ["translate", "i18n"], category: "text" },
  // === WEATHER ===
  { name: "sun", tags: ["day", "bright", "light"], category: "weather" },
  { name: "moon", tags: ["night", "dark"], category: "weather" },
  { name: "cloud", tags: ["weather", "overcast"], category: "weather" },
  { name: "cloud-sun", tags: ["partly cloudy"], category: "weather" },
  { name: "cloud-moon", tags: ["night", "cloudy"], category: "weather" },
  { name: "cloud-rain", tags: ["rain", "weather"], category: "weather" },
  { name: "cloud-drizzle", tags: ["light rain"], category: "weather" },
  { name: "cloud-snow", tags: ["snow", "winter"], category: "weather" },
  { name: "cloud-lightning", tags: ["storm", "thunder"], category: "weather" },
  { name: "cloud-fog", tags: ["mist", "haze"], category: "weather" },
  { name: "snowflake", tags: ["snow", "winter", "cold"], category: "weather" },
  { name: "wind", tags: ["breeze", "air"], category: "weather" },
  { name: "droplet", tags: ["water", "rain"], category: "weather" },
  { name: "droplets", tags: ["water", "humidity"], category: "weather" },
  { name: "thermometer", tags: ["temperature", "heat"], category: "weather" },
  { name: "rainbow", tags: ["weather", "colors"], category: "weather" },
  { name: "umbrella", tags: ["rain", "protection"], category: "weather" },
  { name: "sunrise", tags: ["morning", "dawn"], category: "weather" },
  { name: "sunset", tags: ["evening", "dusk"], category: "weather" }
], Po = (e) => `https://unpkg.com/lucide-static@latest/icons/${e}.svg`, el = (e) => {
  const t = e.toLowerCase().trim();
  return t ? Ge.filter(
    (o) => o.name.toLowerCase().includes(t) || o.tags.some((n) => n.toLowerCase().includes(t)) || o.category.toLowerCase().includes(t)
  ) : Ge;
}, To = (e) => Ge.filter((t) => t.category === e), tl = () => `
  /* Overlay */
  .icon-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: icon-picker-fade-in 0.2s ease;
  }

  @keyframes icon-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .icon-picker-modal {
    background: ${l.white};
    border-radius: 16px;
    width: 90%;
    max-width: 680px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: icon-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes icon-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .icon-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${l.border_glass};
  }

  .icon-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${l.primary};
    margin: 0;
  }

  /* Search */
  .icon-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${l.border_glass};
    position: relative;
  }

  .icon-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${l.gray_medium};
  }

  .icon-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${l.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${l.primary};
    background: ${l.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-search-input:focus {
    border-color: ${l.blue};
    background: ${l.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .icon-picker-search-input::placeholder {
    color: ${l.gray_medium};
  }

  /* Tabs */
  .icon-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${l.border_glass};
  }

  .icon-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${l.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .icon-picker-tab:hover {
    color: ${l.primary};
  }

  .icon-picker-tab.active {
    color: ${l.primary};
  }

  .icon-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${l.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .icon-picker-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .icon-picker-description {
    font-size: 13px;
    color: ${l.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Category Filter */
  .icon-picker-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 24px;
    border-bottom: 1px solid ${l.border_glass};
  }

  .icon-picker-category-btn {
    padding: 6px 14px;
    border: 1px solid ${l.border_glass};
    border-radius: 20px;
    background: ${l.white};
    font-size: 12px;
    font-weight: 500;
    color: ${l.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .icon-picker-category-btn:hover {
    border-color: ${l.blue};
    color: ${l.blue};
  }

  .icon-picker-category-btn.active {
    background: ${l.primary};
    border-color: ${l.primary};
    color: ${l.white};
  }

  /* Icons Container */
  .icon-picker-icons-container {
    padding: 16px 24px;
  }

  .icon-picker-category-section {
    margin-bottom: 24px;
  }

  .icon-picker-category-section:last-child {
    margin-bottom: 0;
  }

  .icon-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${l.gray_medium};
    margin: 0 0 12px 0;
  }

  /* Icons Grid */
  .icon-picker-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
    gap: 8px;
  }

  .icon-picker-icon-item {
    position: relative;
    width: 52px;
    height: 52px;
    border: 1px solid ${l.border_glass};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    background: ${l.white};
  }

  .icon-picker-icon-item:hover {
    border-color: ${l.blue};
    background: rgba(85, 114, 183, 0.04);
    transform: scale(1.05);
  }

  .icon-picker-icon-item.selected {
    border-color: ${l.blue};
    background: rgba(85, 114, 183, 0.08);
    box-shadow: 0 0 0 2px rgba(85, 114, 183, 0.2);
  }

  .icon-picker-icon-preview {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .icon-picker-icon-check {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    background: ${l.blue};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${l.white};
  }

  .icon-picker-empty {
    text-align: center;
    padding: 48px 24px;
    color: ${l.gray_medium};
  }

  /* Selected Icon Info */
  .icon-picker-selected-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background: ${l.bg_light};
    border-top: 1px solid ${l.border_glass};
  }

  .icon-picker-selected-preview {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .icon-picker-selected-name {
    font-size: 14px;
    font-weight: 500;
    color: ${l.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  /* Upload Tab */
  .icon-picker-upload {
    padding: 16px 24px;
  }

  .icon-picker-upload-zone {
    border: 2px dashed ${l.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .icon-picker-upload-zone:hover {
    border-color: ${l.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .icon-picker-upload-icon {
    color: ${l.gray_medium};
  }

  .icon-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${l.primary};
  }

  .icon-picker-upload-hint {
    font-size: 12px;
    color: ${l.gray_medium};
  }

  .icon-picker-upload-preview {
    margin-top: 16px;
  }

  .icon-picker-upload-file {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: ${l.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .icon-picker-svg-preview {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-picker-svg-preview svg {
    max-width: 100%;
    max-height: 100%;
  }

  .icon-picker-upload-file-info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .icon-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${l.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .icon-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .icon-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${l.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .icon-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${l.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${l.primary};
    background: ${l.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-upload-input:focus {
    border-color: ${l.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .icon-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${l.border_glass};
    background: ${l.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, Mo = ({
  isOpen: e,
  onClose: t,
  onSelect: o,
  isLoading: n = !1
}) => {
  const [i, a] = N("lucide"), [s, m] = N(""), [p, h] = N(null), [d, g] = N("all"), [f, w] = N(null), [C, b] = N(""), [y, k] = N(null), P = ie(null);
  J(() => {
    e && (m(""), h(null), g("all"), w(null), b(""), k(null));
  }, [e]);
  const x = le(() => {
    let E;
    return s ? E = el(s) : d === "all" ? E = Ge : E = To(d), E;
  }, [s, d]), M = le(() => {
    if (s || d !== "all")
      return {
        [d === "all" ? "results" : d]: x
      };
    const E = {};
    return zo.forEach((O) => {
      E[O] = To(O);
    }), E;
  }, [x, s, d]), v = (E) => {
    h({
      type: "lucide",
      name: E.name,
      url: Po(E.name)
    });
  }, R = async (E) => {
    var F;
    const O = (F = E.target.files) == null ? void 0 : F[0];
    if (O) {
      w(O);
      const L = O.name.replace(/\.[^/.]+$/, "");
      b(L);
      const Y = new FileReader();
      Y.onload = (j) => {
        var A;
        const B = (A = j.target) == null ? void 0 : A.result;
        k(B);
      }, Y.readAsText(O), h({
        type: "upload",
        name: L,
        file: O
      });
    }
  }, W = (E) => {
    b(E), (p == null ? void 0 : p.type) === "upload" && f && h({
      ...p,
      name: E
    });
  }, S = () => {
    p && (o(p), t());
  }, H = n || !p || p.type === "upload" && (!f || !C.trim());
  if (!e) return null;
  const D = /* @__PURE__ */ u(G, { children: [
    /* @__PURE__ */ r("style", { children: tl() }),
    /* @__PURE__ */ r("div", { className: "icon-picker-overlay", onClick: t, children: /* @__PURE__ */ u("div", { className: "icon-picker-modal", onClick: (E) => E.stopPropagation(), children: [
      /* @__PURE__ */ u("div", { className: "icon-picker-header", children: [
        /* @__PURE__ */ r("h2", { className: "icon-picker-title", children: "Select icon" }),
        /* @__PURE__ */ r(
          _,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ r(xe, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-search", children: [
        /* @__PURE__ */ r(Lo, { size: 16, className: "icon-picker-search-icon" }),
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            placeholder: "Search icons...",
            value: s,
            onChange: (E) => m(E.target.value),
            className: "icon-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-tabs", children: [
        /* @__PURE__ */ r(
          "button",
          {
            className: `icon-picker-tab ${i === "lucide" ? "active" : ""}`,
            onClick: () => a("lucide"),
            children: "Lucide Icons"
          }
        ),
        /* @__PURE__ */ r(
          "button",
          {
            className: `icon-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => a("upload"),
            children: "Upload SVG"
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-content", children: [
        i === "lucide" && /* @__PURE__ */ u(G, { children: [
          /* @__PURE__ */ u("div", { className: "icon-picker-categories", children: [
            /* @__PURE__ */ r(
              "button",
              {
                className: `icon-picker-category-btn ${d === "all" ? "active" : ""}`,
                onClick: () => g("all"),
                children: "All"
              }
            ),
            zo.map((E) => /* @__PURE__ */ r(
              "button",
              {
                className: `icon-picker-category-btn ${d === E ? "active" : ""}`,
                onClick: () => g(E),
                children: E.charAt(0).toUpperCase() + E.slice(1)
              },
              E
            ))
          ] }),
          /* @__PURE__ */ u("div", { className: "icon-picker-icons-container", children: [
            Object.entries(M).map(([E, O]) => /* @__PURE__ */ u(
              "div",
              {
                className: "icon-picker-category-section",
                children: [
                  !s && d === "all" && /* @__PURE__ */ r("h4", { className: "icon-picker-category-title", children: E.charAt(0).toUpperCase() + E.slice(1) }),
                  /* @__PURE__ */ r("div", { className: "icon-picker-grid", children: O.map((F) => /* @__PURE__ */ u(
                    "div",
                    {
                      className: `icon-picker-icon-item ${(p == null ? void 0 : p.type) === "lucide" && (p == null ? void 0 : p.name) === F.name ? "selected" : ""}`,
                      onClick: () => v(F),
                      title: F.name,
                      children: [
                        /* @__PURE__ */ r(
                          "img",
                          {
                            src: Po(F.name),
                            alt: F.name,
                            className: "icon-picker-icon-preview"
                          }
                        ),
                        (p == null ? void 0 : p.type) === "lucide" && (p == null ? void 0 : p.name) === F.name && /* @__PURE__ */ r("div", { className: "icon-picker-icon-check", children: /* @__PURE__ */ r(Fe, { size: 12 }) })
                      ]
                    },
                    F.name
                  )) })
                ]
              },
              E
            )),
            x.length === 0 && /* @__PURE__ */ r("div", { className: "icon-picker-empty", children: /* @__PURE__ */ u("p", { children: [
              'No icons found for "',
              s,
              '"'
            ] }) })
          ] }),
          (p == null ? void 0 : p.type) === "lucide" && /* @__PURE__ */ u("div", { className: "icon-picker-selected-info", children: [
            /* @__PURE__ */ r(
              "img",
              {
                src: p.url,
                alt: p.name,
                className: "icon-picker-selected-preview"
              }
            ),
            /* @__PURE__ */ r("span", { className: "icon-picker-selected-name", children: p.name })
          ] })
        ] }),
        i === "upload" && /* @__PURE__ */ u("div", { className: "icon-picker-upload", children: [
          /* @__PURE__ */ r("p", { className: "icon-picker-description", children: "Upload your own SVG icon file." }),
          /* @__PURE__ */ r(
            "input",
            {
              ref: P,
              type: "file",
              accept: ".svg",
              onChange: R,
              style: { display: "none" }
            }
          ),
          f ? /* @__PURE__ */ u("div", { className: "icon-picker-upload-preview", children: [
            /* @__PURE__ */ u("div", { className: "icon-picker-upload-file", children: [
              y && /* @__PURE__ */ r(
                "div",
                {
                  className: "icon-picker-svg-preview",
                  dangerouslySetInnerHTML: { __html: y }
                }
              ),
              /* @__PURE__ */ u("div", { className: "icon-picker-upload-file-info", children: [
                /* @__PURE__ */ r("span", { className: "icon-picker-upload-filename", children: f.name }),
                /* @__PURE__ */ r(
                  _,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: () => {
                      var E;
                      return (E = P.current) == null ? void 0 : E.click();
                    },
                    children: "Change"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ u("div", { className: "icon-picker-upload-name", children: [
              /* @__PURE__ */ r("label", { className: "icon-picker-upload-label", children: "Icon name" }),
              /* @__PURE__ */ r(
                "input",
                {
                  type: "text",
                  value: C,
                  onChange: (E) => W(E.target.value),
                  placeholder: "Enter icon name",
                  className: "icon-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u(
            "div",
            {
              className: "icon-picker-upload-zone",
              onClick: () => {
                var E;
                return (E = P.current) == null ? void 0 : E.click();
              },
              children: [
                /* @__PURE__ */ r(No, { size: 32, className: "icon-picker-upload-icon" }),
                /* @__PURE__ */ r("span", { className: "icon-picker-upload-text", children: "Click to upload SVG file" }),
                /* @__PURE__ */ r("span", { className: "icon-picker-upload-hint", children: "SVG only" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-footer", children: [
        /* @__PURE__ */ r(_, { variant: "outline", onClick: t, disabled: n, children: "Cancel" }),
        /* @__PURE__ */ r(
          _,
          {
            variant: "primary",
            onClick: S,
            disabled: H,
            children: n ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return fe.createPortal(D, Ye());
}, _l = () => {
  const e = Pe(), t = Do(), [o, n] = N("checking"), [i, a] = N("desktop"), s = ie(null), [m, p] = N(!1), { data: h } = Te(), d = (h == null ? void 0 : h.themeName) || e.themeId, { themeColors: g, refreshThemeColors: f } = gt(), { themeFonts: w, refreshThemeFonts: C } = tr(), { themeIcons: b, refreshThemeIcons: y } = or(), [k, P] = N(null), [x, M] = N(!1), [v, R] = N(!1), W = (L) => {
    P((Y) => Y === L ? null : L);
  }, S = Ka({
    themeId: e.themeId,
    editThemeToken: e.editThemeToken,
    iframeRef: o === "iframe" ? s : null,
    refreshThemeColors: f,
    refreshThemeFonts: C,
    refreshThemeIcons: y
  });
  J(() => {
    t || Pn();
  }, [t]), J(() => {
    if (t || !e.themeId) return;
    (async () => {
      const Y = await Kr();
      n(Y ? "iframe" : "inline");
    })();
  }, [t, e.themeId]);
  const H = pe(() => {
    var L;
    if (s.current)
      try {
        const Y = new URL(
          ((L = s.current.contentWindow) == null ? void 0 : L.location.href) || ""
        ), j = new URL(window.location.href);
        j.pathname = Y.pathname;
        const B = new URLSearchParams(Y.search), A = new URLSearchParams();
        e.themeId && A.set("themeId", e.themeId), e.editMode && A.set("editMode", "true"), e.editThemeToken && A.set("editThemeToken", e.editThemeToken), B.forEach((I, $) => {
          $ !== "frameMode" && $ !== "themeId" && $ !== "editMode" && $ !== "editThemeToken" && A.set($, I);
        }), j.search = A.toString(), window.history.replaceState({}, "", j.toString());
      } catch (Y) {
        console.debug("Could not access iframe URL (cross-origin):", Y);
      }
  }, [e]);
  if (!e.themeId || t)
    return null;
  if (o === "checking")
    return /* @__PURE__ */ u(
      "div",
      {
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          background: "#f5f5f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          zIndex: 999999,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: 14,
          color: "#666"
        },
        children: [
          /* @__PURE__ */ r(Mr, { size: 16, className: "bc-theme-editor-spinner" }),
          /* @__PURE__ */ r("span", { children: "Initializing Theme Editor..." }),
          /* @__PURE__ */ r("style", { children: `
          @keyframes bc-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .bc-theme-editor-spinner {
            animation: bc-spin 1s linear infinite;
          }
        ` })
        ]
      }
    );
  const D = () => {
    zn(), Tn();
    const L = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
    window.location.href = L;
  }, E = () => {
    p(!m);
  }, O = async (L) => {
    await S.handleAddFont(L);
  }, F = async (L) => {
    await S.handleAddIcon(L);
  };
  return o === "inline" ? /* @__PURE__ */ u(G, { children: [
    /* @__PURE__ */ r("style", { children: ko({ showSettings: m, viewMode: i, editorMode: o }) }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ u("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ r("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ r(bt, { size: 18 }) }),
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-theme-id", children: d }),
          (h == null ? void 0 : h.isPublished) && /* @__PURE__ */ u("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ r("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ r("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ r(
            _,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ r(Je, { size: 14 }),
              onClick: E,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ r(
            _,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ r(yt, { size: 14 }),
              onClick: D,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      m && /* @__PURE__ */ u(
        wo,
        {
          onClose: () => p(!1),
          successMessage: S.successMessage,
          error: S.error,
          children: [
            /* @__PURE__ */ r(
              zt,
              {
                themeColors: g,
                isExpanded: k === "colors",
                onToggle: () => W("colors"),
                isLoading: S.isLoading,
                isAddingColor: S.isAddingColor,
                setIsAddingColor: S.setIsAddingColor,
                newColorKey: S.newColorKey,
                setNewColorKey: S.setNewColorKey,
                newColorValue: S.newColorValue,
                setNewColorValue: S.setNewColorValue,
                onAddColor: S.handleAddColor,
                onUpdateColor: S.handleUpdateColor,
                onRenameColor: S.handleRenameColor,
                onDeleteColor: S.handleDeleteColor
              }
            ),
            /* @__PURE__ */ r(
              So,
              {
                themeFonts: w,
                isExpanded: k === "fonts",
                onToggle: () => W("fonts"),
                isLoading: S.isLoading,
                onDeleteFont: S.handleDeleteFont,
                onOpenFontPicker: () => M(!0)
              }
            ),
            /* @__PURE__ */ r(
              Bo,
              {
                themeIcons: b,
                isExpanded: k === "icons",
                onToggle: () => W("icons"),
                isLoading: S.isLoading,
                onDeleteIcon: S.handleDeleteIcon,
                onOpenIconPicker: () => R(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ r(
        Io,
        {
          isOpen: x,
          onClose: () => M(!1),
          onSelect: O,
          isLoading: S.isLoading
        }
      ),
      /* @__PURE__ */ r(
        Mo,
        {
          isOpen: v,
          onClose: () => R(!1),
          onSelect: F,
          isLoading: S.isLoading
        }
      ),
      S.pendingDelete && /* @__PURE__ */ r(
        Ie,
        {
          title: `Delete ${S.pendingDelete.type}`,
          message: `Are you sure you want to delete "${S.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: S.confirmDelete,
          onCancel: S.cancelDelete,
          isLoading: S.isLoading
        }
      )
    ] })
  ] }) : /* @__PURE__ */ u(G, { children: [
    /* @__PURE__ */ r("style", { children: ko({ showSettings: m, viewMode: i, editorMode: o }) }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ u("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ r("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ r(bt, { size: 18 }) }),
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ r("span", { className: "bc-theme-editor-theme-id", children: d }),
          (h == null ? void 0 : h.isPublished) && /* @__PURE__ */ u("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ r("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-viewport-toggle", children: [
          /* @__PURE__ */ r(
            _,
            {
              variant: i === "desktop" ? "primary" : "icon",
              size: "sm",
              onClick: () => a("desktop"),
              "aria-label": "Desktop view",
              children: /* @__PURE__ */ r(Wo, { size: 16 })
            }
          ),
          /* @__PURE__ */ r(
            _,
            {
              variant: i === "mobile" ? "primary" : "icon",
              size: "sm",
              onClick: () => a("mobile"),
              "aria-label": "Mobile view",
              children: /* @__PURE__ */ r(Ho, { size: 16 })
            }
          )
        ] }),
        /* @__PURE__ */ r("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ r(
            _,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ r(Je, { size: 14 }),
              onClick: E,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ r(
            _,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ r(yt, { size: 14 }),
              onClick: D,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ r("div", { className: "bc-theme-editor-preview", children: /* @__PURE__ */ r("div", { className: "bc-theme-editor-preview-container", children: /* @__PURE__ */ r("div", { className: "bc-theme-editor-iframe-wrapper", children: /* @__PURE__ */ r(
        "iframe",
        {
          ref: s,
          className: "bc-theme-editor-iframe",
          src: window.location.href,
          onLoad: H,
          title: "Theme Preview"
        }
      ) }) }) }),
      m && /* @__PURE__ */ u(
        wo,
        {
          onClose: () => p(!1),
          successMessage: S.successMessage,
          error: S.error,
          children: [
            /* @__PURE__ */ r(
              zt,
              {
                themeColors: g,
                isExpanded: k === "colors",
                onToggle: () => W("colors"),
                isLoading: S.isLoading,
                isAddingColor: S.isAddingColor,
                setIsAddingColor: S.setIsAddingColor,
                newColorKey: S.newColorKey,
                setNewColorKey: S.setNewColorKey,
                newColorValue: S.newColorValue,
                setNewColorValue: S.setNewColorValue,
                onAddColor: S.handleAddColor,
                onUpdateColor: S.handleUpdateColor,
                onRenameColor: S.handleRenameColor,
                onDeleteColor: S.handleDeleteColor
              }
            ),
            /* @__PURE__ */ r(
              So,
              {
                themeFonts: w,
                isExpanded: k === "fonts",
                onToggle: () => W("fonts"),
                isLoading: S.isLoading,
                onDeleteFont: S.handleDeleteFont,
                onOpenFontPicker: () => M(!0)
              }
            ),
            /* @__PURE__ */ r(
              Bo,
              {
                themeIcons: b,
                isExpanded: k === "icons",
                onToggle: () => W("icons"),
                isLoading: S.isLoading,
                onDeleteIcon: S.handleDeleteIcon,
                onOpenIconPicker: () => R(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ r(
        Io,
        {
          isOpen: x,
          onClose: () => M(!1),
          onSelect: O,
          isLoading: S.isLoading
        }
      ),
      /* @__PURE__ */ r(
        Mo,
        {
          isOpen: v,
          onClose: () => R(!1),
          onSelect: F,
          isLoading: S.isLoading
        }
      ),
      S.pendingDelete && /* @__PURE__ */ r(
        Ie,
        {
          title: `Delete ${S.pendingDelete.type}`,
          message: `Are you sure you want to delete "${S.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: S.confirmDelete,
          onCancel: S.cancelDelete,
          isLoading: S.isLoading
        }
      )
    ] })
  ] });
};
export {
  _ as Button,
  jl as BuyBoxWidget,
  Ml as ChainOfThoughtWidget,
  hl as ChatInput,
  vl as ConciergeHeaderWidget,
  Rl as ConciergeHomeBrandLabelWidget,
  Ll as ConciergeHomeGreetingWidget,
  Al as ConciergeHomeLayoutWidget,
  Wl as ConciergeHomeLogoWidget,
  Dl as ConciergeHomeMobileNavWidget,
  Nl as ConciergeHomeStartersWidget,
  Hl as ConciergeHomeSubtitleWidget,
  Pl as ConciergePanelWidget,
  wl as ConciergeSidebarWidget,
  xl as ConversationStartersWidget,
  Ql as DailyDealsWidget,
  bl as ELEMENT_GROUPS,
  Qo as EditPanel,
  Gl as FeaturedProductWidget,
  Sl as FloatingButtonWidget,
  Cl as FollowUpQueriesWidget,
  kl as HeaderWidget,
  Gi as LAYOUT_PRESETS,
  El as LoginWallWidget,
  yl as MessageBubbleWidget,
  Yi as PRESET_LABELS,
  Ol as ProductCardCarouselWidget,
  Ul as ProductComparisonWidget,
  $l as PurchaseHistoryWidget,
  Kl as RetailerIconWidget,
  Zl as RewardOpportunitiesWidget,
  ql as RewardPillWidget,
  Il as SearchQueryPillWidget,
  Yl as StoreLocatorWidget,
  zl as SuggestionListWidget,
  Jl as SurveyCard,
  Xl as SurveysWidget,
  Vl as TextBox,
  _l as ThemeManager,
  Fl as TrendingCardWidget,
  fl as TypingIndicatorWidget,
  Tl as VariantPickerWidget,
  De as WIDGET_THEME_QUERY_KEY,
  Bl as WelcomeScreenWidget,
  Mn as WidgetEditSuppressProvider,
  K as WidgetWrapper,
  dl as calculateRewardPercent,
  zn as clearThemeParams,
  Tn as clearUrlParams,
  l as colors,
  c as customColor,
  Oi as defaultLoginWallState,
  ll as formatDate,
  al as formatMoney,
  sl as formatRelativeTime,
  pl as getFontWeightValue,
  In as getThemeParams,
  Cn as isColorValue,
  Fn as saveThemeParams,
  cl as slugify,
  Pn as syncUrlToStorage,
  T as themeColor,
  gl as truncateText,
  ml as updateUrlParams,
  Xo as useEditMode,
  ul as useResolveColor,
  gt as useThemeColors,
  tr as useThemeFonts,
  or as useThemeIcons,
  Zn as useWidgetConfig,
  tt as useWidgetEdit,
  En as useWidgetEditSuppressed,
  V as useWidgetEditable,
  Te as useWidgetTheme,
  Pe as useWidgetThemeParams
};
//# sourceMappingURL=index.js.map
